(() => {
  var t = {
    65: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(914)]),
          (s = function (t, e) {
            return o(r, t, e);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        i.createMethods.push('_createLazyload');
        var s = i.prototype;
        s._createLazyload = function () {
          this.on('select', this.lazyLoad);
        };
        s.lazyLoad = function () {
          var t = this.options.lazyLoad;
          if (!t) return;
          var e = typeof t == 'number' ? t : 0;
          var i = this.getAdjacentCellElements(e);
          var n = [];
          i.forEach(function (t) {
            var e = r(t);
            n = n.concat(e);
          });
          n.forEach(function (t) {
            new o(t, this);
          }, this);
        };
        function r(t) {
          if (t.nodeName == 'IMG') {
            var e = t.getAttribute('data-flickity-lazyload');
            var i = t.getAttribute('data-flickity-lazyload-src');
            var s = t.getAttribute('data-flickity-lazyload-srcset');
            if (e || i || s) return [t];
          }
          var r =
            'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
          var o = t.querySelectorAll(r);
          return n.makeArray(o);
        }
        function o(t, e) {
          this.img = t;
          this.flickity = e;
          this.load();
        }
        o.prototype.handleEvent = n.handleEvent;
        o.prototype.load = function () {
          this.img.addEventListener('load', this);
          this.img.addEventListener('error', this);
          var t =
            this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
          var e = this.img.getAttribute('data-flickity-lazyload-srcset');
          this.img.src = t;
          if (e) this.img.setAttribute('srcset', e);
          this.img.removeAttribute('data-flickity-lazyload');
          this.img.removeAttribute('data-flickity-lazyload-src');
          this.img.removeAttribute('data-flickity-lazyload-srcset');
        };
        o.prototype.onload = function (t) {
          this.complete(t, 'flickity-lazyloaded');
        };
        o.prototype.onerror = function (t) {
          this.complete(t, 'flickity-lazyerror');
        };
        o.prototype.complete = function (t, e) {
          this.img.removeEventListener('load', this);
          this.img.removeEventListener('error', this);
          var i = this.flickity.getParentCell(this.img);
          var n = i && i.element;
          this.flickity.cellSizeChange(n);
          this.img.classList.add(e);
          this.flickity.dispatchEvent('lazyLoad', t, n);
        };
        i.LazyLoader = o;
        return i;
      });
    },
    136: function (t, e, i) {
      var n, s;
      (function (r, o) {
        if (true) !((n = o), (s = typeof n === 'function' ? n.call(e, i, e, t) : n), s !== void 0 && (t.exports = s));
      })(typeof window != 'undefined' ? window : this, function () {
        'use strict';
        function t() {}
        var e = t.prototype;
        e.on = function (t, e) {
          if (!t || !e) return;
          var i = (this._events = this._events || {});
          var n = (i[t] = i[t] || []);
          if (n.indexOf(e) == -1) n.push(e);
          return this;
        };
        e.once = function (t, e) {
          if (!t || !e) return;
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {});
          var n = (i[t] = i[t] || {});
          n[e] = true;
          return this;
        };
        e.off = function (t, e) {
          var i = this._events && this._events[t];
          if (!i || !i.length) return;
          var n = i.indexOf(e);
          if (n != -1) i.splice(n, 1);
          return this;
        };
        e.emitEvent = function (t, e) {
          var i = this._events && this._events[t];
          if (!i || !i.length) return;
          i = i.slice(0);
          e = e || [];
          var n = this._onceEvents && this._onceEvents[t];
          for (var s = 0; s < i.length; s++) {
            var r = i[s];
            var o = n && n[r];
            if (o) {
              this.off(t, r);
              delete n[r];
            }
            r.apply(this, e);
          }
          return this;
        };
        e.allOff = function () {
          delete this._events;
          delete this._onceEvents;
        };
        return t;
      });
    },
    229: (t, e, i) => {
      var n, s;
      (function (r, o) {
        'use strict';
        if (true) !((n = o), (s = typeof n === 'function' ? n.call(e, i, e, t) : n), s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        var e = (function () {
          var t = window.Element.prototype;
          if (t.matches) return 'matches';
          if (t.matchesSelector) return 'matchesSelector';
          var e = ['webkit', 'moz', 'ms', 'o'];
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            var s = n + 'MatchesSelector';
            if (t[s]) return s;
          }
        })();
        return function t(i, n) {
          return i[e](n);
        };
      });
    },
    236: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(878)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n() {}
        var s = (n.prototype = Object.create(i.prototype));
        s.bindHandles = function () {
          this._bindHandles(true);
        };
        s.unbindHandles = function () {
          this._bindHandles(false);
        };
        s._bindHandles = function (t) {
          t = t === void 0 ? true : t;
          var i = t ? 'addEventListener' : 'removeEventListener';
          var n = t ? this._touchActionValue : '';
          for (var s = 0; s < this.handles.length; s++) {
            var r = this.handles[s];
            this._bindStartEvent(r, t);
            r[i]('click', this);
            if (e.PointerEvent) r.style.touchAction = n;
          }
        };
        s._touchActionValue = 'none';
        s.pointerDown = function (t, e) {
          var i = this.okayPointerDown(t);
          if (!i) return;
          this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
          t.preventDefault();
          this.pointerDownBlur();
          this._bindPostStartEvents(t);
          this.emitEvent('pointerDown', [t, e]);
        };
        var r = { TEXTAREA: true, INPUT: true, SELECT: true, OPTION: true };
        var o = {
          radio: true,
          checkbox: true,
          button: true,
          submit: true,
          image: true,
          file: true,
        };
        s.okayPointerDown = function (t) {
          var e = r[t.target.nodeName];
          var i = o[t.target.type];
          var n = !e || i;
          if (!n) this._pointerReset();
          return n;
        };
        s.pointerDownBlur = function () {
          var t = document.activeElement;
          var e = t && t.blur && t != document.body;
          if (e) t.blur();
        };
        s.pointerMove = function (t, e) {
          var i = this._dragPointerMove(t, e);
          this.emitEvent('pointerMove', [t, e, i]);
          this._dragMove(t, e, i);
        };
        s._dragPointerMove = function (t, e) {
          var i = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY,
          };
          if (!this.isDragging && this.hasDragStarted(i)) this._dragStart(t, e);
          return i;
        };
        s.hasDragStarted = function (t) {
          return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
        };
        s.pointerUp = function (t, e) {
          this.emitEvent('pointerUp', [t, e]);
          this._dragPointerUp(t, e);
        };
        s._dragPointerUp = function (t, e) {
          if (this.isDragging) this._dragEnd(t, e);
          else this._staticClick(t, e);
        };
        s._dragStart = function (t, e) {
          this.isDragging = true;
          this.isPreventingClicks = true;
          this.dragStart(t, e);
        };
        s.dragStart = function (t, e) {
          this.emitEvent('dragStart', [t, e]);
        };
        s._dragMove = function (t, e, i) {
          if (!this.isDragging) return;
          this.dragMove(t, e, i);
        };
        s.dragMove = function (t, e, i) {
          t.preventDefault();
          this.emitEvent('dragMove', [t, e, i]);
        };
        s._dragEnd = function (t, e) {
          this.isDragging = false;
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          );
          this.dragEnd(t, e);
        };
        s.dragEnd = function (t, e) {
          this.emitEvent('dragEnd', [t, e]);
        };
        s.onclick = function (t) {
          if (this.isPreventingClicks) t.preventDefault();
        };
        s._staticClick = function (t, e) {
          if (this.isIgnoringMouseUp && t.type == 'mouseup') return;
          this.staticClick(t, e);
          if (t.type != 'mouseup') {
            this.isIgnoringMouseUp = true;
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            );
          }
        };
        s.staticClick = function (t, e) {
          this.emitEvent('staticClick', [t, e]);
        };
        n.getPointerPoint = i.getPointerPoint;
        return n;
      });
    },
    338: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true) !((n = o), (s = typeof n === 'function' ? n.call(e, i, e, t) : n), s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        function e(t) {
          this.parent = t;
          this.isOriginLeft = t.originSide == 'left';
          this.cells = [];
          this.outerWidth = 0;
          this.height = 0;
        }
        var i = e.prototype;
        i.addCell = function (t) {
          this.cells.push(t);
          this.outerWidth += t.size.outerWidth;
          this.height = Math.max(t.size.outerHeight, this.height);
          if (this.cells.length == 1) {
            this.x = t.x;
            var e = this.isOriginLeft ? 'marginLeft' : 'marginRight';
            this.firstMargin = t.size[e];
          }
        };
        i.updateTarget = function () {
          var t = this.isOriginLeft ? 'marginRight' : 'marginLeft';
          var e = this.getLastCell();
          var i = e ? e.size[t] : 0;
          var n = this.outerWidth - (this.firstMargin + i);
          this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
        };
        i.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };
        i.select = function () {
          this.cells.forEach(function (t) {
            t.select();
          });
        };
        i.unselect = function () {
          this.cells.forEach(function (t) {
            t.unselect();
          });
        };
        i.getCellElements = function () {
          return this.cells.map(function (t) {
            return t.element;
          });
        };
        return e;
      });
    },
    359: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(784)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n(t, e) {
          this.element = t;
          this.parent = e;
          this.create();
        }
        var s = n.prototype;
        s.create = function () {
          this.element.style.position = 'absolute';
          this.element.setAttribute('aria-hidden', 'true');
          this.x = 0;
          this.shift = 0;
          this.element.style[this.parent.originSide] = 0;
        };
        s.destroy = function () {
          this.unselect();
          this.element.style.position = '';
          var t = this.parent.originSide;
          this.element.style[t] = '';
          this.element.style.transform = '';
          this.element.removeAttribute('aria-hidden');
        };
        s.getSize = function () {
          this.size = i(this.element);
        };
        s.setPosition = function (t) {
          this.x = t;
          this.updateTarget();
          this.renderPosition(t);
        };
        s.updateTarget = s.setDefaultTarget = function () {
          var t = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
          this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
        };
        s.renderPosition = function (t) {
          var e = this.parent.originSide === 'left' ? 1 : -1;
          var i = this.parent.options.percentPosition ? t * e * (this.parent.size.innerWidth / this.size.width) : t * e;
          this.element.style.transform = 'translateX(' + this.parent.getPositionValue(i) + ')';
        };
        s.select = function () {
          this.element.classList.add('is-selected');
          this.element.removeAttribute('aria-hidden');
        };
        s.unselect = function () {
          this.element.classList.remove('is-selected');
          this.element.setAttribute('aria-hidden', 'true');
        };
        s.wrapShift = function (t) {
          this.shift = t;
          this.renderPosition(this.x + this.parent.slideableWidth * t);
        };
        s.remove = function () {
          this.element.parentNode.removeChild(this.element);
        };
        return n;
      });
    },
    488: (t, e, i) => {
      var n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(window, function t(e, i) {
        'use strict';
        e.createMethods.push('_createAsNavFor');
        var n = e.prototype;
        n._createAsNavFor = function () {
          this.on('activate', this.activateAsNavFor);
          this.on('deactivate', this.deactivateAsNavFor);
          this.on('destroy', this.destroyAsNavFor);
          var t = this.options.asNavFor;
          if (!t) return;
          var e = this;
          setTimeout(function i() {
            e.setNavCompanion(t);
          });
        };
        n.setNavCompanion = function (t) {
          t = i.getQueryElement(t);
          var n = e.data(t);
          if (!n || n == this) return;
          this.navCompanion = n;
          var s = this;
          this.onNavCompanionSelect = function () {
            s.navCompanionSelect();
          };
          n.on('select', this.onNavCompanionSelect);
          this.on('staticClick', this.onNavStaticClick);
          this.navCompanionSelect(true);
        };
        n.navCompanionSelect = function (t) {
          if (!this.navCompanion) return;
          var e = this.navCompanion.selectedCells[0];
          var i = this.navCompanion.cells.indexOf(e);
          var n = i + this.navCompanion.selectedCells.length - 1;
          var r = Math.floor(s(i, n, this.navCompanion.cellAlign));
          this.selectCell(r, false, t);
          this.removeNavSelectedElements();
          if (r >= this.cells.length) return;
          var o = this.cells.slice(i, n + 1);
          this.navSelectedElements = o.map(function (t) {
            return t.element;
          });
          this.changeNavSelectedClass('add');
        };
        function s(t, e, i) {
          return (e - t) * i + t;
        }
        n.changeNavSelectedClass = function (t) {
          this.navSelectedElements.forEach(function (e) {
            e.classList[t]('is-nav-selected');
          });
        };
        n.activateAsNavFor = function () {
          this.navCompanionSelect(true);
        };
        n.removeNavSelectedElements = function () {
          if (!this.navSelectedElements) return;
          this.changeNavSelectedClass('remove');
          delete this.navSelectedElements;
        };
        n.onNavStaticClick = function (t, e, i, n) {
          if (typeof n == 'number') this.navCompanion.selectCell(n);
        };
        n.deactivateAsNavFor = function () {
          this.removeNavSelectedElements();
        };
        n.destroyAsNavFor = function () {
          if (!this.navCompanion) return;
          this.navCompanion.off('select', this.onNavCompanionSelect);
          this.off('staticClick', this.onNavStaticClick);
          delete this.navCompanion;
        };
        return e;
      });
    },
    501: () => {
      __loadjs = (function () {
        var t = function () {},
          e = {},
          i = {},
          n = {};
        function s(t, e) {
          if (t) {
            var s = n[t];
            if (((i[t] = e), s)) for (; s.length; ) s[0](t, e), s.splice(0, 1);
          }
        }
        function r(e, i) {
          e.call && (e = { success: e }), i.length ? (e.error || t)(i) : (e.success || t)(e);
        }
        function o(e, i, n, s) {
          var r,
            a,
            l = document,
            h = n.async,
            c = (n.numRetries || 0) + 1,
            d = n.before || t,
            u = e.replace(/[\?|#].*$/, ''),
            p = e.replace(/^(css|img)!/, '');
          (s = s || 0),
            /(^css!|\.css$)/.test(u)
              ? (((a = l.createElement('link')).rel = 'stylesheet'),
                (a.href = p),
                (r = 'hideFocus' in a) && a.relList && ((r = 0), (a.rel = 'preload'), (a.as = 'style')))
              : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(u)
              ? ((a = l.createElement('img')).src = p)
              : (((a = l.createElement('script')).src = e), (a.async = void 0 === h || h)),
            !(a.onload =
              a.onerror =
              a.onbeforeload =
                function (t) {
                  var l = t.type[0];
                  if (r)
                    try {
                      a.sheet.cssText.length || (l = 'e');
                    } catch (t) {
                      18 != t.code && (l = 'e');
                    }
                  if ('e' == l) {
                    if ((s += 1) < c) return o(e, i, n, s);
                  } else if ('preload' == a.rel && 'style' == a.as) return (a.rel = 'stylesheet');
                  i(e, l, t.defaultPrevented);
                }) !== d(e, a) && l.head.appendChild(a);
        }
        function a(t, i, n) {
          var a, l;
          if ((i && i.trim && (a = i), (l = (a ? n : i) || {}), a)) {
            if (a in e) throw 'LoadJS';
            e[a] = !0;
          }
          function h(e, i) {
            !(function (t, e, i) {
              var n,
                s,
                r = (t = t.push ? t : [t]).length,
                a = r,
                l = [];
              for (
                n = function (t, i, n) {
                  if (('e' == i && l.push(t), 'b' == i)) {
                    if (!n) return;
                    l.push(t);
                  }
                  --r || e(l);
                },
                  s = 0;
                s < a;
                s++
              )
                o(t[s], n, i);
            })(
              t,
              function (t) {
                r(l, t), e && r({ success: e, error: i }, t), s(a, t);
              },
              l
            );
          }
          if (l.returnPromise) return new Promise(h);
          h();
        }
        return (
          (a.ready = function (t, e) {
            return (
              (function (t, e) {
                t = t.push ? t : [t];
                var s,
                  r,
                  o,
                  a = [],
                  l = t.length,
                  h = l;
                for (
                  s = function (t, i) {
                    i.length && a.push(t), --h || e(a);
                  };
                  l--;

                )
                  (r = t[l]), (o = i[r]) ? s(r, o) : (n[r] = n[r] || []).push(s);
              })(t, function (t) {
                r(e, t);
              }),
              a
            );
          }),
          (a.done = function (t) {
            s(t, []);
          }),
          (a.reset = function () {
            (e = {}), (i = {}), (n = {});
          }),
          (a.isDefined = function (t) {
            return t in e;
          }),
          a
        );
      })();
    },
    515: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(878), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        var r = 'http://www.w3.org/2000/svg';
        function o(t, e) {
          this.direction = t;
          this.parent = e;
          this._create();
        }
        o.prototype = Object.create(n.prototype);
        o.prototype._create = function () {
          this.isEnabled = true;
          this.isPrevious = this.direction == -1;
          var t = this.parent.options.rightToLeft ? 1 : -1;
          this.isLeft = this.direction == t;
          var e = (this.element = document.createElement('button'));
          e.className = 'flickity-button flickity-prev-next-button';
          e.className += this.isPrevious ? ' previous' : ' next';
          e.setAttribute('type', 'button');
          this.disable();
          e.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
          var i = this.createSVG();
          e.appendChild(i);
          this.parent.on('select', this.update.bind(this));
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };
        o.prototype.activate = function () {
          this.bindStartEvent(this.element);
          this.element.addEventListener('click', this);
          this.parent.element.appendChild(this.element);
        };
        o.prototype.deactivate = function () {
          this.parent.element.removeChild(this.element);
          this.unbindStartEvent(this.element);
          this.element.removeEventListener('click', this);
        };
        o.prototype.createSVG = function () {
          var t = document.createElementNS(r, 'svg');
          t.setAttribute('class', 'flickity-button-icon');
          t.setAttribute('viewBox', '0 0 100 100');
          var e = document.createElementNS(r, 'path');
          var i = a(this.parent.options.arrowShape);
          e.setAttribute('d', i);
          e.setAttribute('class', 'arrow');
          if (!this.isLeft) e.setAttribute('transform', 'translate(100, 100) rotate(180) ');
          t.appendChild(e);
          return t;
        };
        function a(t) {
          if (typeof t == 'string') return t;
          return (
            'M ' +
            t.x0 +
            ',50' +
            ' L ' +
            t.x1 +
            ',' +
            (t.y1 + 50) +
            ' L ' +
            t.x2 +
            ',' +
            (t.y2 + 50) +
            ' L ' +
            t.x3 +
            ',50 ' +
            ' L ' +
            t.x2 +
            ',' +
            (50 - t.y2) +
            ' L ' +
            t.x1 +
            ',' +
            (50 - t.y1) +
            ' Z'
          );
        }
        o.prototype.handleEvent = s.handleEvent;
        o.prototype.onclick = function () {
          if (!this.isEnabled) return;
          this.parent.uiChange();
          var t = this.isPrevious ? 'previous' : 'next';
          this.parent[t]();
        };
        o.prototype.enable = function () {
          if (this.isEnabled) return;
          this.element.disabled = false;
          this.isEnabled = true;
        };
        o.prototype.disable = function () {
          if (!this.isEnabled) return;
          this.element.disabled = true;
          this.isEnabled = false;
        };
        o.prototype.update = function () {
          var t = this.parent.slides;
          if (this.parent.options.wrapAround && t.length > 1) {
            this.enable();
            return;
          }
          var e = t.length ? t.length - 1 : 0;
          var i = this.isPrevious ? 0 : e;
          var n = this.parent.selectedIndex == i ? 'disable' : 'enable';
          this[n]();
        };
        o.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };
        s.extend(i.defaults, {
          prevNextButtons: true,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
        });
        i.createMethods.push('_createPrevNextButtons');
        var l = i.prototype;
        l._createPrevNextButtons = function () {
          if (!this.options.prevNextButtons) return;
          this.prevButton = new o(-1, this);
          this.nextButton = new o(1, this);
          this.on('activate', this.activatePrevNextButtons);
        };
        l.activatePrevNextButtons = function () {
          this.prevButton.activate();
          this.nextButton.activate();
          this.on('deactivate', this.deactivatePrevNextButtons);
        };
        l.deactivatePrevNextButtons = function () {
          this.prevButton.deactivate();
          this.nextButton.deactivate();
          this.off('deactivate', this.deactivatePrevNextButtons);
        };
        i.PrevNextButton = o;
        return i;
      });
    },
    519: function (t, e, i) {
      var n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(typeof window != 'undefined' ? window : this, function t(e, i) {
        e.createMethods.push('_sync');
        let n = e.prototype;
        n._sync = function () {
          this.syncers = {};
          let t = this.options.sync;
          this.on('destroy', this.unsyncAll);
          if (!t) return;
          setTimeout(() => {
            this.sync(t);
          });
        };
        n.sync = function (t) {
          t = i.getQueryElement(t);
          let n = e.data(t);
          if (!n) return;
          this._syncCompanion(n);
          n._syncCompanion(this);
        };
        n._syncCompanion = function (t) {
          let e = this;
          function i() {
            let i = e.selectedIndex;
            if (t.selectedIndex !== i) t.select(i);
          }
          this.on('select', i);
          this.syncers[t.guid] = { flickity: t, listener: i };
        };
        n.unsync = function (t) {
          t = i.getQueryElement(t);
          let n = e.data(t);
          this._unsync(n);
        };
        n._unsync = function (t) {
          if (!t) return;
          this._unsyncCompanion(t);
          t._unsyncCompanion(this);
        };
        n._unsyncCompanion = function (t) {
          let e = t.guid;
          let i = this.syncers[e];
          this.off('select', i.listener);
          delete this.syncers[e];
        };
        n.unsyncAll = function () {
          for (let t in this.syncers) {
            let e = this.syncers[t];
            this._unsync(e.flickity);
          }
        };
        return e;
      });
    },
    542: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136), i(784), i(914), i(359), i(338), i(816)]),
          (s = function (t, e, i, n, s, a) {
            return o(r, t, e, i, n, s, a);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
        else var a;
      })(window, function t(e, i, n, s, r, o, a) {
        'use strict';
        var l = e.jQuery;
        var h = e.getComputedStyle;
        var c = e.console;
        function d(t, e) {
          t = s.makeArray(t);
          while (t.length) e.appendChild(t.shift());
        }
        var u = 0;
        var p = {};
        function f(t, e) {
          var i = s.getQueryElement(t);
          if (!i) {
            if (c) c.error('Bad element for Flickity: ' + (i || t));
            return;
          }
          this.element = i;
          if (this.element.flickityGUID) {
            var n = p[this.element.flickityGUID];
            if (n) n.option(e);
            return n;
          }
          if (l) this.$element = l(this.element);
          this.options = s.extend({}, this.constructor.defaults);
          this.option(e);
          this._create();
        }
        f.defaults = {
          accessibility: true,
          cellAlign: 'center',
          freeScrollFriction: 0.075,
          friction: 0.28,
          namespaceJQueryEvents: true,
          percentPosition: true,
          resize: true,
          selectedAttraction: 0.025,
          setGallerySize: true,
        };
        f.createMethods = [];
        var v = f.prototype;
        s.extend(v, i.prototype);
        v._create = function () {
          var t = (this.guid = ++u);
          this.element.flickityGUID = t;
          p[t] = this;
          this.selectedIndex = 0;
          this.restingFrames = 0;
          this.x = 0;
          this.velocity = 0;
          this.originSide = this.options.rightToLeft ? 'right' : 'left';
          this.viewport = document.createElement('div');
          this.viewport.className = 'flickity-viewport';
          this._createSlider();
          if (this.options.resize || this.options.watchCSS) e.addEventListener('resize', this);
          for (var i in this.options.on) {
            var n = this.options.on[i];
            this.on(i, n);
          }
          f.createMethods.forEach(function (t) {
            this[t]();
          }, this);
          if (this.options.watchCSS) this.watchCSS();
          else this.activate();
        };
        v.option = function (t) {
          s.extend(this.options, t);
        };
        v.activate = function () {
          if (this.isActive) return;
          this.isActive = true;
          this.element.classList.add('flickity-enabled');
          if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
          this.getSize();
          var t = this._filterFindCellElements(this.element.children);
          d(t, this.slider);
          this.viewport.appendChild(this.slider);
          this.element.appendChild(this.viewport);
          this.reloadCells();
          if (this.options.accessibility) {
            this.element.tabIndex = 0;
            this.element.addEventListener('keydown', this);
          }
          this.emitEvent('activate');
          this.selectInitialIndex();
          this.isInitActivated = true;
          this.dispatchEvent('ready');
        };
        v._createSlider = function () {
          var t = document.createElement('div');
          t.className = 'flickity-slider';
          t.style[this.originSide] = 0;
          this.slider = t;
        };
        v._filterFindCellElements = function (t) {
          return s.filterFindElements(t, this.options.cellSelector);
        };
        v.reloadCells = function () {
          this.cells = this._makeCells(this.slider.children);
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
        };
        v._makeCells = function (t) {
          var e = this._filterFindCellElements(t);
          var i = e.map(function (t) {
            return new r(t, this);
          }, this);
          return i;
        };
        v.getLastCell = function () {
          return this.cells[this.cells.length - 1];
        };
        v.getLastSlide = function () {
          return this.slides[this.slides.length - 1];
        };
        v.positionCells = function () {
          this._sizeCells(this.cells);
          this._positionCells(0);
        };
        v._positionCells = function (t) {
          t = t || 0;
          this.maxCellHeight = t ? this.maxCellHeight || 0 : 0;
          var e = 0;
          if (t > 0) {
            var i = this.cells[t - 1];
            e = i.x + i.size.outerWidth;
          }
          var n = this.cells.length;
          for (var s = t; s < n; s++) {
            var r = this.cells[s];
            r.setPosition(e);
            e += r.size.outerWidth;
            this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight);
          }
          this.slideableWidth = e;
          this.updateSlides();
          this._containSlides();
          this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0;
        };
        v._sizeCells = function (t) {
          t.forEach(function (t) {
            t.getSize();
          });
        };
        v.updateSlides = function () {
          this.slides = [];
          if (!this.cells.length) return;
          var t = new o(this);
          this.slides.push(t);
          var e = this.originSide == 'left';
          var i = e ? 'marginRight' : 'marginLeft';
          var n = this._getCanCellFit();
          this.cells.forEach(function (e, s) {
            if (!t.cells.length) {
              t.addCell(e);
              return;
            }
            var r = t.outerWidth - t.firstMargin + (e.size.outerWidth - e.size[i]);
            if (n.call(this, s, r)) t.addCell(e);
            else {
              t.updateTarget();
              t = new o(this);
              this.slides.push(t);
              t.addCell(e);
            }
          }, this);
          t.updateTarget();
          this.updateSelectedSlide();
        };
        v._getCanCellFit = function () {
          var t = this.options.groupCells;
          if (!t)
            return function () {
              return false;
            };
          else if (typeof t == 'number') {
            var e = parseInt(t, 10);
            return function (t) {
              return t % e !== 0;
            };
          }
          var i = typeof t == 'string' && t.match(/^(\d+)%$/);
          var n = i ? parseInt(i[1], 10) / 100 : 1;
          return function (t, e) {
            return e <= (this.size.innerWidth + 1) * n;
          };
        };
        v._init = v.reposition = function () {
          this.positionCells();
          this.positionSliderAtSelected();
        };
        v.getSize = function () {
          this.size = n(this.element);
          this.setCellAlign();
          this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };
        var m = {
          center: { left: 0.5, right: 0.5 },
          left: { left: 0, right: 1 },
          right: { right: 0, left: 1 },
        };
        v.setCellAlign = function () {
          var t = m[this.options.cellAlign];
          this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
        };
        v.setGallerySize = function () {
          if (this.options.setGallerySize) {
            var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = t + 'px';
          }
        };
        v._getWrapShiftCells = function () {
          if (!this.options.wrapAround) return;
          this._unshiftCells(this.beforeShiftCells);
          this._unshiftCells(this.afterShiftCells);
          var t = this.cursorPosition;
          var e = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(t, e, -1);
          t = this.size.innerWidth - this.cursorPosition;
          this.afterShiftCells = this._getGapCells(t, 0, 1);
        };
        v._getGapCells = function (t, e, i) {
          var n = [];
          while (t > 0) {
            var s = this.cells[e];
            if (!s) break;
            n.push(s);
            e += i;
            t -= s.size.outerWidth;
          }
          return n;
        };
        v._containSlides = function () {
          if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
          var t = this.options.rightToLeft;
          var e = t ? 'marginRight' : 'marginLeft';
          var i = t ? 'marginLeft' : 'marginRight';
          var n = this.slideableWidth - this.getLastCell().size[i];
          var s = n < this.size.innerWidth;
          var r = this.cursorPosition + this.cells[0].size[e];
          var o = n - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (t) {
            if (s) t.target = n * this.cellAlign;
            else {
              t.target = Math.max(t.target, r);
              t.target = Math.min(t.target, o);
            }
          }, this);
        };
        v.dispatchEvent = function (t, e, i) {
          var n = e ? [e].concat(i) : i;
          this.emitEvent(t, n);
          if (l && this.$element) {
            t += this.options.namespaceJQueryEvents ? '.flickity' : '';
            var s = t;
            if (e) {
              var r = new l.Event(e);
              r.type = t;
              s = r;
            }
            this.$element.trigger(s, i);
          }
        };
        v.select = function (t, e, i) {
          if (!this.isActive) return;
          t = parseInt(t, 10);
          this._wrapSelect(t);
          if (this.options.wrapAround || e) t = s.modulo(t, this.slides.length);
          if (!this.slides[t]) return;
          var n = this.selectedIndex;
          this.selectedIndex = t;
          this.updateSelectedSlide();
          if (i) this.positionSliderAtSelected();
          else this.startAnimation();
          if (this.options.adaptiveHeight) this.setGallerySize();
          this.dispatchEvent('select', null, [t]);
          if (t != n) this.dispatchEvent('change', null, [t]);
          this.dispatchEvent('cellSelect');
        };
        v._wrapSelect = function (t) {
          var e = this.slides.length;
          var i = this.options.wrapAround && e > 1;
          if (!i) return t;
          var n = s.modulo(t, e);
          var r = Math.abs(n - this.selectedIndex);
          var o = Math.abs(n + e - this.selectedIndex);
          var a = Math.abs(n - e - this.selectedIndex);
          if (!this.isDragSelect && o < r) t += e;
          else if (!this.isDragSelect && a < r) t -= e;
          if (t < 0) this.x -= this.slideableWidth;
          else if (t >= e) this.x += this.slideableWidth;
        };
        v.previous = function (t, e) {
          this.select(this.selectedIndex - 1, t, e);
        };
        v.next = function (t, e) {
          this.select(this.selectedIndex + 1, t, e);
        };
        v.updateSelectedSlide = function () {
          var t = this.slides[this.selectedIndex];
          if (!t) return;
          this.unselectSelectedSlide();
          this.selectedSlide = t;
          t.select();
          this.selectedCells = t.cells;
          this.selectedElements = t.getCellElements();
          this.selectedCell = t.cells[0];
          this.selectedElement = this.selectedElements[0];
        };
        v.unselectSelectedSlide = function () {
          if (this.selectedSlide) this.selectedSlide.unselect();
        };
        v.selectInitialIndex = function () {
          var t = this.options.initialIndex;
          if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
          }
          if (t && typeof t == 'string') {
            var e = this.queryCell(t);
            if (e) {
              this.selectCell(t, false, true);
              return;
            }
          }
          var i = 0;
          if (t && this.slides[t]) i = t;
          this.select(i, false, true);
        };
        v.selectCell = function (t, e, i) {
          var n = this.queryCell(t);
          if (!n) return;
          var s = this.getCellSlideIndex(n);
          this.select(s, e, i);
        };
        v.getCellSlideIndex = function (t) {
          for (var e = 0; e < this.slides.length; e++) {
            var i = this.slides[e];
            var n = i.cells.indexOf(t);
            if (n != -1) return e;
          }
        };
        v.getCell = function (t) {
          for (var e = 0; e < this.cells.length; e++) {
            var i = this.cells[e];
            if (i.element == t) return i;
          }
        };
        v.getCells = function (t) {
          t = s.makeArray(t);
          var e = [];
          t.forEach(function (t) {
            var i = this.getCell(t);
            if (i) e.push(i);
          }, this);
          return e;
        };
        v.getCellElements = function () {
          return this.cells.map(function (t) {
            return t.element;
          });
        };
        v.getParentCell = function (t) {
          var e = this.getCell(t);
          if (e) return e;
          t = s.getParent(t, '.flickity-slider > *');
          return this.getCell(t);
        };
        v.getAdjacentCellElements = function (t, e) {
          if (!t) return this.selectedSlide.getCellElements();
          e = e === void 0 ? this.selectedIndex : e;
          var i = this.slides.length;
          if (1 + t * 2 >= i) return this.getCellElements();
          var n = [];
          for (var r = e - t; r <= e + t; r++) {
            var o = this.options.wrapAround ? s.modulo(r, i) : r;
            var a = this.slides[o];
            if (a) n = n.concat(a.getCellElements());
          }
          return n;
        };
        v.queryCell = function (t) {
          if (typeof t == 'number') return this.cells[t];
          if (typeof t == 'string') {
            if (t.match(/^[#.]?[\d/]/)) return;
            t = this.element.querySelector(t);
          }
          return this.getCell(t);
        };
        v.uiChange = function () {
          this.emitEvent('uiChange');
        };
        v.childUIPointerDown = function (t) {
          if (t.type != 'touchstart') t.preventDefault();
          this.focus();
        };
        v.onresize = function () {
          this.watchCSS();
          this.resize();
        };
        s.debounceMethod(f, 'onresize', 150);
        v.resize = function () {
          if (!this.isActive || this.isAnimating || this.isDragging) return;
          this.getSize();
          if (this.options.wrapAround) this.x = s.modulo(this.x, this.slideableWidth);
          this.positionCells();
          this._getWrapShiftCells();
          this.setGallerySize();
          this.emitEvent('resize');
          var t = this.selectedElements && this.selectedElements[0];
          this.selectCell(t, false, true);
        };
        v.watchCSS = function () {
          var t = this.options.watchCSS;
          if (!t) return;
          var e = h(this.element, ':after').content;
          if (e.indexOf('flickity') != -1) this.activate();
          else this.deactivate();
        };
        v.onkeydown = function (t) {
          var e = document.activeElement && document.activeElement != this.element;
          if (!this.options.accessibility || e) return;
          var i = f.keyboardHandlers[t.keyCode];
          if (i) i.call(this);
        };
        f.keyboardHandlers = {
          37: function () {
            var t = this.options.rightToLeft ? 'next' : 'previous';
            this.uiChange();
            this[t]();
          },
          39: function () {
            var t = this.options.rightToLeft ? 'previous' : 'next';
            this.uiChange();
            this[t]();
          },
        };
        v.focus = function () {
          var t = e.pageYOffset;
          this.element.focus({ preventScroll: true });
          if (e.pageYOffset != t) e.scrollTo(e.pageXOffset, t);
        };
        v.deactivate = function () {
          if (!this.isActive) return;
          this.element.classList.remove('flickity-enabled');
          this.element.classList.remove('flickity-rtl');
          this.unselectSelectedSlide();
          this.cells.forEach(function (t) {
            t.destroy();
          });
          this.element.removeChild(this.viewport);
          d(this.slider.children, this.element);
          if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
          }
          this.isActive = false;
          this.emitEvent('deactivate');
        };
        v.destroy = function () {
          this.deactivate();
          e.removeEventListener('resize', this);
          this.allOff();
          this.emitEvent('destroy');
          if (l && this.$element) l.removeData(this.element, 'flickity');
          delete this.element.flickityGUID;
          delete p[this.guid];
        };
        s.extend(v, a);
        f.data = function (t) {
          t = s.getQueryElement(t);
          var e = t && t.flickityGUID;
          return e && p[e];
        };
        s.htmlInit(f, 'flickity');
        if (l && l.bridget) l.bridget('flickity', f);
        f.setJQuery = function (t) {
          l = t;
        };
        f.Cell = r;
        f.Slide = o;
        return f;
      });
    },
    549: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(878), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        function r(t) {
          this.parent = t;
          this._create();
        }
        r.prototype = Object.create(n.prototype);
        r.prototype._create = function () {
          this.holder = document.createElement('ol');
          this.holder.className = 'flickity-page-dots';
          this.dots = [];
          this.handleClick = this.onClick.bind(this);
          this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
        };
        r.prototype.activate = function () {
          this.setDots();
          this.holder.addEventListener('click', this.handleClick);
          this.bindStartEvent(this.holder);
          this.parent.element.appendChild(this.holder);
        };
        r.prototype.deactivate = function () {
          this.holder.removeEventListener('click', this.handleClick);
          this.unbindStartEvent(this.holder);
          this.parent.element.removeChild(this.holder);
        };
        r.prototype.setDots = function () {
          var t = this.parent.slides.length - this.dots.length;
          if (t > 0) this.addDots(t);
          else if (t < 0) this.removeDots(-t);
        };
        r.prototype.addDots = function (t) {
          var e = document.createDocumentFragment();
          var i = [];
          var n = this.dots.length;
          var s = n + t;
          for (var r = n; r < s; r++) {
            var o = document.createElement('li');
            o.className = 'dot';
            o.setAttribute('aria-label', 'Page dot ' + (r + 1));
            e.appendChild(o);
            i.push(o);
          }
          this.holder.appendChild(e);
          this.dots = this.dots.concat(i);
        };
        r.prototype.removeDots = function (t) {
          var e = this.dots.splice(this.dots.length - t, t);
          e.forEach(function (t) {
            this.holder.removeChild(t);
          }, this);
        };
        r.prototype.updateSelected = function () {
          if (this.selectedDot) {
            this.selectedDot.className = 'dot';
            this.selectedDot.removeAttribute('aria-current');
          }
          if (!this.dots.length) return;
          this.selectedDot = this.dots[this.parent.selectedIndex];
          this.selectedDot.className = 'dot is-selected';
          this.selectedDot.setAttribute('aria-current', 'step');
        };
        r.prototype.onTap = r.prototype.onClick = function (t) {
          var e = t.target;
          if (e.nodeName != 'LI') return;
          this.parent.uiChange();
          var i = this.dots.indexOf(e);
          this.parent.select(i);
        };
        r.prototype.destroy = function () {
          this.deactivate();
          this.allOff();
        };
        i.PageDots = r;
        s.extend(i.defaults, { pageDots: true });
        i.createMethods.push('_createPageDots');
        var o = i.prototype;
        o._createPageDots = function () {
          if (!this.options.pageDots) return;
          this.pageDots = new r(this);
          this.on('activate', this.activatePageDots);
          this.on('select', this.updateSelectedPageDots);
          this.on('cellChange', this.updatePageDots);
          this.on('resize', this.updatePageDots);
          this.on('deactivate', this.deactivatePageDots);
        };
        o.activatePageDots = function () {
          this.pageDots.activate();
        };
        o.updateSelectedPageDots = function () {
          this.pageDots.updateSelected();
        };
        o.updatePageDots = function () {
          this.pageDots.setDots();
        };
        o.deactivatePageDots = function () {
          this.pageDots.deactivate();
        };
        i.PageDots = r;
        return i;
      });
    },
    572: function (t) {
      !(function (e, i) {
        true ? (t.exports = i()) : 0;
      })(this, function () {
        return (() => {
          'use strict';
          var t = {
              d: (e, i) => {
                for (var n in i) t.o(i, n) && !t.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: i[n] });
              },
              o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
              r: (t) => {
                'undefined' != typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, {
                    value: 'Module',
                  }),
                  Object.defineProperty(t, '__esModule', { value: !0 });
              },
            },
            e = {};
          function i(t, e) {
            for (var i = 0; i < e.length; i++) {
              var n = e[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                'value' in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n);
            }
          }
          function n(t, e, n) {
            return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, 'prototype', { writable: !1 }), t;
          }
          function s(t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
          }
          function r(t, e, i) {
            return (
              e in t
                ? Object.defineProperty(t, e, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (t[e] = i),
              t
            );
          }
          t.r(e), t.d(e, { default: () => a });
          var o = {
              overlay: null,
              thickness: '3px',
              color: 'gray',
              startDuration: 1e3,
              finishDuration: 300,
            },
            a = n(function t() {
              var e = this,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.body,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              s(this, t),
                r(this, 'setLoadingData', function () {
                  var t = e.target,
                    i = e.options,
                    n = i.startDuration,
                    s = i.finishDuration,
                    r = i.thickness,
                    o = i.color;
                  t.style.setProperty('--al-thickness', ' '.concat(r)),
                    t.style.setProperty('--al-color', ' '.concat(o)),
                    t.style.setProperty('--al-start-duration', ' '.concat(n, 'ms')),
                    t.style.setProperty('--al-finish-duration', ' '.concat(s, 'ms'));
                }),
                r(this, 'start', function () {
                  e.target.classList.add('al-loading-bar', 'start', 'loading'),
                    e.overlay && e.overlay.classList.add('al-loading-overlay', 'overlay-show');
                }),
                r(this, 'finish', function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {},
                    i = e.target,
                    n = e.overlay,
                    s = e.cleanUp,
                    r = e.options.finishDuration,
                    o = window.getComputedStyle(i, ':before').width;
                  i.style.setProperty('--al-end-width', o),
                    i.classList.add('loaded'),
                    i.classList.remove('loading'),
                    window.requestAnimationFrame(function () {
                      i.classList.add('finished'), e.overlay && n.classList.remove('overlay-show');
                    }),
                    setTimeout(s, 2 * r),
                    setTimeout(t, r);
                }),
                r(this, 'cleanUp', function () {
                  e.target.classList.remove('al-loading-bar', 'start', 'loaded', 'finished'),
                    e.overlay && e.overlay.classList.remove('al-loading-overlay');
                }),
                (this.options = Object.assign({}, o, n)),
                (this.target = i),
                (this.overlay = this.options.overlay),
                this.setLoadingData();
            });
          return e;
        })();
      });
    },
    575: (t, e, i) => {
      var n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(542), i(793), i(515), i(549), i(762), i(958), i(65)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(window, function t(e) {
        return e;
      });
    },
    691: () => {
      (function () {
        'use strict';
        var t = function (t, e) {
          var i = function t(e) {
            for (var i = 0, s = e.length; i < s; i++) n(e[i]);
          };
          var n = function t(e) {
            var i = e.target,
              n = e.attributeName,
              s = e.oldValue;
            i.attributeChangedCallback(n, s, i.getAttribute(n));
          };
          return function (s, r) {
            var o = s.constructor.observedAttributes;
            if (o)
              t(r).then(function () {
                new e(i).observe(s, {
                  attributes: true,
                  attributeOldValue: true,
                  attributeFilter: o,
                });
                for (var t = 0, r = o.length; t < r; t++)
                  if (s.hasAttribute(o[t])) n({ target: s, attributeName: o[t], oldValue: null });
              });
            return s;
          };
        };
        function e(t, e) {
          if (!t) return;
          if (typeof t === 'string') return i(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          if (n === 'Object' && t.constructor) n = t.constructor.name;
          if (n === 'Map' || n === 'Set') return Array.from(t);
          if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(t, e);
        }
        function i(t, e) {
          if (e == null || e > t.length) e = t.length;
          for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
          return n;
        }
        function n(t, i) {
          var n = (typeof Symbol !== 'undefined' && t[Symbol.iterator]) || t['@@iterator'];
          if (!n) {
            if (Array.isArray(t) || (n = e(t)) || (i && t && typeof t.length === 'number')) {
              if (n) t = n;
              var s = 0;
              var r = function () {};
              return {
                s: r,
                n: function () {
                  if (s >= t.length) return { done: true };
                  return { done: false, value: t[s++] };
                },
                e: function (t) {
                  throw t;
                },
                f: r,
              };
            }
            throw new TypeError(
              'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            );
          }
          var o = true,
            a = false,
            l;
          return {
            s: function () {
              n = n.call(t);
            },
            n: function () {
              var t = n.next();
              o = t.done;
              return t;
            },
            e: function (t) {
              a = true;
              l = t;
            },
            f: function () {
              try {
                if (!o && n.return != null) n.return();
              } finally {
                if (a) throw l;
              }
            },
          };
        }
        var s = true,
          r = false,
          o = 'querySelectorAll';
        var a = function t(e) {
          var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
          var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MutationObserver;
          var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ['*'];
          var h = function t(i, r, a, l, h, c) {
            var d = n(i),
              u;
            try {
              for (d.s(); !(u = d.n()).done; ) {
                var p = u.value;
                if (c || o in p) {
                  if (h) {
                    if (!a.has(p)) {
                      a.add(p);
                      l['delete'](p);
                      e(p, h);
                    }
                  } else if (!l.has(p)) {
                    l.add(p);
                    a['delete'](p);
                    e(p, h);
                  }
                  if (!c) t(p[o](r), r, a, l, h, s);
                }
              }
            } catch (t) {
              d.e(t);
            } finally {
              d.f();
            }
          };
          var c = new a(function (t) {
            if (l.length) {
              var e = l.join(',');
              var i = new Set(),
                o = new Set();
              var a = n(t),
                c;
              try {
                for (a.s(); !(c = a.n()).done; ) {
                  var d = c.value,
                    u = d.addedNodes,
                    p = d.removedNodes;
                  h(p, e, i, o, r, r);
                  h(u, e, i, o, s, r);
                }
              } catch (t) {
                a.e(t);
              } finally {
                a.f();
              }
            }
          });
          var d = c.observe;
          (c.observe = function (t) {
            return d.call(c, t, { subtree: s, childList: s });
          })(i);
          return c;
        };
        var l = 'querySelectorAll';
        var h = self,
          c = h.document,
          d = h.Element,
          u = h.MutationObserver,
          p = h.Set,
          f = h.WeakMap;
        var v = function t(e) {
          return l in e;
        };
        var m = [].filter;
        var g = function (t) {
          var e = new f();
          var i = function t(i) {
            for (var n = 0, s = i.length; n < s; n++) e['delete'](i[n]);
          };
          var n = function t() {
            var e = y.takeRecords();
            for (var i = 0, n = e.length; i < n; i++) {
              o(m.call(e[i].removedNodes, v), false);
              o(m.call(e[i].addedNodes, v), true);
            }
          };
          var s = function t(e) {
            return e.matches || e.webkitMatchesSelector || e.msMatchesSelector;
          };
          var r = function i(n, r) {
            var o;
            if (r) {
              for (var a, l = s(n), c = 0, d = h.length; c < d; c++)
                if (l.call(n, (a = h[c]))) {
                  if (!e.has(n)) e.set(n, new p());
                  o = e.get(n);
                  if (!o.has(a)) {
                    o.add(a);
                    t.handle(n, r, a);
                  }
                }
            } else if (e.has(n)) {
              o = e.get(n);
              e['delete'](n);
              o.forEach(function (e) {
                t.handle(n, r, e);
              });
            }
          };
          var o = function t(e) {
            var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            for (var n = 0, s = e.length; n < s; n++) r(e[n], i);
          };
          var h = t.query;
          var g = t.root || c;
          var y = a(r, g, u, h);
          var w = d.prototype.attachShadow;
          if (w)
            d.prototype.attachShadow = function (t) {
              var e = w.call(this, t);
              y.observe(e);
              return e;
            };
          if (h.length) o(g[l](h));
          return { drop: i, flush: n, observer: y, parse: o };
        };
        var y = self,
          w = y.document,
          b = y.Map,
          _ = y.MutationObserver,
          x = y.Object,
          S = y.Set,
          C = y.WeakMap,
          E = y.Element,
          P = y.HTMLElement,
          A = y.Node,
          D = y.Error,
          L = y.TypeError,
          O = y.Reflect;
        var I = x.defineProperty,
          T = x.keys,
          z = x.getOwnPropertyNames,
          M = x.setPrototypeOf;
        var k = !self.customElements;
        var F = function t(e) {
          var i = T(e);
          var n = [];
          var s = new S();
          var r = i.length;
          for (var o = 0; o < r; o++) {
            n[o] = e[i[o]];
            try {
              delete e[i[o]];
            } catch (t) {
              s.add(o);
            }
          }
          return function () {
            for (var t = 0; t < r; t++) s.has(t) || (e[i[t]] = n[t]);
          };
        };
        if (k) {
          var R = function t() {
            var e = this.constructor;
            if (!Z.has(e)) throw new L('Illegal constructor');
            var i = Z.get(e);
            if (X) return $(X, i);
            var n = N.call(w, i);
            return $(M(n, e.prototype), i);
          };
          var N = w.createElement;
          var Z = new b();
          var B = new b();
          var W = new b();
          var H = new b();
          var j = [];
          var V = function t(e, i, n) {
            var s = W.get(n);
            if (i && !s.isPrototypeOf(e)) {
              var r = F(e);
              X = M(e, s);
              try {
                new s.constructor();
              } finally {
                X = null;
                r();
              }
            }
            var o = ''.concat(i ? '' : 'dis', 'connectedCallback');
            if (o in s) e[o]();
          };
          var U = g({ query: j, handle: V }),
            q = U.parse;
          var X = null;
          var G = function t(e) {
            if (!B.has(e)) {
              var i,
                n = new Promise(function (t) {
                  i = t;
                });
              B.set(e, { $: n, _: i });
            }
            return B.get(e).$;
          };
          var $ = t(G, _);
          self.customElements = {
            define: function t(e, i) {
              if (H.has(e)) throw new D('the name "'.concat(e, '" has already been used with this registry'));
              Z.set(i, e);
              W.set(e, i.prototype);
              H.set(e, i);
              j.push(e);
              G(e).then(function () {
                q(w.querySelectorAll(e));
              });
              B.get(e)._(i);
            },
            get: function t(e) {
              return H.get(e);
            },
            whenDefined: G,
          };
          I((R.prototype = P.prototype), 'constructor', { value: R });
          self.HTMLElement = R;
          w.createElement = function (t, e) {
            var i = e && e.is;
            var n = i ? H.get(i) : H.get(t);
            return n ? new n() : N.call(w, t);
          };
          if (!('isConnected' in A.prototype))
            I(A.prototype, 'isConnected', {
              configurable: true,
              get: function t() {
                return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
              },
            });
        } else {
          k = !self.customElements.get('extends-br');
          if (k)
            try {
              var Y = function t() {
                return self.Reflect.construct(HTMLBRElement, [], t);
              };
              Y.prototype = HTMLLIElement.prototype;
              var K = 'extends-br';
              self.customElements.define('extends-br', Y, { extends: 'br' });
              k = w.createElement('br', { is: K }).outerHTML.indexOf(K) < 0;
              var Q = self.customElements,
                J = Q.get,
                tt = Q.whenDefined;
              self.customElements.whenDefined = function (t) {
                var e = this;
                return tt.call(this, t).then(function (i) {
                  return i || J.call(e, t);
                });
              };
            } catch (t) {}
        }
        if (k) {
          var et = function t(e) {
            var i = ht.get(e);
            bt(i.querySelectorAll(this), e.isConnected);
          };
          var it = self.customElements;
          var nt = w.createElement;
          var st = it.define,
            rt = it.get,
            ot = it.upgrade;
          var at = O || {
              construct: function t(e) {
                return e.call(this);
              },
            },
            lt = at.construct;
          var ht = new C();
          var ct = new S();
          var dt = new b();
          var ut = new b();
          var pt = new b();
          var ft = new b();
          var vt = [];
          var mt = [];
          var gt = function t(e) {
            return ft.get(e) || rt.call(it, e);
          };
          var yt = function t(e, i, n) {
            var s = pt.get(n);
            if (i && !s.isPrototypeOf(e)) {
              var r = F(e);
              Pt = M(e, s);
              try {
                new s.constructor();
              } finally {
                Pt = null;
                r();
              }
            }
            var o = ''.concat(i ? '' : 'dis', 'connectedCallback');
            if (o in s) e[o]();
          };
          var wt = g({ query: mt, handle: yt }),
            bt = wt.parse;
          var _t = g({
              query: vt,
              handle: function t(e, i) {
                if (ht.has(e)) {
                  if (i) ct.add(e);
                  else ct['delete'](e);
                  if (mt.length) et.call(mt, e);
                }
              },
            }),
            xt = _t.parse;
          var St = E.prototype.attachShadow;
          if (St)
            E.prototype.attachShadow = function (t) {
              var e = St.call(this, t);
              ht.set(this, e);
              return e;
            };
          var Ct = function t(e) {
            if (!ut.has(e)) {
              var i,
                n = new Promise(function (t) {
                  i = t;
                });
              ut.set(e, { $: n, _: i });
            }
            return ut.get(e).$;
          };
          var Et = t(Ct, _);
          var Pt = null;
          z(self)
            .filter(function (t) {
              return /^HTML.*Element$/.test(t);
            })
            .forEach(function (t) {
              var e = self[t];
              function i() {
                var t = this.constructor;
                if (!dt.has(t)) throw new L('Illegal constructor');
                var i = dt.get(t),
                  n = i.is,
                  s = i.tag;
                if (n) {
                  if (Pt) return Et(Pt, n);
                  var r = nt.call(w, s);
                  r.setAttribute('is', n);
                  return Et(M(r, t.prototype), n);
                } else return lt.call(this, e, [], t);
              }
              I((i.prototype = e.prototype), 'constructor', { value: i });
              I(self, t, { value: i });
            });
          w.createElement = function (t, e) {
            var i = e && e.is;
            if (i) {
              var n = ft.get(i);
              if (n && dt.get(n).tag === t) return new n();
            }
            var s = nt.call(w, t);
            if (i) s.setAttribute('is', i);
            return s;
          };
          it.get = gt;
          it.whenDefined = Ct;
          it.upgrade = function (t) {
            var e = t.getAttribute('is');
            if (e) {
              var i = ft.get(e);
              if (i) {
                Et(M(t, i.prototype), e);
                return;
              }
            }
            ot.call(it, t);
          };
          it.define = function (t, e, i) {
            if (gt(t)) throw new D("'".concat(t, "' has already been defined as a custom element"));
            var n;
            var s = i && i['extends'];
            dt.set(e, s ? { is: t, tag: s } : { is: '', tag: t });
            if (s) {
              n = ''.concat(s, '[is="').concat(t, '"]');
              pt.set(n, e.prototype);
              ft.set(t, e);
              mt.push(n);
            } else {
              st.apply(it, arguments);
              vt.push((n = t));
            }
            Ct(t).then(function () {
              if (s) {
                bt(w.querySelectorAll(n));
                ct.forEach(et, [n]);
              } else xt(w.querySelectorAll(n));
            });
            ut.get(t)._(e);
          };
        }
      })();
    },
    715: () => {
      const t = (t) => {
        const e = document.querySelectorAll('[data-cart-count-number]');
        e &&
          e.forEach((e) => {
            const i = e.closest('[data-cart-count-bubble]');
            const n = e.dataset.type;
            if (n == 'drawer') e.textContent = t;
            else if (t < 100) e.textContent = t;
            else e.textContent = '99+';
            if (t === 0) i.classList.add('is-cart-empty');
            else i.classList.remove('is-cart-empty');
          });
      };
      const e = () =>
        fetch(`/cart.js`, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
          },
        }).then((t) => {
          if (!t.ok) throw t;
          return t.json();
        });
      window.FoxThemeCartHelpers = window.FoxThemeCartHelpers || {};
      window.FoxThemeCartHelpers = { updateCartCount: t, getState: e };
    },
    762: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136), i(914), i(542)]),
          (s = function (t, e, i) {
            return o(t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        function s(t) {
          this.parent = t;
          this.state = 'stopped';
          this.onVisibilityChange = this.visibilityChange.bind(this);
          this.onVisibilityPlay = this.visibilityPlay.bind(this);
        }
        s.prototype = Object.create(e.prototype);
        s.prototype.play = function () {
          if (this.state == 'playing') return;
          var t = document.hidden;
          if (t) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
          }
          this.state = 'playing';
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          this.tick();
        };
        s.prototype.tick = function () {
          if (this.state != 'playing') return;
          var t = this.parent.options.autoPlay;
          t = typeof t == 'number' ? t : 3e3;
          var e = this;
          this.clear();
          this.timeout = setTimeout(function () {
            e.parent.next(true);
            e.tick();
          }, t);
        };
        s.prototype.stop = function () {
          this.state = 'stopped';
          this.clear();
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        };
        s.prototype.clear = function () {
          clearTimeout(this.timeout);
        };
        s.prototype.pause = function () {
          if (this.state == 'playing') {
            this.state = 'paused';
            this.clear();
          }
        };
        s.prototype.unpause = function () {
          if (this.state == 'paused') this.play();
        };
        s.prototype.visibilityChange = function () {
          var t = document.hidden;
          this[t ? 'pause' : 'unpause']();
        };
        s.prototype.visibilityPlay = function () {
          this.play();
          document.removeEventListener('visibilitychange', this.onVisibilityPlay);
        };
        i.extend(n.defaults, { pauseAutoPlayOnHover: true });
        n.createMethods.push('_createPlayer');
        var r = n.prototype;
        r._createPlayer = function () {
          this.player = new s(this);
          this.on('activate', this.activatePlayer);
          this.on('uiChange', this.stopPlayer);
          this.on('pointerDown', this.stopPlayer);
          this.on('deactivate', this.deactivatePlayer);
        };
        r.activatePlayer = function () {
          if (!this.options.autoPlay) return;
          this.player.play();
          this.element.addEventListener('mouseenter', this);
        };
        r.playPlayer = function () {
          this.player.play();
        };
        r.stopPlayer = function () {
          this.player.stop();
        };
        r.pausePlayer = function () {
          this.player.pause();
        };
        r.unpausePlayer = function () {
          this.player.unpause();
        };
        r.deactivatePlayer = function () {
          this.player.stop();
          this.element.removeEventListener('mouseenter', this);
        };
        r.onmouseenter = function () {
          if (!this.options.pauseAutoPlayOnHover) return;
          this.player.pause();
          this.element.addEventListener('mouseleave', this);
        };
        r.onmouseleave = function () {
          this.player.unpause();
          this.element.removeEventListener('mouseleave', this);
        };
        n.Player = s;
        return n;
      });
    },
    784: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true) !((n = o), (s = typeof n === 'function' ? n.call(e, i, e, t) : n), s !== void 0 && (t.exports = s));
      })(window, function t() {
        'use strict';
        function e(t) {
          var e = parseFloat(t);
          var i = t.indexOf('%') == -1 && !isNaN(e);
          return i && e;
        }
        function i() {}
        var n =
          typeof console == 'undefined'
            ? i
            : function (t) {
                void 0;
              };
        var s = [
          'paddingLeft',
          'paddingRight',
          'paddingTop',
          'paddingBottom',
          'marginLeft',
          'marginRight',
          'marginTop',
          'marginBottom',
          'borderLeftWidth',
          'borderRightWidth',
          'borderTopWidth',
          'borderBottomWidth',
        ];
        var r = s.length;
        function o() {
          var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
          };
          for (var e = 0; e < r; e++) {
            var i = s[e];
            t[i] = 0;
          }
          return t;
        }
        function a(t) {
          var e = getComputedStyle(t);
          if (!e)
            n(
              'Style returned ' +
                e +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1'
            );
          return e;
        }
        var l = false;
        var h;
        function c() {
          if (l) return;
          l = true;
          var t = document.createElement('div');
          t.style.width = '200px';
          t.style.padding = '1px 2px 3px 4px';
          t.style.borderStyle = 'solid';
          t.style.borderWidth = '1px 2px 3px 4px';
          t.style.boxSizing = 'border-box';
          var i = document.body || document.documentElement;
          i.appendChild(t);
          var n = a(t);
          h = Math.round(e(n.width)) == 200;
          d.isBoxSizeOuter = h;
          i.removeChild(t);
        }
        function d(t) {
          c();
          if (typeof t == 'string') t = document.querySelector(t);
          if (!t || typeof t != 'object' || !t.nodeType) return;
          var i = a(t);
          if (i.display == 'none') return o();
          var n = {};
          n.width = t.offsetWidth;
          n.height = t.offsetHeight;
          var l = (n.isBorderBox = i.boxSizing == 'border-box');
          for (var d = 0; d < r; d++) {
            var u = s[d];
            var p = i[u];
            var f = parseFloat(p);
            n[u] = !isNaN(f) ? f : 0;
          }
          var v = n.paddingLeft + n.paddingRight;
          var m = n.paddingTop + n.paddingBottom;
          var g = n.marginLeft + n.marginRight;
          var y = n.marginTop + n.marginBottom;
          var w = n.borderLeftWidth + n.borderRightWidth;
          var b = n.borderTopWidth + n.borderBottomWidth;
          var _ = l && h;
          var x = e(i.width);
          if (x !== false) n.width = x + (_ ? 0 : v + w);
          var S = e(i.height);
          if (S !== false) n.height = S + (_ ? 0 : m + b);
          n.innerWidth = n.width - (v + w);
          n.innerHeight = n.height - (m + b);
          n.outerWidth = n.width + g;
          n.outerHeight = n.height + y;
          return n;
        }
        return d;
      });
    },
    793: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(236), i(914)]),
          (s = function (t, e, i) {
            return o(r, t, e, i);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n, s) {
        'use strict';
        s.extend(i.defaults, { draggable: '>1', dragThreshold: 3 });
        i.createMethods.push('_createDrag');
        var r = i.prototype;
        s.extend(r, n.prototype);
        r._touchActionValue = 'pan-y';
        r._createDrag = function () {
          this.on('activate', this.onActivateDrag);
          this.on('uiChange', this._uiChangeDrag);
          this.on('deactivate', this.onDeactivateDrag);
          this.on('cellChange', this.updateDraggable);
        };
        r.onActivateDrag = function () {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };
        r.onDeactivateDrag = function () {
          this.unbindHandles();
          this.element.classList.remove('is-draggable');
        };
        r.updateDraggable = function () {
          if (this.options.draggable == '>1') this.isDraggable = this.slides.length > 1;
          else this.isDraggable = this.options.draggable;
          if (this.isDraggable) this.element.classList.add('is-draggable');
          else this.element.classList.remove('is-draggable');
        };
        r.bindDrag = function () {
          this.options.draggable = true;
          this.updateDraggable();
        };
        r.unbindDrag = function () {
          this.options.draggable = false;
          this.updateDraggable();
        };
        r._uiChangeDrag = function () {
          delete this.isFreeScrolling;
        };
        r.pointerDown = function (t, i) {
          if (!this.isDraggable) {
            this._pointerDownDefault(t, i);
            return;
          }
          var n = this.okayPointerDown(t);
          if (!n) return;
          this._pointerDownPreventDefault(t);
          this.pointerDownFocus(t);
          if (document.activeElement != this.element) this.pointerDownBlur();
          this.dragX = this.x;
          this.viewport.classList.add('is-pointer-down');
          this.pointerDownScroll = a();
          e.addEventListener('scroll', this);
          this._pointerDownDefault(t, i);
        };
        r._pointerDownDefault = function (t, e) {
          this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY };
          this._bindPostStartEvents(t);
          this.dispatchEvent('pointerDown', t, [e]);
        };
        var o = { INPUT: true, TEXTAREA: true, SELECT: true };
        r.pointerDownFocus = function (t) {
          var e = o[t.target.nodeName];
          if (!e) this.focus();
        };
        r._pointerDownPreventDefault = function (t) {
          var e = t.type == 'touchstart';
          var i = t.pointerType == 'touch';
          var n = o[t.target.nodeName];
          if (!e && !i && !n) t.preventDefault();
        };
        r.hasDragStarted = function (t) {
          return Math.abs(t.x) > this.options.dragThreshold;
        };
        r.pointerUp = function (t, e) {
          delete this.isTouchScrolling;
          this.viewport.classList.remove('is-pointer-down');
          this.dispatchEvent('pointerUp', t, [e]);
          this._dragPointerUp(t, e);
        };
        r.pointerDone = function () {
          e.removeEventListener('scroll', this);
          delete this.pointerDownScroll;
        };
        r.dragStart = function (t, i) {
          if (!this.isDraggable) return;
          this.dragStartPosition = this.x;
          this.startAnimation();
          e.removeEventListener('scroll', this);
          this.dispatchEvent('dragStart', t, [i]);
        };
        r.pointerMove = function (t, e) {
          var i = this._dragPointerMove(t, e);
          this.dispatchEvent('pointerMove', t, [e, i]);
          this._dragMove(t, e, i);
        };
        r.dragMove = function (t, e, i) {
          if (!this.isDraggable) return;
          t.preventDefault();
          this.previousDragX = this.dragX;
          var n = this.options.rightToLeft ? -1 : 1;
          if (this.options.wrapAround) i.x %= this.slideableWidth;
          var s = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            var r = Math.max(-this.slides[0].target, this.dragStartPosition);
            s = s > r ? (s + r) * 0.5 : s;
            var o = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            s = s < o ? (s + o) * 0.5 : s;
          }
          this.dragX = s;
          this.dragMoveTime = new Date();
          this.dispatchEvent('dragMove', t, [e, i]);
        };
        r.dragEnd = function (t, e) {
          if (!this.isDraggable) return;
          if (this.options.freeScroll) this.isFreeScrolling = true;
          var i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n = this.getRestingPosition();
            this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else if (!this.options.freeScroll && i == this.selectedIndex) i += this.dragEndBoostSelect();
          delete this.previousDragX;
          this.isDragSelect = this.options.wrapAround;
          this.select(i);
          delete this.isDragSelect;
          this.dispatchEvent('dragEnd', t, [e]);
        };
        r.dragEndRestingSelect = function () {
          var t = this.getRestingPosition();
          var e = Math.abs(this.getSlideDistance(-t, this.selectedIndex));
          var i = this._getClosestResting(t, e, 1);
          var n = this._getClosestResting(t, e, -1);
          var s = i.distance < n.distance ? i.index : n.index;
          return s;
        };
        r._getClosestResting = function (t, e, i) {
          var n = this.selectedIndex;
          var s = 1 / 0;
          var r =
            this.options.contain && !this.options.wrapAround
              ? function (t, e) {
                  return t <= e;
                }
              : function (t, e) {
                  return t < e;
                };
          while (r(e, s)) {
            n += i;
            s = e;
            e = this.getSlideDistance(-t, n);
            if (e === null) break;
            e = Math.abs(e);
          }
          return { distance: s, index: n - i };
        };
        r.getSlideDistance = function (t, e) {
          var i = this.slides.length;
          var n = this.options.wrapAround && i > 1;
          var r = n ? s.modulo(e, i) : e;
          var o = this.slides[r];
          if (!o) return null;
          var a = n ? this.slideableWidth * Math.floor(e / i) : 0;
          return t - (o.target + a);
        };
        r.dragEndBoostSelect = function () {
          if (this.previousDragX === void 0 || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
          var t = this.getSlideDistance(-this.dragX, this.selectedIndex);
          var e = this.previousDragX - this.dragX;
          if (t > 0 && e > 0) return 1;
          else if (t < 0 && e < 0) return -1;
          return 0;
        };
        r.staticClick = function (t, e) {
          var i = this.getParentCell(t.target);
          var n = i && i.element;
          var s = i && this.cells.indexOf(i);
          this.dispatchEvent('staticClick', t, [e, n, s]);
        };
        r.onscroll = function () {
          var t = a();
          var e = this.pointerDownScroll.x - t.x;
          var i = this.pointerDownScroll.y - t.y;
          if (Math.abs(e) > 3 || Math.abs(i) > 3) this._pointerDone();
        };
        function a() {
          return { x: e.pageXOffset, y: e.pageYOffset };
        }
        return i;
      });
    },
    816: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(914)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        var n = {};
        n.startAnimation = function () {
          if (this.isAnimating) return;
          this.isAnimating = true;
          this.restingFrames = 0;
          this.animate();
        };
        n.animate = function () {
          this.applyDragForce();
          this.applySelectedAttraction();
          var t = this.x;
          this.integratePhysics();
          this.positionSlider();
          this.settle(t);
          if (this.isAnimating) {
            var e = this;
            requestAnimationFrame(function t() {
              e.animate();
            });
          }
        };
        n.positionSlider = function () {
          var t = this.x;
          if (this.options.wrapAround && this.cells.length > 1) {
            t = i.modulo(t, this.slideableWidth);
            t -= this.slideableWidth;
            this.shiftWrapCells(t);
          }
          this.setTranslateX(t, this.isAnimating);
          this.dispatchScrollEvent();
        };
        n.setTranslateX = function (t, e) {
          t += this.cursorPosition;
          t = this.options.rightToLeft ? -t : t;
          var i = this.getPositionValue(t);
          this.slider.style.transform = e ? 'translate3d(' + i + ',0,0)' : 'translateX(' + i + ')';
        };
        n.dispatchScrollEvent = function () {
          var t = this.slides[0];
          if (!t) return;
          var e = -this.x - t.target;
          var i = e / this.slidesWidth;
          this.dispatchEvent('scroll', null, [i, e]);
        };
        n.positionSliderAtSelected = function () {
          if (!this.cells.length) return;
          this.x = -this.selectedSlide.target;
          this.velocity = 0;
          this.positionSlider();
        };
        n.getPositionValue = function (t) {
          if (this.options.percentPosition) return Math.round((t / this.size.innerWidth) * 1e4) * 0.01 + '%';
          else return Math.round(t) + 'px';
        };
        n.settle = function (t) {
          var e = !this.isPointerDown && Math.round(this.x * 100) == Math.round(t * 100);
          if (e) this.restingFrames++;
          if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            this.positionSlider();
            this.dispatchEvent('settle', null, [this.selectedIndex]);
          }
        };
        n.shiftWrapCells = function (t) {
          var e = this.cursorPosition + t;
          this._shiftCells(this.beforeShiftCells, e, -1);
          var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
          this._shiftCells(this.afterShiftCells, i, 1);
        };
        n._shiftCells = function (t, e, i) {
          for (var n = 0; n < t.length; n++) {
            var s = t[n];
            var r = e > 0 ? i : 0;
            s.wrapShift(r);
            e -= s.size.outerWidth;
          }
        };
        n._unshiftCells = function (t) {
          if (!t || !t.length) return;
          for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
        };
        n.integratePhysics = function () {
          this.x += this.velocity;
          this.velocity *= this.getFrictionFactor();
        };
        n.applyForce = function (t) {
          this.velocity += t;
        };
        n.getFrictionFactor = function () {
          return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
        };
        n.getRestingPosition = function () {
          return this.x + this.velocity / (1 - this.getFrictionFactor());
        };
        n.applyDragForce = function () {
          if (!this.isDraggable || !this.isPointerDown) return;
          var t = this.dragX - this.x;
          var e = t - this.velocity;
          this.applyForce(e);
        };
        n.applySelectedAttraction = function () {
          var t = this.isDraggable && this.isPointerDown;
          if (t || this.isFreeScrolling || !this.slides.length) return;
          var e = this.selectedSlide.target * -1 - this.x;
          var i = e * this.options.selectedAttraction;
          this.applyForce(i);
        };
        return n;
      });
    },
    878: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(136)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        function n() {}
        function s() {}
        var r = (s.prototype = Object.create(i.prototype));
        r.bindStartEvent = function (t) {
          this._bindStartEvent(t, true);
        };
        r.unbindStartEvent = function (t) {
          this._bindStartEvent(t, false);
        };
        r._bindStartEvent = function (t, i) {
          i = i === void 0 ? true : i;
          var n = i ? 'addEventListener' : 'removeEventListener';
          var s = 'mousedown';
          if ('ontouchstart' in e) s = 'touchstart';
          else if (e.PointerEvent) s = 'pointerdown';
          t[n](s, this);
        };
        r.handleEvent = function (t) {
          var e = 'on' + t.type;
          if (this[e]) this[e](t);
        };
        r.getTouch = function (t) {
          for (var e = 0; e < t.length; e++) {
            var i = t[e];
            if (i.identifier == this.pointerIdentifier) return i;
          }
        };
        r.onmousedown = function (t) {
          var e = t.button;
          if (e && e !== 0 && e !== 1) return;
          this._pointerDown(t, t);
        };
        r.ontouchstart = function (t) {
          this._pointerDown(t, t.changedTouches[0]);
        };
        r.onpointerdown = function (t) {
          this._pointerDown(t, t);
        };
        r._pointerDown = function (t, e) {
          if (t.button || this.isPointerDown) return;
          this.isPointerDown = true;
          this.pointerIdentifier = e.pointerId !== void 0 ? e.pointerId : e.identifier;
          this.pointerDown(t, e);
        };
        r.pointerDown = function (t, e) {
          this._bindPostStartEvents(t);
          this.emitEvent('pointerDown', [t, e]);
        };
        var o = {
          mousedown: ['mousemove', 'mouseup'],
          touchstart: ['touchmove', 'touchend', 'touchcancel'],
          pointerdown: ['pointermove', 'pointerup', 'pointercancel'],
        };
        r._bindPostStartEvents = function (t) {
          if (!t) return;
          var i = o[t.type];
          i.forEach(function (t) {
            e.addEventListener(t, this);
          }, this);
          this._boundPointerEvents = i;
        };
        r._unbindPostStartEvents = function () {
          if (!this._boundPointerEvents) return;
          this._boundPointerEvents.forEach(function (t) {
            e.removeEventListener(t, this);
          }, this);
          delete this._boundPointerEvents;
        };
        r.onmousemove = function (t) {
          this._pointerMove(t, t);
        };
        r.onpointermove = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerMove(t, t);
        };
        r.ontouchmove = function (t) {
          var e = this.getTouch(t.changedTouches);
          if (e) this._pointerMove(t, e);
        };
        r._pointerMove = function (t, e) {
          this.pointerMove(t, e);
        };
        r.pointerMove = function (t, e) {
          this.emitEvent('pointerMove', [t, e]);
        };
        r.onmouseup = function (t) {
          this._pointerUp(t, t);
        };
        r.onpointerup = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerUp(t, t);
        };
        r.ontouchend = function (t) {
          var e = this.getTouch(t.changedTouches);
          if (e) this._pointerUp(t, e);
        };
        r._pointerUp = function (t, e) {
          this._pointerDone();
          this.pointerUp(t, e);
        };
        r.pointerUp = function (t, e) {
          this.emitEvent('pointerUp', [t, e]);
        };
        r._pointerDone = function () {
          this._pointerReset();
          this._unbindPostStartEvents();
          this.pointerDone();
        };
        r._pointerReset = function () {
          this.isPointerDown = false;
          delete this.pointerIdentifier;
        };
        r.pointerDone = n;
        r.onpointercancel = function (t) {
          if (t.pointerId == this.pointerIdentifier) this._pointerCancel(t, t);
        };
        r.ontouchcancel = function (t) {
          var e = this.getTouch(t.changedTouches);
          if (e) this._pointerCancel(t, e);
        };
        r._pointerCancel = function (t, e) {
          this._pointerDone();
          this.pointerCancel(t, e);
        };
        r.pointerCancel = function (t, e) {
          this.emitEvent('pointerCancel', [t, e]);
        };
        s.getPointerPoint = function (t) {
          return { x: t.pageX, y: t.pageY };
        };
        return s;
      });
    },
    914: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(229)]),
          (s = function (t) {
            return o(r, t);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i) {
        'use strict';
        var n = {};
        n.extend = function (t, e) {
          for (var i in e) t[i] = e[i];
          return t;
        };
        n.modulo = function (t, e) {
          return ((t % e) + e) % e;
        };
        var s = Array.prototype.slice;
        n.makeArray = function (t) {
          if (Array.isArray(t)) return t;
          if (t === null || t === void 0) return [];
          var e = typeof t == 'object' && typeof t.length == 'number';
          if (e) return s.call(t);
          return [t];
        };
        n.removeFrom = function (t, e) {
          var i = t.indexOf(e);
          if (i != -1) t.splice(i, 1);
        };
        n.getParent = function (t, e) {
          while (t.parentNode && t != document.body) {
            t = t.parentNode;
            if (i(t, e)) return t;
          }
        };
        n.getQueryElement = function (t) {
          if (typeof t == 'string') return document.querySelector(t);
          return t;
        };
        n.handleEvent = function (t) {
          var e = 'on' + t.type;
          if (this[e]) this[e](t);
        };
        n.filterFindElements = function (t, e) {
          t = n.makeArray(t);
          var s = [];
          t.forEach(function (t) {
            if (!(t instanceof HTMLElement)) return;
            if (!e) {
              s.push(t);
              return;
            }
            if (i(t, e)) s.push(t);
            var n = t.querySelectorAll(e);
            for (var r = 0; r < n.length; r++) s.push(n[r]);
          });
          return s;
        };
        n.debounceMethod = function (t, e, i) {
          i = i || 100;
          var n = t.prototype[e];
          var s = e + 'Timeout';
          t.prototype[e] = function () {
            var t = this[s];
            clearTimeout(t);
            var e = arguments;
            var r = this;
            this[s] = setTimeout(function () {
              n.apply(r, e);
              delete r[s];
            }, i);
          };
        };
        n.docReady = function (t) {
          var e = document.readyState;
          if (e == 'complete' || e == 'interactive') setTimeout(t);
          else document.addEventListener('DOMContentLoaded', t);
        };
        n.toDashed = function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + '-' + i;
            })
            .toLowerCase();
        };
        var r = e.console;
        n.htmlInit = function (t, i) {
          n.docReady(function () {
            var s = n.toDashed(i);
            var o = 'data-' + s;
            var a = document.querySelectorAll('[' + o + ']');
            var l = document.querySelectorAll('.js-' + s);
            var h = n.makeArray(a).concat(n.makeArray(l));
            var c = o + '-options';
            var d = e.jQuery;
            h.forEach(function (e) {
              var n = e.getAttribute(o) || e.getAttribute(c);
              var s;
              try {
                s = n && JSON.parse(n);
              } catch (t) {
                if (r) r.error('Error parsing ' + o + ' on ' + e.className + ': ' + t);
                return;
              }
              var a = new t(e, s);
              if (d) d.data(e, i, a);
            });
          });
        };
        return n;
      });
    },
    954: function (t, e, i) {
      var n, s, r;
      (function (o, a) {
        if (true)
          !((s = [i(575), i(914)]),
          (n = a),
          (r = typeof n === 'function' ? n.apply(e, s) : n),
          r !== void 0 && (t.exports = r));
      })(this, function t(e, i) {
        var n = e.Slide;
        var s = n.prototype.updateTarget;
        n.prototype.updateTarget = function () {
          s.apply(this, arguments);
          if (!this.parent.options.fade) return;
          var t = this.target - this.x;
          var e = this.cells[0].x;
          this.cells.forEach(function (i) {
            var n = i.x - e - t;
            i.renderPosition(n);
          });
        };
        n.prototype.setOpacity = function (t) {
          this.cells.forEach(function (e) {
            e.element.style.opacity = t;
          });
        };
        var r = e.prototype;
        e.createMethods.push('_createFade');
        r._createFade = function () {
          this.fadeIndex = this.selectedIndex;
          this.prevSelectedIndex = this.selectedIndex;
          this.on('select', this.onSelectFade);
          this.on('dragEnd', this.onDragEndFade);
          this.on('settle', this.onSettleFade);
          this.on('activate', this.onActivateFade);
          this.on('deactivate', this.onDeactivateFade);
        };
        var o = r.updateSlides;
        r.updateSlides = function () {
          o.apply(this, arguments);
          if (!this.options.fade) return;
          this.slides.forEach(function (t, e) {
            var i = e == this.selectedIndex ? 1 : 0;
            t.setOpacity(i);
          }, this);
        };
        r.onSelectFade = function () {
          this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
          this.prevSelectedIndex = this.selectedIndex;
        };
        r.onSettleFade = function () {
          delete this.didDragEnd;
          if (!this.options.fade) return;
          this.selectedSlide.setOpacity(1);
          var t = this.slides[this.fadeIndex];
          if (t && this.fadeIndex != this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
        };
        r.onDragEndFade = function () {
          this.didDragEnd = true;
        };
        r.onActivateFade = function () {
          if (this.options.fade) this.element.classList.add('is-fade');
        };
        r.onDeactivateFade = function () {
          if (!this.options.fade) return;
          this.element.classList.remove('is-fade');
          this.slides.forEach(function (t) {
            t.setOpacity('');
          });
        };
        var a = r.positionSlider;
        r.positionSlider = function () {
          if (!this.options.fade) {
            a.apply(this, arguments);
            return;
          }
          this.fadeSlides();
          this.dispatchScrollEvent();
        };
        var l = r.positionSliderAtSelected;
        r.positionSliderAtSelected = function () {
          if (this.options.fade) this.setTranslateX(0);
          l.apply(this, arguments);
        };
        r.fadeSlides = function () {
          if (this.slides.length < 2) return;
          var t = this.getFadeIndexes();
          var e = this.slides[t.a];
          var i = this.slides[t.b];
          var n = this.wrapDifference(e.target, i.target);
          var s = this.wrapDifference(e.target, -this.x);
          s /= n;
          e.setOpacity(1 - s);
          i.setOpacity(s);
          var r = t.a;
          if (this.isDragging) r = s > 0.5 ? t.a : t.b;
          var o =
            this.fadeHideIndex != void 0 &&
            this.fadeHideIndex != r &&
            this.fadeHideIndex != t.a &&
            this.fadeHideIndex != t.b;
          if (o) this.slides[this.fadeHideIndex].setOpacity(0);
          this.fadeHideIndex = r;
        };
        r.getFadeIndexes = function () {
          if (!this.isDragging && !this.didDragEnd) return { a: this.fadeIndex, b: this.selectedIndex };
          if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
          else return this.getFadeDragLimitIndexes();
        };
        r.getFadeDragWrapIndexes = function () {
          var t = this.slides.map(function (t, e) {
            return this.getSlideDistance(-this.x, e);
          }, this);
          var e = t.map(function (t) {
            return Math.abs(t);
          });
          var n = Math.min.apply(Math, e);
          var s = e.indexOf(n);
          var r = t[s];
          var o = this.slides.length;
          var a = r >= 0 ? 1 : -1;
          return { a: s, b: i.modulo(s + a, o) };
        };
        r.getFadeDragLimitIndexes = function () {
          var t = 0;
          for (var e = 0; e < this.slides.length - 1; e++) {
            var i = this.slides[e];
            if (-this.x < i.target) break;
            t = e;
          }
          return { a: t, b: t + 1 };
        };
        r.wrapDifference = function (t, e) {
          var i = e - t;
          if (!this.options.wrapAround) return i;
          var n = i + this.slideableWidth;
          var s = i - this.slideableWidth;
          if (Math.abs(n) < Math.abs(i)) i = n;
          if (Math.abs(s) < Math.abs(i)) i = s;
          return i;
        };
        var h = r._getWrapShiftCells;
        r._getWrapShiftCells = function () {
          if (!this.options.fade) h.apply(this, arguments);
        };
        var c = r.shiftWrapCells;
        r.shiftWrapCells = function () {
          if (!this.options.fade) c.apply(this, arguments);
        };
        return e;
      });
    },
    958: (t, e, i) => {
      var n, s;
      (function (r, o) {
        if (true)
          !((n = [i(542), i(914)]),
          (s = function (t, e) {
            return o(r, t, e);
          }.apply(e, n)),
          s !== void 0 && (t.exports = s));
      })(window, function t(e, i, n) {
        'use strict';
        function s(t) {
          var e = document.createDocumentFragment();
          t.forEach(function (t) {
            e.appendChild(t.element);
          });
          return e;
        }
        var r = i.prototype;
        r.insert = function (t, e) {
          var i = this._makeCells(t);
          if (!i || !i.length) return;
          var n = this.cells.length;
          e = e === void 0 ? n : e;
          var r = s(i);
          var o = e == n;
          if (o) this.slider.appendChild(r);
          else {
            var a = this.cells[e].element;
            this.slider.insertBefore(r, a);
          }
          if (e === 0) this.cells = i.concat(this.cells);
          else if (o) this.cells = this.cells.concat(i);
          else {
            var l = this.cells.splice(e, n - e);
            this.cells = this.cells.concat(i).concat(l);
          }
          this._sizeCells(i);
          this.cellChange(e, true);
        };
        r.append = function (t) {
          this.insert(t, this.cells.length);
        };
        r.prepend = function (t) {
          this.insert(t, 0);
        };
        r.remove = function (t) {
          var e = this.getCells(t);
          if (!e || !e.length) return;
          var i = this.cells.length - 1;
          e.forEach(function (t) {
            t.remove();
            var e = this.cells.indexOf(t);
            i = Math.min(e, i);
            n.removeFrom(this.cells, t);
          }, this);
          this.cellChange(i, true);
        };
        r.cellSizeChange = function (t) {
          var e = this.getCell(t);
          if (!e) return;
          e.getSize();
          var i = this.cells.indexOf(e);
          this.cellChange(i);
        };
        r.cellChange = function (t, e) {
          var i = this.selectedElement;
          this._positionCells(t);
          this._getWrapShiftCells();
          this.setGallerySize();
          var n = this.getCell(i);
          if (n) this.selectedIndex = this.getCellSlideIndex(n);
          this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
          this.emitEvent('cellChange', [t]);
          this.select(this.selectedIndex);
          if (e) this.positionSliderAtSelected();
        };
        return i;
      });
    },
  };
  var e = {};
  function i(n) {
    var s = e[n];
    if (s !== void 0) return s.exports;
    var r = (e[n] = { exports: {} });
    t[n].call(r.exports, r, r.exports, i);
    return r.exports;
  }
  (() => {
    i.n = (t) => {
      var e = t && t.__esModule ? () => t['default'] : () => t;
      i.d(e, { a: e });
      return e;
    };
  })();
  (() => {
    i.d = (t, e) => {
      for (var n in e) if (i.o(e, n) && !i.o(t, n)) Object.defineProperty(t, n, { enumerable: true, get: e[n] });
    };
  })();
  (() => {
    i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  })();
  var n = {};
  (() => {
    'use strict';
    var t = i(572);
    var e = i.n(t);
    var n = i(575);
    var s = i.n(n);
    var r = i(954);
    var o = i(488);
    var a = i(519);
    class l {
      constructor() {
        this.noti = null;
        this.removeTimeoutId = null;
        this.hideTimeoutId = null;
        this.transitionDuration = 300;
      }
      setNoti(t, e, i) {
        let n;
        if (t === 'warning')
          n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
        else if (t === 'success')
          n = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
        this.noti = document.createElement('div');
        this.noti.classList.add('f-notification');
        this.noti.classList.add(t);
        if (i) this.noti.classList.add('f-notification--sticky');
        this.noti.innerHTML = `${n}<div class="ml-3">${e}</div>`;
      }
      show({
        target: t,
        type: e,
        message: i,
        method: n = 'after',
        last: s = 3e3,
        delay: r = 0,
        debug: o = false,
        sticky: a = false,
      }) {
        this.clearTimeout();
        this.removeNoti();
        this.setNoti(e, i, a);
        setTimeout(() => {
          t?.[n](this.noti);
          requestAnimationFrame(() => this.noti.classList.add('show'));
          if (!o)
            this.hideTimeoutId = setTimeout(() => {
              this.noti.classList.add('hide');
              this.removeTimeoutId = setTimeout(this.removeNoti, this.transitionDuration * 2);
            }, s);
        }, r);
      }
      handleClick = () => {
        clearTimeout(this.removeTimeoutId);
        this.noti.classList.add('f-hidden');
        setTimeout(this.removeNoti, this.transitionDuration * 2);
      };
      clearTimeout() {
        clearTimeout(this.removeTimeoutId);
        clearTimeout(this.hideTimeoutId);
      }
      removeNoti() {
        if (this.noti) this.noti.remove();
      }
    }
    class h {
      constructor() {
        this.events = {};
      }
      get evts() {
        return Object.keys(this.events);
      }
      subscribe(t, e) {
        this.events[t] = this.events[t] || [];
        this.events[t].push(e);
        return () => this.unSubscribe(t, e);
      }
      unSubscribe(t, e) {
        const i = this.events[t];
        if (i && Array.isArray(i))
          for (let t = 0; t < i.length; t++)
            if (i[t] === e) {
              i.splice(t, 1);
              break;
            }
      }
      emit(t, ...e) {
        void 0;
        void 0;
        void 0;
        (this.events[t] || []).forEach((t) => {
          t(...e);
        });
      }
    }
    var c = i(715);
    class d {
      constructor(t, e = {}) {
        if (!t) return;
        this.container = t;
        const { sliderOptions: i } = t.dataset;
        const n = i ? JSON.parse(i) : {};
        this.inlineOptions = n;
        this.options = { ...n, ...e };
        const { on: s = {}, onReady: r = () => {} } = e;
        this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
        this.settings = {
          cellAlign: this.isRTL ? 'right' : 'left',
          rightToLeft: this.isRTL,
          watchCSS: true,
          pageDots: false,
          autoPlay: false,
          prevNextButtons: false,
          wrapAround: false,
          pauseAutoPlayOnHover: false,
          arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 40, x3: 25 },
          freeScrollFriction: 0.01,
          ...this.options,
          on: {
            ...s,
            ready: () => {
              r();
              this._onInit();
            },
          },
        };
        this.init();
      }
      init = () => {
        if (this.container) {
          this.container.classList.add('flickity-wrapper');
          if (this.settings.adaptiveHeight) this.container.classList.add('flickity-adaptive-height');
        }
        this.instance = new window.FoxTheme.Flickity(this.container, this.settings);
        if (this.inlineOptions.autoPlay)
          this.instance.on('pointerDown', () => {
            this.instance.playPlayer();
          });
      };
      calcArrowsPos = () => {
        const t = this.container && this.container.querySelector('.f-image');
        if (t) {
          let e = t.clientHeight;
          if (e === 0) e = '50%';
          this.container.style.setProperty('--arrows-offset-top', parseInt(e) / 2 + 'px');
          this.container.classList.add('flickity-button-initialized');
        }
      };
      _onInit = () => {
        const { prevNextButtons: t, pageDots: e } = this.options;
        const { calcButtonPosition: i } = this.container.dataset;
        if (t && i === 'true') {
          this.container && this.container.classList.add('flickity-with-nav');
          setTimeout(() => this.calcArrowsPos(), 500);
        }
        if (e) this.container && this.container.classList.add('flickity-with-dots');
        this.initialized = true;
      };
      destroy = () => {
        this.instance.destroy();
        this.initialized = false;
      };
    }
    function u(t) {
      return fetch('/products/' + t + '.js').then(function (t) {
        return t.json();
      });
    }
    function p(t, e) {
      g(t);
      if (typeof e !== 'number') throw new TypeError(e + ' is not a Number.');
      var i = t.variants.filter(function (t) {
        return t.id === e;
      });
      return i[0] || null;
    }
    function f(t, e) {
      g(t);
      var i = m(t, e);
      return v(t, i);
    }
    function v(t, e) {
      g(t);
      w(e);
      var i = t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      });
      return i[0] || null;
    }
    function m(t, e) {
      g(t);
      y(e);
      var i = [];
      e.forEach(function (e) {
        for (var n = 0; n < t.options.length; n++)
          if (t.options[n].name.toLowerCase() === e.name.toLowerCase()) {
            i[n] = e.value;
            break;
          }
      });
      return i;
    }
    function g(t) {
      if (typeof t !== 'object') throw new TypeError(t + ' is not an object.');
      if (Object.keys(t).length === 0 && t.constructor === Object) throw new Error(t + ' is empty.');
    }
    function y(t) {
      if (!Array.isArray(t)) throw new TypeError(t + ' is not an array.');
      if (t.length === 0) return [];
      if (t[0].hasOwnProperty('name')) {
        if (typeof t[0].name !== 'string')
          throw new TypeError(
            'Invalid value type passed for name of option ' + t[0].name + '. Value should be string.'
          );
      } else throw new Error(t[0] + 'does not contain name key.');
    }
    function w(t) {
      if (Array.isArray(t) && typeof t[0] === 'object') throw new Error(t + 'is not a valid array of options.');
    }
    var b = i(501);
    class _ {
      constructor(t) {
        this.confettiInterval = null;
        this.containerEl = null;
        this.confettiColors = ['#EF2964', '#00C09D', '#2D87B0', '#48485E', '#EFFF1D'];
        this.confettiAnimations = ['slow', 'medium', 'fast'];
        this.timeRun = 0;
        this.container = t;
        this.setupElement();
        this.render();
      }
      setupElement() {
        const t = document.createElement('div');
        const e = this.container.style.position;
        if (e !== 'relative' || e !== 'absolute') this.container.style.position = 'relative';
        t.classList.add('f-confetti-container');
        this.container.appendChild(t);
        this.containerEl = t;
      }
      stopConfetti() {
        clearInterval(this.confettiInterval);
        setTimeout(() => this.containerEl.remove(), 1500);
      }
      render() {
        this.confettiInterval = setInterval(() => {
          this.timeRun += 1;
          if (this.timeRun >= 160) this.stopConfetti();
          const t = document.createElement('div');
          const e = Math.floor(Math.random() * 3) + 7 + 'px';
          const i = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
          const n = Math.floor(Math.random() * this.container.offsetWidth) + 'px';
          const s = this.confettiAnimations[Math.floor(Math.random() * this.confettiAnimations.length)];
          t.classList.add('f-confetti', 'f-confetti--animation-' + s);
          t.style.left = n;
          t.style.width = e;
          t.style.height = e;
          t.style.backgroundColor = i;
          t.removeTimeout = setTimeout(function () {
            t.parentNode.removeChild(t);
          }, 3e3);
          this.containerEl.appendChild(t);
        }, 20);
      }
    }
    function x(t, e, i) {
      const n = document.createElement(e);
      if (t) n.className = t;
      if (i) i.appendChild(n);
      return n;
    }
    function S(t, e) {
      t.x = e.x;
      t.y = e.y;
      if (e.id !== void 0) t.id = e.id;
      return t;
    }
    function C(t) {
      t.x = Math.round(t.x);
      t.y = Math.round(t.y);
    }
    function E(t, e) {
      const i = Math.abs(t.x - e.x);
      const n = Math.abs(t.y - e.y);
      return Math.sqrt(i * i + n * n);
    }
    function P(t, e) {
      return t.x === e.x && t.y === e.y;
    }
    function A(t, e, i) {
      return Math.min(Math.max(t, e), i);
    }
    function D(t, e, i) {
      let n = `translate3d(${t}px,${e || 0}px,0)`;
      if (i !== void 0) n += ` scale3d(${i},${i},1)`;
      return n;
    }
    function L(t, e, i, n) {
      t.style.transform = D(e, i, n);
    }
    const O = 'cubic-bezier(.4,0,.22,1)';
    function I(t, e, i, n) {
      t.style.transition = e ? `${e} ${i}ms ${n || O}` : 'none';
    }
    function T(t, e, i) {
      t.style.width = typeof e === 'number' ? `${e}px` : e;
      t.style.height = typeof i === 'number' ? `${i}px` : i;
    }
    function z(t) {
      I(t);
    }
    function M(t) {
      if ('decode' in t) return t.decode().catch(() => {});
      if (t.complete) return Promise.resolve(t);
      return new Promise((e, i) => {
        t.onload = () => e(t);
        t.onerror = i;
      });
    }
    const k = {
      IDLE: 'idle',
      LOADING: 'loading',
      LOADED: 'loaded',
      ERROR: 'error',
    };
    function F(t) {
      return ('button' in t && t.button === 1) || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
    }
    function R(t, e, i = document) {
      let n = [];
      if (t instanceof Element) n = [t];
      else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
      else {
        const s = typeof t === 'string' ? t : e;
        if (s) n = Array.from(i.querySelectorAll(s));
      }
      return n;
    }
    function N() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    let Z = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: () => {
            Z = true;
          },
        })
      );
    } catch (t) {}
    class B {
      constructor() {
        this._pool = [];
      }
      add(t, e, i, n) {
        this._toggleListener(t, e, i, n);
      }
      remove(t, e, i, n) {
        this._toggleListener(t, e, i, n, true);
      }
      removeAll() {
        this._pool.forEach((t) => {
          this._toggleListener(t.target, t.type, t.listener, t.passive, true, true);
        });
        this._pool = [];
      }
      _toggleListener(t, e, i, n, s, r) {
        if (!t) return;
        const o = s ? 'removeEventListener' : 'addEventListener';
        const a = e.split(' ');
        a.forEach((e) => {
          if (e) {
            if (!r)
              if (s) this._pool = this._pool.filter((n) => n.type !== e || n.listener !== i || n.target !== t);
              else
                this._pool.push({
                  target: t,
                  type: e,
                  listener: i,
                  passive: n,
                });
            const a = Z ? { passive: n || false } : false;
            t[o](e, i, a);
          }
        });
      }
    }
    function W(t, e) {
      if (t.getViewportSizeFn) {
        const i = t.getViewportSizeFn(t, e);
        if (i) return i;
      }
      return { x: document.documentElement.clientWidth, y: window.innerHeight };
    }
    function H(t, e, i, n, s) {
      let r = 0;
      if (e.paddingFn) r = e.paddingFn(i, n, s)[t];
      else if (e.padding) r = e.padding[t];
      else {
        const i = 'padding' + t[0].toUpperCase() + t.slice(1);
        if (e[i]) r = e[i];
      }
      return Number(r) || 0;
    }
    function j(t, e, i, n) {
      return {
        x: e.x - H('left', t, e, i, n) - H('right', t, e, i, n),
        y: e.y - H('top', t, e, i, n) - H('bottom', t, e, i, n),
      };
    }
    class V {
      constructor(t) {
        this.slide = t;
        this.currZoomLevel = 1;
        this.center = { x: 0, y: 0 };
        this.max = { x: 0, y: 0 };
        this.min = { x: 0, y: 0 };
      }
      update(t) {
        this.currZoomLevel = t;
        if (!this.slide.width) this.reset();
        else {
          this._updateAxis('x');
          this._updateAxis('y');
          this.slide.pswp.dispatch('calcBounds', { slide: this.slide });
        }
      }
      _updateAxis(t) {
        const { pswp: e } = this.slide;
        const i = this.slide[t === 'x' ? 'width' : 'height'] * this.currZoomLevel;
        const n = t === 'x' ? 'left' : 'top';
        const s = H(n, e.options, e.viewportSize, this.slide.data, this.slide.index);
        const r = this.slide.panAreaSize[t];
        this.center[t] = Math.round((r - i) / 2) + s;
        this.max[t] = i > r ? Math.round(r - i) + s : this.center[t];
        this.min[t] = i > r ? s : this.center[t];
      }
      reset() {
        this.center.x = 0;
        this.center.y = 0;
        this.max.x = 0;
        this.max.y = 0;
        this.min.x = 0;
        this.min.y = 0;
      }
      correctPan(t, e) {
        return A(e, this.max[t], this.min[t]);
      }
    }
    const U = 4e3;
    class q {
      constructor(t, e, i, n) {
        this.pswp = n;
        this.options = t;
        this.itemData = e;
        this.index = i;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(t, e, i) {
        const n = { x: t, y: e };
        this.elementSize = n;
        this.panAreaSize = i;
        const s = i.x / n.x;
        const r = i.y / n.y;
        this.fit = Math.min(1, s < r ? s : r);
        this.fill = Math.min(1, s > r ? s : r);
        this.vFill = Math.min(1, r);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp)
          this.pswp.dispatch('zoomLevelsUpdate', {
            zoomLevels: this,
            slideData: this.itemData,
          });
      }
      _parseZoomLevelOption(t) {
        const e = t + 'ZoomLevel';
        const i = this.options[e];
        if (!i) return;
        if (typeof i === 'function') return i(this);
        if (i === 'fill') return this.fill;
        if (i === 'fit') return this.fit;
        return Number(i);
      }
      _getSecondary() {
        let t = this._parseZoomLevelOption('secondary');
        if (t) return t;
        t = Math.min(1, this.fit * 3);
        if (this.elementSize && t * this.elementSize.x > U) t = U / this.elementSize.x;
        return t;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    }
    class X {
      constructor(t, e, i) {
        this.data = t;
        this.index = e;
        this.pswp = i;
        this.isActive = e === i.currIndex;
        this.currentResolution = 0;
        this.panAreaSize = { x: 0, y: 0 };
        this.pan = { x: 0, y: 0 };
        this.isFirstSlide = this.isActive && !i.opener.isOpen;
        this.zoomLevels = new q(i.options, t, e, i);
        this.pswp.dispatch('gettingData', {
          slide: this,
          data: this.data,
          index: e,
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = x('pswp__zoom-wrap', 'div');
        this.holderElement = null;
        this.currZoomLevel = 1;
        this.width = this.content.width;
        this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new V(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch('slideInit', { slide: this });
      }
      setIsActive(t) {
        if (t && !this.isActive) this.activate();
        else if (!t && this.isActive) this.deactivate();
      }
      append(t) {
        this.holderElement = t;
        this.container.style.transformOrigin = '0 0';
        if (!this.data) return;
        this.calculateSize();
        this.load();
        this.updateContentSize();
        this.appendHeavy();
        this.holderElement.appendChild(this.container);
        this.zoomAndPanToInitial();
        this.pswp.dispatch('firstZoomPan', { slide: this });
        this.applyCurrentZoomPan();
        this.pswp.dispatch('afterSetContent', { slide: this });
        if (this.isActive) this.activate();
      }
      load() {
        this.content.load(false);
        this.pswp.dispatch('slideLoad', { slide: this });
      }
      appendHeavy() {
        const { pswp: t } = this;
        const e = true;
        if (this.heavyAppended || !t.opener.isOpen || t.mainScroll.isShifted() || (!this.isActive && !e)) return;
        if (this.pswp.dispatch('appendHeavy', { slide: this }).defaultPrevented) return;
        this.heavyAppended = true;
        this.content.append();
        this.pswp.dispatch('appendHeavyContent', { slide: this });
      }
      activate() {
        this.isActive = true;
        this.appendHeavy();
        this.content.activate();
        this.pswp.dispatch('slideActivate', { slide: this });
      }
      deactivate() {
        this.isActive = false;
        this.content.deactivate();
        if (this.currZoomLevel !== this.zoomLevels.initial) this.calculateSize();
        this.currentResolution = 0;
        this.zoomAndPanToInitial();
        this.applyCurrentZoomPan();
        this.updateContentSize();
        this.pswp.dispatch('slideDeactivate', { slide: this });
      }
      destroy() {
        this.content.hasSlide = false;
        this.content.remove();
        this.container.remove();
        this.pswp.dispatch('slideDestroy', { slide: this });
      }
      resize() {
        if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
          this.calculateSize();
          this.currentResolution = 0;
          this.zoomAndPanToInitial();
          this.applyCurrentZoomPan();
          this.updateContentSize();
        } else {
          this.calculateSize();
          this.bounds.update(this.currZoomLevel);
          this.panTo(this.pan.x, this.pan.y);
        }
      }
      updateContentSize(t) {
        const e = this.currentResolution || this.zoomLevels.initial;
        if (!e) return;
        const i = Math.round(this.width * e) || this.pswp.viewportSize.x;
        const n = Math.round(this.height * e) || this.pswp.viewportSize.y;
        if (!this.sizeChanged(i, n) && !t) return;
        this.content.setDisplayedSize(i, n);
      }
      sizeChanged(t, e) {
        if (t !== this.prevDisplayedWidth || e !== this.prevDisplayedHeight) {
          this.prevDisplayedWidth = t;
          this.prevDisplayedHeight = e;
          return true;
        }
        return false;
      }
      getPlaceholderElement() {
        var t;
        return (t = this.content.placeholder) === null || t === void 0 ? void 0 : t.element;
      }
      zoomTo(t, e, i, n) {
        const { pswp: s } = this;
        if (!this.isZoomable() || s.mainScroll.isShifted()) return;
        s.dispatch('beforeZoomTo', {
          destZoomLevel: t,
          centerPoint: e,
          transitionDuration: i,
        });
        s.animations.stopAllPan();
        const r = this.currZoomLevel;
        if (!n) t = A(t, this.zoomLevels.min, this.zoomLevels.max);
        this.setZoomLevel(t);
        this.pan.x = this.calculateZoomToPanOffset('x', e, r);
        this.pan.y = this.calculateZoomToPanOffset('y', e, r);
        C(this.pan);
        const o = () => {
          this._setResolution(t);
          this.applyCurrentZoomPan();
        };
        if (!i) o();
        else
          s.animations.startTransition({
            isPan: true,
            name: 'zoomTo',
            target: this.container,
            transform: this.getCurrentTransform(),
            onComplete: o,
            duration: i,
            easing: s.options.easing,
          });
      }
      toggleZoom(t) {
        this.zoomTo(
          this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial,
          t,
          this.pswp.options.zoomAnimationDuration
        );
      }
      setZoomLevel(t) {
        this.currZoomLevel = t;
        this.bounds.update(this.currZoomLevel);
      }
      calculateZoomToPanOffset(t, e, i) {
        const n = this.bounds.max[t] - this.bounds.min[t];
        if (n === 0) return this.bounds.center[t];
        if (!e) e = this.pswp.getViewportCenterPoint();
        if (!i) i = this.zoomLevels.initial;
        const s = this.currZoomLevel / i;
        return this.bounds.correctPan(t, (this.pan[t] - e[t]) * s + e[t]);
      }
      panTo(t, e) {
        this.pan.x = this.bounds.correctPan('x', t);
        this.pan.y = this.bounds.correctPan('y', e);
        this.applyCurrentZoomPan();
      }
      isPannable() {
        return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
      }
      isZoomable() {
        return Boolean(this.width) && this.content.isZoomable();
      }
      applyCurrentZoomPan() {
        this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
        if (this === this.pswp.currSlide) this.pswp.dispatch('zoomPanUpdate', { slide: this });
      }
      zoomAndPanToInitial() {
        this.currZoomLevel = this.zoomLevels.initial;
        this.bounds.update(this.currZoomLevel);
        S(this.pan, this.bounds.center);
        this.pswp.dispatch('initialZoomPan', { slide: this });
      }
      _applyZoomTransform(t, e, i) {
        i /= this.currentResolution || this.zoomLevels.initial;
        L(this.container, t, e, i);
      }
      calculateSize() {
        const { pswp: t } = this;
        S(this.panAreaSize, j(t.options, t.viewportSize, this.data, this.index));
        this.zoomLevels.update(this.width, this.height, this.panAreaSize);
        t.dispatch('calcSlideSize', { slide: this });
      }
      getCurrentTransform() {
        const t = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
        return D(this.pan.x, this.pan.y, t);
      }
      _setResolution(t) {
        if (t === this.currentResolution) return;
        this.currentResolution = t;
        this.updateContentSize();
        this.pswp.dispatch('resolutionChanged');
      }
    }
    const G = 0.35;
    const $ = 0.6;
    const Y = 0.4;
    const K = 0.5;
    function Q(t, e) {
      return (t * e) / (1 - e);
    }
    class J {
      constructor(t) {
        this.gestures = t;
        this.pswp = t.pswp;
        this.startPan = { x: 0, y: 0 };
      }
      start() {
        if (this.pswp.currSlide) S(this.startPan, this.pswp.currSlide.pan);
        this.pswp.animations.stopAll();
      }
      change() {
        const { p1: t, prevP1: e, dragAxis: i } = this.gestures;
        const { currSlide: n } = this.pswp;
        if (
          i === 'y' &&
          this.pswp.options.closeOnVerticalDrag &&
          n &&
          n.currZoomLevel <= n.zoomLevels.fit &&
          !this.gestures.isMultitouch
        ) {
          const i = n.pan.y + (t.y - e.y);
          if (!this.pswp.dispatch('verticalDrag', { panY: i }).defaultPrevented) {
            this._setPanWithFriction('y', i, $);
            const t = 1 - Math.abs(this._getVerticalDragRatio(n.pan.y));
            this.pswp.applyBgOpacity(t);
            n.applyCurrentZoomPan();
          }
        } else {
          const t = this._panOrMoveMainScroll('x');
          if (!t) {
            this._panOrMoveMainScroll('y');
            if (n) {
              C(n.pan);
              n.applyCurrentZoomPan();
            }
          }
        }
      }
      end() {
        const { velocity: t } = this.gestures;
        const { mainScroll: e, currSlide: i } = this.pswp;
        let n = 0;
        this.pswp.animations.stopAll();
        if (e.isShifted()) {
          const i = e.x - e.getCurrSlideX();
          const s = i / this.pswp.viewportSize.x;
          if ((t.x < -K && s < 0) || (t.x < 0.1 && s < -0.5)) {
            n = 1;
            t.x = Math.min(t.x, 0);
          } else if ((t.x > K && s > 0) || (t.x > -0.1 && s > 0.5)) {
            n = -1;
            t.x = Math.max(t.x, 0);
          }
          e.moveIndexBy(n, true, t.x);
        }
        if ((i && i.currZoomLevel > i.zoomLevels.max) || this.gestures.isMultitouch)
          this.gestures.zoomLevels.correctZoomPan(true);
        else {
          this._finishPanGestureForAxis('x');
          this._finishPanGestureForAxis('y');
        }
      }
      _finishPanGestureForAxis(t) {
        const { velocity: e } = this.gestures;
        const { currSlide: i } = this.pswp;
        if (!i) return;
        const { pan: n, bounds: s } = i;
        const r = n[t];
        const o = this.pswp.bgOpacity < 1 && t === 'y';
        const a = 0.995;
        const l = r + Q(e[t], a);
        if (o) {
          const t = this._getVerticalDragRatio(r);
          const e = this._getVerticalDragRatio(l);
          if ((t < 0 && e < -Y) || (t > 0 && e > Y)) {
            this.pswp.close();
            return;
          }
        }
        const h = s.correctPan(t, l);
        if (r === h) return;
        const c = h === l ? 1 : 0.82;
        const d = this.pswp.bgOpacity;
        const u = h - r;
        this.pswp.animations.startSpring({
          name: 'panGesture' + t,
          isPan: true,
          start: r,
          end: h,
          velocity: e[t],
          dampingRatio: c,
          onUpdate: (e) => {
            if (o && this.pswp.bgOpacity < 1) {
              const t = 1 - (h - e) / u;
              this.pswp.applyBgOpacity(A(d + (1 - d) * t, 0, 1));
            }
            n[t] = Math.floor(e);
            i.applyCurrentZoomPan();
          },
        });
      }
      _panOrMoveMainScroll(t) {
        const { p1: e, dragAxis: i, prevP1: n, isMultitouch: s } = this.gestures;
        const { currSlide: r, mainScroll: o } = this.pswp;
        const a = e[t] - n[t];
        const l = o.x + a;
        if (!a || !r) return false;
        if (t === 'x' && !r.isPannable() && !s) {
          o.moveTo(l, true);
          return true;
        }
        const { bounds: h } = r;
        const c = r.pan[t] + a;
        if (this.pswp.options.allowPanToNext && i === 'x' && t === 'x' && !s) {
          const e = o.getCurrSlideX();
          const i = o.x - e;
          const n = a > 0;
          const s = !n;
          if (c > h.min[t] && n) {
            const e = h.min[t] <= this.startPan[t];
            if (e) {
              o.moveTo(l, true);
              return true;
            } else this._setPanWithFriction(t, c);
          } else if (c < h.max[t] && s) {
            const e = this.startPan[t] <= h.max[t];
            if (e) {
              o.moveTo(l, true);
              return true;
            } else this._setPanWithFriction(t, c);
          } else if (i !== 0) {
            if (i > 0) {
              o.moveTo(Math.max(l, e), true);
              return true;
            } else if (i < 0) {
              o.moveTo(Math.min(l, e), true);
              return true;
            }
          } else this._setPanWithFriction(t, c);
        } else if (t === 'y') {
          if (!o.isShifted() && h.min.y !== h.max.y) this._setPanWithFriction(t, c);
        } else this._setPanWithFriction(t, c);
        return false;
      }
      _getVerticalDragRatio(t) {
        var e, i;
        return (
          (t -
            ((e = (i = this.pswp.currSlide) === null || i === void 0 ? void 0 : i.bounds.center.y) !== null &&
            e !== void 0
              ? e
              : 0)) /
          (this.pswp.viewportSize.y / 3)
        );
      }
      _setPanWithFriction(t, e, i) {
        const { currSlide: n } = this.pswp;
        if (!n) return;
        const { pan: s, bounds: r } = n;
        const o = r.correctPan(t, e);
        if (o !== e || i) {
          const n = Math.round(e - s[t]);
          s[t] += n * (i || G);
        } else s[t] = e;
      }
    }
    const tt = 0.05;
    const et = 0.15;
    function it(t, e, i) {
      t.x = (e.x + i.x) / 2;
      t.y = (e.y + i.y) / 2;
      return t;
    }
    class nt {
      constructor(t) {
        this.gestures = t;
        this._startPan = { x: 0, y: 0 };
        this._startZoomPoint = { x: 0, y: 0 };
        this._zoomPoint = { x: 0, y: 0 };
        this._wasOverFitZoomLevel = false;
        this._startZoomLevel = 1;
      }
      start() {
        const { currSlide: t } = this.gestures.pswp;
        if (t) {
          this._startZoomLevel = t.currZoomLevel;
          S(this._startPan, t.pan);
        }
        this.gestures.pswp.animations.stopAllPan();
        this._wasOverFitZoomLevel = false;
      }
      change() {
        const { p1: t, startP1: e, p2: i, startP2: n, pswp: s } = this.gestures;
        const { currSlide: r } = s;
        if (!r) return;
        const o = r.zoomLevels.min;
        const a = r.zoomLevels.max;
        if (!r.isZoomable() || s.mainScroll.isShifted()) return;
        it(this._startZoomPoint, e, n);
        it(this._zoomPoint, t, i);
        let l = (1 / E(e, n)) * E(t, i) * this._startZoomLevel;
        if (l > r.zoomLevels.initial + r.zoomLevels.initial / 15) this._wasOverFitZoomLevel = true;
        if (l < o)
          if (s.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= r.zoomLevels.initial) {
            const t = 1 - (o - l) / (o / 1.2);
            if (!s.dispatch('pinchClose', { bgOpacity: t }).defaultPrevented) s.applyBgOpacity(t);
          } else l = o - (o - l) * et;
        else if (l > a) l = a + (l - a) * tt;
        r.pan.x = this._calculatePanForZoomLevel('x', l);
        r.pan.y = this._calculatePanForZoomLevel('y', l);
        r.setZoomLevel(l);
        r.applyCurrentZoomPan();
      }
      end() {
        const { pswp: t } = this.gestures;
        const { currSlide: e } = t;
        if ((!e || e.currZoomLevel < e.zoomLevels.initial) && !this._wasOverFitZoomLevel && t.options.pinchToClose)
          t.close();
        else this.correctZoomPan();
      }
      _calculatePanForZoomLevel(t, e) {
        const i = e / this._startZoomLevel;
        return this._zoomPoint[t] - (this._startZoomPoint[t] - this._startPan[t]) * i;
      }
      correctZoomPan(t) {
        const { pswp: e } = this.gestures;
        const { currSlide: i } = e;
        if (!(i !== null && i !== void 0 && i.isZoomable())) return;
        if (this._zoomPoint.x === 0) t = true;
        const n = i.currZoomLevel;
        let s;
        let r = true;
        if (n < i.zoomLevels.initial) s = i.zoomLevels.initial;
        else if (n > i.zoomLevels.max) s = i.zoomLevels.max;
        else {
          r = false;
          s = n;
        }
        const o = e.bgOpacity;
        const a = e.bgOpacity < 1;
        const l = S({ x: 0, y: 0 }, i.pan);
        let h = S({ x: 0, y: 0 }, l);
        if (t) {
          this._zoomPoint.x = 0;
          this._zoomPoint.y = 0;
          this._startZoomPoint.x = 0;
          this._startZoomPoint.y = 0;
          this._startZoomLevel = n;
          S(this._startPan, l);
        }
        if (r)
          h = {
            x: this._calculatePanForZoomLevel('x', s),
            y: this._calculatePanForZoomLevel('y', s),
          };
        i.setZoomLevel(s);
        h = {
          x: i.bounds.correctPan('x', h.x),
          y: i.bounds.correctPan('y', h.y),
        };
        i.setZoomLevel(n);
        const c = !P(h, l);
        if (!c && !r && !a) {
          i._setResolution(s);
          i.applyCurrentZoomPan();
          return;
        }
        e.animations.stopAllPan();
        e.animations.startSpring({
          isPan: true,
          start: 0,
          end: 1e3,
          velocity: 0,
          dampingRatio: 1,
          naturalFrequency: 40,
          onUpdate: (t) => {
            t /= 1e3;
            if (c || r) {
              if (c) {
                i.pan.x = l.x + (h.x - l.x) * t;
                i.pan.y = l.y + (h.y - l.y) * t;
              }
              if (r) {
                const e = n + (s - n) * t;
                i.setZoomLevel(e);
              }
              i.applyCurrentZoomPan();
            }
            if (a && e.bgOpacity < 1) e.applyBgOpacity(A(o + (1 - o) * t, 0, 1));
          },
          onComplete: () => {
            i._setResolution(s);
            i.applyCurrentZoomPan();
          },
        });
      }
    }
    function st(t) {
      return !!t.target.closest('.pswp__container');
    }
    class rt {
      constructor(t) {
        this.gestures = t;
      }
      click(t, e) {
        const i = e.target.classList;
        const n = i.contains('pswp__img');
        const s = i.contains('pswp__item') || i.contains('pswp__zoom-wrap');
        if (n) this._doClickOrTapAction('imageClick', t, e);
        else if (s) this._doClickOrTapAction('bgClick', t, e);
      }
      tap(t, e) {
        if (st(e)) this._doClickOrTapAction('tap', t, e);
      }
      doubleTap(t, e) {
        if (st(e)) this._doClickOrTapAction('doubleTap', t, e);
      }
      _doClickOrTapAction(t, e, i) {
        var n;
        const { pswp: s } = this.gestures;
        const { currSlide: r } = s;
        const o = t + 'Action';
        const a = s.options[o];
        if (s.dispatch(o, { point: e, originalEvent: i }).defaultPrevented) return;
        if (typeof a === 'function') {
          a.call(s, e, i);
          return;
        }
        switch (a) {
          case 'close':
          case 'next':
            s[a]();
            break;
          case 'zoom':
            r === null || r === void 0 || r.toggleZoom(e);
            break;
          case 'zoom-or-close':
            if (r !== null && r !== void 0 && r.isZoomable() && r.zoomLevels.secondary !== r.zoomLevels.initial)
              r.toggleZoom(e);
            else if (s.options.clickToCloseNonZoomable) s.close();
            break;
          case 'toggle-controls':
            (n = this.gestures.pswp.element) === null || n === void 0 || n.classList.toggle('pswp--ui-visible');
            break;
        }
      }
    }
    const ot = 10;
    const at = 300;
    const lt = 25;
    class ht {
      constructor(t) {
        this.pswp = t;
        this.dragAxis = null;
        this.p1 = { x: 0, y: 0 };
        this.p2 = { x: 0, y: 0 };
        this.prevP1 = { x: 0, y: 0 };
        this.prevP2 = { x: 0, y: 0 };
        this.startP1 = { x: 0, y: 0 };
        this.startP2 = { x: 0, y: 0 };
        this.velocity = { x: 0, y: 0 };
        this._lastStartP1 = { x: 0, y: 0 };
        this._intervalP1 = { x: 0, y: 0 };
        this._numActivePoints = 0;
        this._ongoingPointers = [];
        this._touchEventEnabled = 'ontouchstart' in window;
        this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || (this._pointerEventEnabled && navigator.maxTouchPoints > 1);
        this._numActivePoints = 0;
        this._intervalTime = 0;
        this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        this.raf = null;
        this._tapTimer = null;
        if (!this.supportsTouch) t.options.allowPanToNext = false;
        this.drag = new J(this);
        this.zoomLevels = new nt(this);
        this.tapHandler = new rt(this);
        t.on('bindEvents', () => {
          t.events.add(t.scrollWrap, 'click', this._onClick.bind(this));
          if (this._pointerEventEnabled) this._bindEvents('pointer', 'down', 'up', 'cancel');
          else if (this._touchEventEnabled) {
            this._bindEvents('touch', 'start', 'end', 'cancel');
            if (t.scrollWrap) {
              t.scrollWrap.ontouchmove = () => {};
              t.scrollWrap.ontouchend = () => {};
            }
          } else this._bindEvents('mouse', 'down', 'up');
        });
      }
      _bindEvents(t, e, i, n) {
        const { pswp: s } = this;
        const { events: r } = s;
        const o = n ? t + n : '';
        r.add(s.scrollWrap, t + e, this.onPointerDown.bind(this));
        r.add(window, t + 'move', this.onPointerMove.bind(this));
        r.add(window, t + i, this.onPointerUp.bind(this));
        if (o) r.add(s.scrollWrap, o, this.onPointerUp.bind(this));
      }
      onPointerDown(t) {
        const e = t.type === 'mousedown' || t.pointerType === 'mouse';
        if (e && t.button > 0) return;
        const { pswp: i } = this;
        if (!i.opener.isOpen) {
          t.preventDefault();
          return;
        }
        if (i.dispatch('pointerDown', { originalEvent: t }).defaultPrevented) return;
        if (e) {
          i.mouseDetected();
          this._preventPointerEventBehaviour(t, 'down');
        }
        i.animations.stopAll();
        this._updatePoints(t, 'down');
        if (this._numActivePoints === 1) {
          this.dragAxis = null;
          S(this.startP1, this.p1);
        }
        if (this._numActivePoints > 1) {
          this._clearTapTimer();
          this.isMultitouch = true;
        } else this.isMultitouch = false;
      }
      onPointerMove(t) {
        this._preventPointerEventBehaviour(t, 'move');
        if (!this._numActivePoints) return;
        this._updatePoints(t, 'move');
        if (this.pswp.dispatch('pointerMove', { originalEvent: t }).defaultPrevented) return;
        if (this._numActivePoints === 1 && !this.isDragging) {
          if (!this.dragAxis) this._calculateDragDirection();
          if (this.dragAxis && !this.isDragging) {
            if (this.isZooming) {
              this.isZooming = false;
              this.zoomLevels.end();
            }
            this.isDragging = true;
            this._clearTapTimer();
            this._updateStartPoints();
            this._intervalTime = Date.now();
            this._velocityCalculated = false;
            S(this._intervalP1, this.p1);
            this.velocity.x = 0;
            this.velocity.y = 0;
            this.drag.start();
            this._rafStopLoop();
            this._rafRenderLoop();
          }
        } else if (this._numActivePoints > 1 && !this.isZooming) {
          this._finishDrag();
          this.isZooming = true;
          this._updateStartPoints();
          this.zoomLevels.start();
          this._rafStopLoop();
          this._rafRenderLoop();
        }
      }
      _finishDrag() {
        if (this.isDragging) {
          this.isDragging = false;
          if (!this._velocityCalculated) this._updateVelocity(true);
          this.drag.end();
          this.dragAxis = null;
        }
      }
      onPointerUp(t) {
        if (!this._numActivePoints) return;
        this._updatePoints(t, 'up');
        if (this.pswp.dispatch('pointerUp', { originalEvent: t }).defaultPrevented) return;
        if (this._numActivePoints === 0) {
          this._rafStopLoop();
          if (this.isDragging) this._finishDrag();
          else if (!this.isZooming && !this.isMultitouch) this._finishTap(t);
        }
        if (this._numActivePoints < 2 && this.isZooming) {
          this.isZooming = false;
          this.zoomLevels.end();
          if (this._numActivePoints === 1) {
            this.dragAxis = null;
            this._updateStartPoints();
          }
        }
      }
      _rafRenderLoop() {
        if (this.isDragging || this.isZooming) {
          this._updateVelocity();
          if (this.isDragging) {
            if (!P(this.p1, this.prevP1)) this.drag.change();
          } else if (!P(this.p1, this.prevP1) || !P(this.p2, this.prevP2)) this.zoomLevels.change();
          this._updatePrevPoints();
          this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
        }
      }
      _updateVelocity(t) {
        const e = Date.now();
        const i = e - this._intervalTime;
        if (i < 50 && !t) return;
        this.velocity.x = this._getVelocity('x', i);
        this.velocity.y = this._getVelocity('y', i);
        this._intervalTime = e;
        S(this._intervalP1, this.p1);
        this._velocityCalculated = true;
      }
      _finishTap(t) {
        const { mainScroll: e } = this.pswp;
        if (e.isShifted()) {
          e.moveIndexBy(0, true);
          return;
        }
        if (t.type.indexOf('cancel') > 0) return;
        if (t.type === 'mouseup' || t.pointerType === 'mouse') {
          this.tapHandler.click(this.startP1, t);
          return;
        }
        const i = this.pswp.options.doubleTapAction ? at : 0;
        if (this._tapTimer) {
          this._clearTapTimer();
          if (E(this._lastStartP1, this.startP1) < lt) this.tapHandler.doubleTap(this.startP1, t);
        } else {
          S(this._lastStartP1, this.startP1);
          this._tapTimer = setTimeout(() => {
            this.tapHandler.tap(this.startP1, t);
            this._clearTapTimer();
          }, i);
        }
      }
      _clearTapTimer() {
        if (this._tapTimer) {
          clearTimeout(this._tapTimer);
          this._tapTimer = null;
        }
      }
      _getVelocity(t, e) {
        const i = this.p1[t] - this._intervalP1[t];
        if (Math.abs(i) > 1 && e > 5) return i / e;
        return 0;
      }
      _rafStopLoop() {
        if (this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }
      _preventPointerEventBehaviour(t, e) {
        const i = this.pswp.applyFilters('preventPointerEvent', true, t, e);
        if (i) t.preventDefault();
      }
      _updatePoints(t, e) {
        if (this._pointerEventEnabled) {
          const i = t;
          const n = this._ongoingPointers.findIndex((t) => t.id === i.pointerId);
          if (e === 'up' && n > -1) this._ongoingPointers.splice(n, 1);
          else if (e === 'down' && n === -1)
            this._ongoingPointers.push(this._convertEventPosToPoint(i, { x: 0, y: 0 }));
          else if (n > -1) this._convertEventPosToPoint(i, this._ongoingPointers[n]);
          this._numActivePoints = this._ongoingPointers.length;
          if (this._numActivePoints > 0) S(this.p1, this._ongoingPointers[0]);
          if (this._numActivePoints > 1) S(this.p2, this._ongoingPointers[1]);
        } else {
          const i = t;
          this._numActivePoints = 0;
          if (i.type.indexOf('touch') > -1) {
            if (i.touches && i.touches.length > 0) {
              this._convertEventPosToPoint(i.touches[0], this.p1);
              this._numActivePoints++;
              if (i.touches.length > 1) {
                this._convertEventPosToPoint(i.touches[1], this.p2);
                this._numActivePoints++;
              }
            }
          } else {
            this._convertEventPosToPoint(t, this.p1);
            if (e === 'up') this._numActivePoints = 0;
            else this._numActivePoints++;
          }
        }
      }
      _updatePrevPoints() {
        S(this.prevP1, this.p1);
        S(this.prevP2, this.p2);
      }
      _updateStartPoints() {
        S(this.startP1, this.p1);
        S(this.startP2, this.p2);
        this._updatePrevPoints();
      }
      _calculateDragDirection() {
        if (this.pswp.mainScroll.isShifted()) this.dragAxis = 'x';
        else {
          const t = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
          if (t !== 0) {
            const e = t > 0 ? 'x' : 'y';
            if (Math.abs(this.p1[e] - this.startP1[e]) >= ot) this.dragAxis = e;
          }
        }
      }
      _convertEventPosToPoint(t, e) {
        e.x = t.pageX - this.pswp.offset.x;
        e.y = t.pageY - this.pswp.offset.y;
        if ('pointerId' in t) e.id = t.pointerId;
        else if (t.identifier !== void 0) e.id = t.identifier;
        return e;
      }
      _onClick(t) {
        if (this.pswp.mainScroll.isShifted()) {
          t.preventDefault();
          t.stopPropagation();
        }
      }
    }
    const ct = 0.35;
    class dt {
      constructor(t) {
        this.pswp = t;
        this.x = 0;
        this.slideWidth = 0;
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this._containerShiftIndex = -1;
        this.itemHolders = [];
      }
      resize(t) {
        const { pswp: e } = this;
        const i = Math.round(e.viewportSize.x + e.viewportSize.x * e.options.spacing);
        const n = i !== this.slideWidth;
        if (n) {
          this.slideWidth = i;
          this.moveTo(this.getCurrSlideX());
        }
        this.itemHolders.forEach((e, i) => {
          if (n) L(e.el, (i + this._containerShiftIndex) * this.slideWidth);
          if (t && e.slide) e.slide.resize();
        });
      }
      resetPosition() {
        this._currPositionIndex = 0;
        this._prevPositionIndex = 0;
        this.slideWidth = 0;
        this._containerShiftIndex = -1;
      }
      appendHolders() {
        this.itemHolders = [];
        for (let t = 0; t < 3; t++) {
          const e = x('pswp__item', 'div', this.pswp.container);
          e.setAttribute('role', 'group');
          e.setAttribute('aria-roledescription', 'slide');
          e.setAttribute('aria-hidden', 'true');
          e.style.display = t === 1 ? 'block' : 'none';
          this.itemHolders.push({ el: e });
        }
      }
      canBeSwiped() {
        return this.pswp.getNumItems() > 1;
      }
      moveIndexBy(t, e, i) {
        const { pswp: n } = this;
        let s = n.potentialIndex + t;
        const r = n.getNumItems();
        if (n.canLoop()) {
          s = n.getLoopedIndex(s);
          const e = (t + r) % r;
          if (e <= r / 2) t = e;
          else t = e - r;
        } else {
          if (s < 0) s = 0;
          else if (s >= r) s = r - 1;
          t = s - n.potentialIndex;
        }
        n.potentialIndex = s;
        this._currPositionIndex -= t;
        n.animations.stopMainScroll();
        const o = this.getCurrSlideX();
        if (!e) {
          this.moveTo(o);
          this.updateCurrItem();
        } else {
          n.animations.startSpring({
            isMainScroll: true,
            start: this.x,
            end: o,
            velocity: i || 0,
            naturalFrequency: 30,
            dampingRatio: 1,
            onUpdate: (t) => {
              this.moveTo(t);
            },
            onComplete: () => {
              this.updateCurrItem();
              n.appendHeavy();
            },
          });
          let t = n.potentialIndex - n.currIndex;
          if (n.canLoop()) {
            const e = (t + r) % r;
            if (e <= r / 2) t = e;
            else t = e - r;
          }
          if (Math.abs(t) > 1) this.updateCurrItem();
        }
        return Boolean(t);
      }
      getCurrSlideX() {
        return this.slideWidth * this._currPositionIndex;
      }
      isShifted() {
        return this.x !== this.getCurrSlideX();
      }
      updateCurrItem() {
        var t;
        const { pswp: e } = this;
        const i = this._prevPositionIndex - this._currPositionIndex;
        if (!i) return;
        this._prevPositionIndex = this._currPositionIndex;
        e.currIndex = e.potentialIndex;
        let n = Math.abs(i);
        let s;
        if (n >= 3) {
          this._containerShiftIndex += i + (i > 0 ? -3 : 3);
          n = 3;
          this.itemHolders.forEach((t) => {
            var e;
            (e = t.slide) === null || e === void 0 || e.destroy();
            t.slide = void 0;
          });
        }
        for (let t = 0; t < n; t++)
          if (i > 0) {
            s = this.itemHolders.shift();
            if (s) {
              this.itemHolders[2] = s;
              this._containerShiftIndex++;
              L(s.el, (this._containerShiftIndex + 2) * this.slideWidth);
              e.setContent(s, e.currIndex - n + t + 2);
            }
          } else {
            s = this.itemHolders.pop();
            if (s) {
              this.itemHolders.unshift(s);
              this._containerShiftIndex--;
              L(s.el, this._containerShiftIndex * this.slideWidth);
              e.setContent(s, e.currIndex + n - t - 2);
            }
          }
        if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
          this.resetPosition();
          this.resize();
        }
        e.animations.stopAllPan();
        this.itemHolders.forEach((t, e) => {
          if (t.slide) t.slide.setIsActive(e === 1);
        });
        e.currSlide = (t = this.itemHolders[1]) === null || t === void 0 ? void 0 : t.slide;
        e.contentLoader.updateLazy(i);
        if (e.currSlide) e.currSlide.applyCurrentZoomPan();
        e.dispatch('change');
      }
      moveTo(t, e) {
        if (!this.pswp.canLoop() && e) {
          let e = (this.slideWidth * this._currPositionIndex - t) / this.slideWidth;
          e += this.pswp.currIndex;
          const i = Math.round(t - this.x);
          if ((e < 0 && i > 0) || (e >= this.pswp.getNumItems() - 1 && i < 0)) t = this.x + i * ct;
        }
        this.x = t;
        if (this.pswp.container) L(this.pswp.container, t);
        this.pswp.dispatch('moveMainScroll', {
          x: t,
          dragging: e !== null && e !== void 0 ? e : false,
        });
      }
    }
    const ut = {
      Escape: 27,
      z: 90,
      ArrowLeft: 37,
      ArrowUp: 38,
      ArrowRight: 39,
      ArrowDown: 40,
      Tab: 9,
    };
    const pt = (t, e) => (e ? t : ut[t]);
    class ft {
      constructor(t) {
        this.pswp = t;
        this._wasFocused = false;
        t.on('bindEvents', () => {
          if (t.options.trapFocus) {
            if (!t.options.initialPointerPos) this._focusRoot();
            t.events.add(document, 'focusin', this._onFocusIn.bind(this));
          }
          t.events.add(document, 'keydown', this._onKeyDown.bind(this));
        });
        const e = document.activeElement;
        t.on('destroy', () => {
          if (t.options.returnFocus && e && this._wasFocused) e.focus();
        });
      }
      _focusRoot() {
        if (!this._wasFocused && this.pswp.element) {
          this.pswp.element.focus();
          this._wasFocused = true;
        }
      }
      _onKeyDown(t) {
        const { pswp: e } = this;
        if (e.dispatch('keydown', { originalEvent: t }).defaultPrevented) return;
        if (F(t)) return;
        let i;
        let n;
        let s = false;
        const r = 'key' in t;
        switch (r ? t.key : t.keyCode) {
          case pt('Escape', r):
            if (e.options.escKey) i = 'close';
            break;
          case pt('z', r):
            i = 'toggleZoom';
            break;
          case pt('ArrowLeft', r):
            n = 'x';
            break;
          case pt('ArrowUp', r):
            n = 'y';
            break;
          case pt('ArrowRight', r):
            n = 'x';
            s = true;
            break;
          case pt('ArrowDown', r):
            s = true;
            n = 'y';
            break;
          case pt('Tab', r):
            this._focusRoot();
            break;
        }
        if (n) {
          t.preventDefault();
          const { currSlide: r } = e;
          if (e.options.arrowKeys && n === 'x' && e.getNumItems() > 1) i = s ? 'next' : 'prev';
          else if (r && r.currZoomLevel > r.zoomLevels.fit) {
            r.pan[n] += s ? -80 : 80;
            r.panTo(r.pan.x, r.pan.y);
          }
        }
        if (i) {
          t.preventDefault();
          e[i]();
        }
      }
      _onFocusIn(t) {
        const { template: e } = this.pswp;
        if (e && document !== t.target && e !== t.target && !e.contains(t.target)) e.focus();
      }
    }
    const vt = 'cubic-bezier(.4,0,.22,1)';
    class mt {
      constructor(t) {
        var e;
        this.props = t;
        const { target: i, onComplete: n, transform: s, onFinish: r = () => {}, duration: o = 333, easing: a = vt } = t;
        this.onFinish = r;
        const l = s ? 'transform' : 'opacity';
        const h = (e = t[l]) !== null && e !== void 0 ? e : '';
        this._target = i;
        this._onComplete = n;
        this._finished = false;
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
        this._helperTimeout = setTimeout(() => {
          I(i, l, o, a);
          this._helperTimeout = setTimeout(() => {
            i.addEventListener('transitionend', this._onTransitionEnd, false);
            i.addEventListener('transitioncancel', this._onTransitionEnd, false);
            this._helperTimeout = setTimeout(() => {
              this._finalizeAnimation();
            }, o + 500);
            i.style[l] = h;
          }, 30);
        }, 0);
      }
      _onTransitionEnd(t) {
        if (t.target === this._target) this._finalizeAnimation();
      }
      _finalizeAnimation() {
        if (!this._finished) {
          this._finished = true;
          this.onFinish();
          if (this._onComplete) this._onComplete();
        }
      }
      destroy() {
        if (this._helperTimeout) clearTimeout(this._helperTimeout);
        z(this._target);
        this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
        this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
        if (!this._finished) this._finalizeAnimation();
      }
    }
    const gt = 12;
    const yt = 0.75;
    class wt {
      constructor(t, e, i) {
        this.velocity = t * 1e3;
        this._dampingRatio = e || yt;
        this._naturalFrequency = i || gt;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
      }
      easeFrame(t, e) {
        let i = 0;
        let n;
        e /= 1e3;
        const s = Math.E ** (-this._dampingRatio * this._naturalFrequency * e);
        if (this._dampingRatio === 1) {
          n = this.velocity + this._naturalFrequency * t;
          i = (t + n * e) * s;
          this.velocity = i * -this._naturalFrequency + n * s;
        } else if (this._dampingRatio < 1) {
          n = (1 / this._dampedFrequency) * (this._dampingRatio * this._naturalFrequency * t + this.velocity);
          const r = Math.cos(this._dampedFrequency * e);
          const o = Math.sin(this._dampedFrequency * e);
          i = s * (t * r + n * o);
          this.velocity =
            i * -this._naturalFrequency * this._dampingRatio +
            s * (-this._dampedFrequency * t * o + this._dampedFrequency * n * r);
        }
        return i;
      }
    }
    class bt {
      constructor(t) {
        this.props = t;
        this._raf = 0;
        const {
          start: e,
          end: i,
          velocity: n,
          onUpdate: s,
          onComplete: r,
          onFinish: o = () => {},
          dampingRatio: a,
          naturalFrequency: l,
        } = t;
        this.onFinish = o;
        const h = new wt(n, a, l);
        let c = Date.now();
        let d = e - i;
        const u = () => {
          if (this._raf) {
            d = h.easeFrame(d, Date.now() - c);
            if (Math.abs(d) < 1 && Math.abs(h.velocity) < 50) {
              s(i);
              if (r) r();
              this.onFinish();
            } else {
              c = Date.now();
              s(d + i);
              this._raf = requestAnimationFrame(u);
            }
          }
        };
        this._raf = requestAnimationFrame(u);
      }
      destroy() {
        if (this._raf >= 0) cancelAnimationFrame(this._raf);
        this._raf = 0;
      }
    }
    class _t {
      constructor() {
        this.activeAnimations = [];
      }
      startSpring(t) {
        this._start(t, true);
      }
      startTransition(t) {
        this._start(t);
      }
      _start(t, e) {
        const i = e ? new bt(t) : new mt(t);
        this.activeAnimations.push(i);
        i.onFinish = () => this.stop(i);
        return i;
      }
      stop(t) {
        t.destroy();
        const e = this.activeAnimations.indexOf(t);
        if (e > -1) this.activeAnimations.splice(e, 1);
      }
      stopAll() {
        this.activeAnimations.forEach((t) => {
          t.destroy();
        });
        this.activeAnimations = [];
      }
      stopAllPan() {
        this.activeAnimations = this.activeAnimations.filter((t) => {
          if (t.props.isPan) {
            t.destroy();
            return false;
          }
          return true;
        });
      }
      stopMainScroll() {
        this.activeAnimations = this.activeAnimations.filter((t) => {
          if (t.props.isMainScroll) {
            t.destroy();
            return false;
          }
          return true;
        });
      }
      isPanRunning() {
        return this.activeAnimations.some((t) => t.props.isPan);
      }
    }
    class xt {
      constructor(t) {
        this.pswp = t;
        t.events.add(t.element, 'wheel', this._onWheel.bind(this));
      }
      _onWheel(t) {
        t.preventDefault();
        const { currSlide: e } = this.pswp;
        let { deltaX: i, deltaY: n } = t;
        if (!e) return;
        if (this.pswp.dispatch('wheel', { originalEvent: t }).defaultPrevented) return;
        if (t.ctrlKey || this.pswp.options.wheelToZoom) {
          if (e.isZoomable()) {
            let i = -n;
            if (t.deltaMode === 1) i *= 0.05;
            else i *= t.deltaMode ? 1 : 0.002;
            i = 2 ** i;
            const s = e.currZoomLevel * i;
            e.zoomTo(s, { x: t.clientX, y: t.clientY });
          }
        } else if (e.isPannable()) {
          if (t.deltaMode === 1) {
            i *= 18;
            n *= 18;
          }
          e.panTo(e.pan.x - i, e.pan.y - n);
        }
      }
    }
    function St(t) {
      if (typeof t === 'string') return t;
      if (!t || !t.isCustomSVG) return '';
      const e = t;
      let i = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
      i = i.split('%d').join(e.size || 32);
      if (e.outlineID) i += '<use class="pswp__icn-shadow" xlink:href="#' + e.outlineID + '"/>';
      i += e.inner;
      i += '</svg>';
      return i;
    }
    class Ct {
      constructor(t, e) {
        var i;
        const n = e.name || e.className;
        let s = e.html;
        if (t.options[n] === false) return;
        if (typeof t.options[n + 'SVG'] === 'string') s = t.options[n + 'SVG'];
        t.dispatch('uiElementCreate', { data: e });
        let r = '';
        if (e.isButton) {
          r += 'pswp__button ';
          r += e.className || `pswp__button--${e.name}`;
        } else r += e.className || `pswp__${e.name}`;
        let o = e.isButton ? e.tagName || 'button' : e.tagName || 'div';
        o = o.toLowerCase();
        const a = x(r, o);
        if (e.isButton) {
          if (o === 'button') a.type = 'button';
          let { title: i } = e;
          const { ariaLabel: s } = e;
          if (typeof t.options[n + 'Title'] === 'string') i = t.options[n + 'Title'];
          if (i) a.title = i;
          const r = s || i;
          if (r) a.setAttribute('aria-label', r);
        }
        a.innerHTML = St(s);
        if (e.onInit) e.onInit(a, t);
        if (e.onClick)
          a.onclick = (i) => {
            if (typeof e.onClick === 'string') t[e.onClick]();
            else if (typeof e.onClick === 'function') e.onClick(i, a, t);
          };
        const l = e.appendTo || 'bar';
        let h = t.element;
        if (l === 'bar') {
          if (!t.topBar) t.topBar = x('pswp__top-bar pswp__hide-on-close', 'div', t.scrollWrap);
          h = t.topBar;
        } else {
          a.classList.add('pswp__hide-on-close');
          if (l === 'wrapper') h = t.scrollWrap;
        }
        (i = h) === null || i === void 0 || i.appendChild(t.applyFilters('uiElement', a, e));
      }
    }
    function Et(t, e, i) {
      t.classList.add('pswp__button--arrow');
      t.setAttribute('aria-controls', 'pswp__items');
      e.on('change', () => {
        if (!e.options.loop)
          if (i) t.disabled = !(e.currIndex < e.getNumItems() - 1);
          else t.disabled = !(e.currIndex > 0);
      });
    }
    const Pt = {
      name: 'arrowPrev',
      className: 'pswp__button--arrow--prev',
      title: 'Previous',
      order: 10,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow',
      },
      onClick: 'prev',
      onInit: Et,
    };
    const At = {
      name: 'arrowNext',
      className: 'pswp__button--arrow--next',
      title: 'Next',
      order: 11,
      isButton: true,
      appendTo: 'wrapper',
      html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow',
      },
      onClick: 'next',
      onInit: (t, e) => {
        Et(t, e, true);
      },
    };
    const Dt = {
      name: 'close',
      title: 'Close',
      order: 20,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: 'pswp__icn-close',
      },
      onClick: 'close',
    };
    const Lt = {
      name: 'zoom',
      title: 'Zoom',
      order: 10,
      isButton: true,
      html: {
        isCustomSVG: true,
        inner:
          '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>' +
          '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>' +
          '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: 'pswp__icn-zoom',
      },
      onClick: 'toggleZoom',
    };
    const Ot = {
      name: 'preloader',
      appendTo: 'bar',
      order: 7,
      html: {
        isCustomSVG: true,
        inner:
          '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: 'pswp__icn-loading',
      },
      onInit: (t, e) => {
        let i;
        let n = null;
        const s = (e, i) => {
          t.classList.toggle('pswp__preloader--' + e, i);
        };
        const r = (t) => {
          if (i !== t) {
            i = t;
            s('active', t);
          }
        };
        const o = () => {
          var t;
          if (!((t = e.currSlide) !== null && t !== void 0 && t.content.isLoading())) {
            r(false);
            if (n) {
              clearTimeout(n);
              n = null;
            }
            return;
          }
          if (!n)
            n = setTimeout(() => {
              var t;
              r(Boolean((t = e.currSlide) === null || t === void 0 ? void 0 : t.content.isLoading()));
              n = null;
            }, e.options.preloaderDelay);
        };
        e.on('change', o);
        e.on('loadComplete', (t) => {
          if (e.currSlide === t.slide) o();
        });
        if (e.ui) e.ui.updatePreloaderVisibility = o;
      },
    };
    const It = {
      name: 'counter',
      order: 5,
      onInit: (t, e) => {
        e.on('change', () => {
          t.innerText = e.currIndex + 1 + e.options.indexIndicatorSep + e.getNumItems();
        });
      },
    };
    function Tt(t, e) {
      t.classList.toggle('pswp--zoomed-in', e);
    }
    class zt {
      constructor(t) {
        this.pswp = t;
        this.isRegistered = false;
        this.uiElementsData = [];
        this.items = [];
        this.updatePreloaderVisibility = () => {};
        this._lastUpdatedZoomLevel = void 0;
      }
      init() {
        const { pswp: t } = this;
        this.isRegistered = false;
        this.uiElementsData = [Dt, Pt, At, Lt, Ot, It];
        t.dispatch('uiRegister');
        this.uiElementsData.sort((t, e) => (t.order || 0) - (e.order || 0));
        this.items = [];
        this.isRegistered = true;
        this.uiElementsData.forEach((t) => {
          this.registerElement(t);
        });
        t.on('change', () => {
          var e;
          (e = t.element) === null || e === void 0 || e.classList.toggle('pswp--one-slide', t.getNumItems() === 1);
        });
        t.on('zoomPanUpdate', () => this._onZoomPanUpdate());
      }
      registerElement(t) {
        if (this.isRegistered) this.items.push(new Ct(this.pswp, t));
        else this.uiElementsData.push(t);
      }
      _onZoomPanUpdate() {
        const { template: t, currSlide: e, options: i } = this.pswp;
        if (this.pswp.opener.isClosing || !t || !e) return;
        let { currZoomLevel: n } = e;
        if (!this.pswp.opener.isOpen) n = e.zoomLevels.initial;
        if (n === this._lastUpdatedZoomLevel) return;
        this._lastUpdatedZoomLevel = n;
        const s = e.zoomLevels.initial - e.zoomLevels.secondary;
        if (Math.abs(s) < 0.01 || !e.isZoomable()) {
          Tt(t, false);
          t.classList.remove('pswp--zoom-allowed');
          return;
        }
        t.classList.add('pswp--zoom-allowed');
        const r = n === e.zoomLevels.initial ? e.zoomLevels.secondary : e.zoomLevels.initial;
        Tt(t, r <= n);
        if (i.imageClickAction === 'zoom' || i.imageClickAction === 'zoom-or-close')
          t.classList.add('pswp--click-to-zoom');
      }
    }
    function Mt(t) {
      const e = t.getBoundingClientRect();
      return { x: e.left, y: e.top, w: e.width };
    }
    function kt(t, e, i) {
      const n = t.getBoundingClientRect();
      const s = n.width / e;
      const r = n.height / i;
      const o = s > r ? s : r;
      const a = (n.width - e * o) / 2;
      const l = (n.height - i * o) / 2;
      const h = { x: n.left + a, y: n.top + l, w: e * o };
      h.innerRect = { w: n.width, h: n.height, x: a, y: l };
      return h;
    }
    function Ft(t, e, i) {
      const n = i.dispatch('thumbBounds', {
        index: t,
        itemData: e,
        instance: i,
      });
      if (n.thumbBounds) return n.thumbBounds;
      const { element: s } = e;
      let r;
      let o;
      if (s && i.options.thumbSelector !== false) {
        const t = i.options.thumbSelector || 'img';
        o = s.matches(t) ? s : s.querySelector(t);
      }
      o = i.applyFilters('thumbEl', o, e, t);
      if (o)
        if (!e.thumbCropped) r = Mt(o);
        else r = kt(o, e.width || e.w || 0, e.height || e.h || 0);
      return i.applyFilters('thumbBounds', r, e, t);
    }
    class Rt {
      constructor(t, e) {
        this.type = t;
        this.defaultPrevented = false;
        if (e) Object.assign(this, e);
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    }
    class Nt {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = void 0;
        this.options = void 0;
      }
      addFilter(t, e, i = 100) {
        var n, s, r;
        if (!this._filters[t]) this._filters[t] = [];
        (n = this._filters[t]) === null || n === void 0 || n.push({ fn: e, priority: i });
        (s = this._filters[t]) === null || s === void 0 || s.sort((t, e) => t.priority - e.priority);
        (r = this.pswp) === null || r === void 0 || r.addFilter(t, e, i);
      }
      removeFilter(t, e) {
        if (this._filters[t]) this._filters[t] = this._filters[t].filter((t) => t.fn !== e);
        if (this.pswp) this.pswp.removeFilter(t, e);
      }
      applyFilters(t, ...e) {
        var i;
        (i = this._filters[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            e[0] = t.fn.apply(this, e);
          });
        return e[0];
      }
      on(t, e) {
        var i, n;
        if (!this._listeners[t]) this._listeners[t] = [];
        (i = this._listeners[t]) === null || i === void 0 || i.push(e);
        (n = this.pswp) === null || n === void 0 || n.on(t, e);
      }
      off(t, e) {
        var i;
        if (this._listeners[t]) this._listeners[t] = this._listeners[t].filter((t) => e !== t);
        (i = this.pswp) === null || i === void 0 || i.off(t, e);
      }
      dispatch(t, e) {
        var i;
        if (this.pswp) return this.pswp.dispatch(t, e);
        const n = new Rt(t, e);
        (i = this._listeners[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            t.call(this, n);
          });
        return n;
      }
    }
    class Zt {
      constructor(t, e) {
        this.element = x('pswp__img pswp__img--placeholder', t ? 'img' : 'div', e);
        if (t) {
          const e = this.element;
          e.decoding = 'async';
          e.alt = '';
          e.src = t;
          e.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.element.tagName === 'IMG') {
          T(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = D(0, 0, t / 250);
        } else T(this.element, t, e);
      }
      destroy() {
        var t;
        if ((t = this.element) !== null && t !== void 0 && t.parentNode) this.element.remove();
        this.element = null;
      }
    }
    class Bt {
      constructor(t, e, i) {
        this.instance = e;
        this.data = t;
        this.index = i;
        this.element = void 0;
        this.placeholder = void 0;
        this.slide = void 0;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = k.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', { content: this });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder())
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = void 0;
            }
          }, 1e3);
      }
      load(t, e) {
        if (this.slide && this.usePlaceholder())
          if (!this.placeholder) {
            const t = this.instance.applyFilters(
              'placeholderSrc',
              this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
              this
            );
            this.placeholder = new Zt(t, this.slide.container);
          } else {
            const t = this.placeholder.element;
            if (t && !t.parentElement) this.slide.container.prepend(t);
          }
        if (this.element && !e) return;
        if (this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented) return;
        if (this.isImageContent()) {
          this.element = x('pswp__img', 'img');
          if (this.displayedImageWidth) this.loadImage(t);
        } else {
          this.element = x('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (e && this.slide) this.slide.updateContentSize(true);
      }
      loadImage(t) {
        var e, i;
        if (
          !this.isImageContent() ||
          !this.element ||
          this.instance.dispatch('contentLoadImage', {
            content: this,
            isLazy: t,
          }).defaultPrevented
        )
          return;
        const n = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) n.srcset = this.data.srcset;
        n.src = (e = this.data.src) !== null && e !== void 0 ? e : '';
        n.alt = (i = this.data.alt) !== null && i !== void 0 ? i : '';
        this.state = k.LOADING;
        if (n.complete) this.onLoaded();
        else {
          n.onload = () => {
            this.onLoaded();
          };
          n.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(t) {
        this.slide = t;
        this.hasSlide = true;
        this.instance = t.pswp;
      }
      onLoaded() {
        this.state = k.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            content: this,
          });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === k.LOADED || this.state === k.ERROR) this.removePlaceholder();
        }
      }
      onError() {
        this.state = k.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this,
          });
          this.instance.dispatch('loadError', {
            slide: this.slide,
            content: this,
          });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === k.LOADING, this);
      }
      isError() {
        return this.state === k.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(t, e);
        if (
          this.instance.dispatch('contentResize', {
            content: this,
            width: t,
            height: e,
          }).defaultPrevented
        )
          return;
        T(this.element, t, e);
        if (this.isImageContent() && !this.isError()) {
          const i = !this.displayedImageWidth && t;
          this.displayedImageWidth = t;
          this.displayedImageHeight = e;
          if (i) this.loadImage(false);
          else this.updateSrcsetSizes();
          if (this.slide)
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width: t,
              height: e,
              content: this,
            });
        }
      }
      isZoomable() {
        return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== k.ERROR, this);
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const t = this.element;
        const e = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) {
          t.sizes = e + 'px';
          t.dataset.largestUsedSize = String(e);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) return;
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = void 0;
        if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = void 0;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = void 0;
        }
      }
      displayError() {
        if (this.slide) {
          var t, e;
          let i = x('pswp__error-msg', 'div');
          i.innerText =
            (t = (e = this.instance.options) === null || e === void 0 ? void 0 : e.errorMsg) !== null && t !== void 0
              ? t
              : '';
          i = this.instance.applyFilters('contentErrorElement', i, this);
          this.element = x('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(i);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === k.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
        const t = 'decode' in this.element;
        if (this.isImageContent())
          if (t && this.slide && (!this.slide.isActive || N())) {
            this.isDecoding = true;
            this.element
              .decode()
              .catch(() => {})
              .finally(() => {
                this.isDecoding = false;
                this.appendImage();
              });
          } else this.appendImage();
        else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
      }
      activate() {
        if (this.instance.dispatch('contentActivate', { content: this }).defaultPrevented || !this.slide) return;
        if (this.isImageContent() && this.isDecoding && !N()) this.appendImage();
        else if (this.isError()) this.load(false, true);
        if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', { content: this });
        if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'true');
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
      }
      appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented) return;
        if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
        if (this.state === k.LOADED || this.state === k.ERROR) this.removePlaceholder();
      }
    }
    const Wt = 5;
    function Ht(t, e, i) {
      const n = e.createContentFromData(t, i);
      let s;
      const { options: r } = e;
      if (r) {
        s = new q(r, t, -1);
        let o;
        if (e.pswp) o = e.pswp.viewportSize;
        else o = W(r, e);
        const a = j(r, o, t, i);
        s.update(n.width, n.height, a);
      }
      n.lazyLoad();
      if (s) n.setDisplayedSize(Math.ceil(n.width * s.initial), Math.ceil(n.height * s.initial));
      return n;
    }
    function jt(t, e) {
      const i = e.getItemData(t);
      if (e.dispatch('lazyLoadSlide', { index: t, itemData: i }).defaultPrevented) return;
      return Ht(i, e, t);
    }
    class Vt {
      constructor(t) {
        this.pswp = t;
        this.limit = Math.max(t.options.preload[0] + t.options.preload[1] + 1, Wt);
        this._cachedItems = [];
      }
      updateLazy(t) {
        const { pswp: e } = this;
        if (e.dispatch('lazyLoad').defaultPrevented) return;
        const { preload: i } = e.options;
        const n = t === void 0 ? true : t >= 0;
        let s;
        for (s = 0; s <= i[1]; s++) this.loadSlideByIndex(e.currIndex + (n ? s : -s));
        for (s = 1; s <= i[0]; s++) this.loadSlideByIndex(e.currIndex + (n ? -s : s));
      }
      loadSlideByIndex(t) {
        const e = this.pswp.getLoopedIndex(t);
        let i = this.getContentByIndex(e);
        if (!i) {
          i = jt(e, this.pswp);
          if (i) this.addToCache(i);
        }
      }
      getContentBySlide(t) {
        let e = this.getContentByIndex(t.index);
        if (!e) {
          e = this.pswp.createContentFromData(t.data, t.index);
          this.addToCache(e);
        }
        e.setSlide(t);
        return e;
      }
      addToCache(t) {
        this.removeByIndex(t.index);
        this._cachedItems.push(t);
        if (this._cachedItems.length > this.limit) {
          const t = this._cachedItems.findIndex((t) => !t.isAttached && !t.hasSlide);
          if (t !== -1) {
            const e = this._cachedItems.splice(t, 1)[0];
            e.destroy();
          }
        }
      }
      removeByIndex(t) {
        const e = this._cachedItems.findIndex((e) => e.index === t);
        if (e !== -1) this._cachedItems.splice(e, 1);
      }
      getContentByIndex(t) {
        return this._cachedItems.find((e) => e.index === t);
      }
      destroy() {
        this._cachedItems.forEach((t) => t.destroy());
        this._cachedItems = [];
      }
    }
    class Ut extends Nt {
      getNumItems() {
        var t;
        let e = 0;
        const i = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
        if (i && 'length' in i) e = i.length;
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          if (i.items) e = i.items.length;
        }
        const n = this.dispatch('numItems', { dataSource: i, numItems: e });
        return this.applyFilters('numItems', n.numItems, i);
      }
      createContentFromData(t, e) {
        return new Bt(t, this, e);
      }
      getItemData(t) {
        var e;
        const i = (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
        let n = {};
        if (Array.isArray(i)) n = i[t];
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          n = i.items[t];
        }
        let s = n;
        if (s instanceof Element) s = this._domElementToItemData(s);
        const r = this.dispatch('itemData', { itemData: s || {}, index: t });
        return this.applyFilters('itemData', r.itemData, t);
      }
      _getGalleryDOMElements(t) {
        var e, i;
        if (
          ((e = this.options) !== null && e !== void 0 && e.children) ||
          ((i = this.options) !== null && i !== void 0 && i.childSelector)
        )
          return R(this.options.children, this.options.childSelector, t) || [];
        return [t];
      }
      _domElementToItemData(t) {
        const e = { element: t };
        const i = t.tagName === 'A' ? t : t.querySelector('a');
        if (i) {
          e.src = i.dataset.pswpSrc || i.href;
          if (i.dataset.pswpSrcset) e.srcset = i.dataset.pswpSrcset;
          e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0;
          e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0;
          e.w = e.width;
          e.h = e.height;
          if (i.dataset.pswpType) e.type = i.dataset.pswpType;
          const s = t.querySelector('img');
          if (s) {
            var n;
            e.msrc = s.currentSrc || s.src;
            e.alt = (n = s.getAttribute('alt')) !== null && n !== void 0 ? n : '';
          }
          if (i.dataset.pswpCropped || i.dataset.cropped) e.thumbCropped = true;
        }
        return this.applyFilters('domItemData', e, t, i);
      }
      lazyLoadData(t, e) {
        return Ht(t, this, e);
      }
    }
    const qt = 0.003;
    class Xt {
      constructor(t) {
        this.pswp = t;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        this._duration = void 0;
        this._useAnimation = false;
        this._croppedZoom = false;
        this._animateRootOpacity = false;
        this._animateBgOpacity = false;
        this._placeholder = void 0;
        this._opacityElement = void 0;
        this._cropContainer1 = void 0;
        this._cropContainer2 = void 0;
        this._thumbBounds = void 0;
        this._prepareOpen = this._prepareOpen.bind(this);
        t.on('firstZoomPan', this._prepareOpen);
      }
      open() {
        this._prepareOpen();
        this._start();
      }
      close() {
        if (this.isClosed || this.isClosing || this.isOpening) return;
        const t = this.pswp.currSlide;
        this.isOpen = false;
        this.isOpening = false;
        this.isClosing = true;
        this._duration = this.pswp.options.hideAnimationDuration;
        if (t && t.currZoomLevel * t.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
        this._applyStartProps();
        setTimeout(
          () => {
            this._start();
          },
          this._croppedZoom ? 30 : 0
        );
      }
      _prepareOpen() {
        this.pswp.off('firstZoomPan', this._prepareOpen);
        if (!this.isOpening) {
          const t = this.pswp.currSlide;
          this.isOpening = true;
          this.isClosing = false;
          this._duration = this.pswp.options.showAnimationDuration;
          if (t && t.zoomLevels.initial * t.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
          this._applyStartProps();
        }
      }
      _applyStartProps() {
        const { pswp: t } = this;
        const e = this.pswp.currSlide;
        const { options: i } = t;
        if (i.showHideAnimationType === 'fade') {
          i.showHideOpacity = true;
          this._thumbBounds = void 0;
        } else if (i.showHideAnimationType === 'none') {
          i.showHideOpacity = false;
          this._duration = 0;
          this._thumbBounds = void 0;
        } else if (this.isOpening && t._initialThumbBounds) this._thumbBounds = t._initialThumbBounds;
        else this._thumbBounds = this.pswp.getThumbBounds();
        this._placeholder = e === null || e === void 0 ? void 0 : e.getPlaceholderElement();
        t.animations.stopAll();
        this._useAnimation = Boolean(this._duration && this._duration > 50);
        this._animateZoom =
          Boolean(this._thumbBounds) &&
          (e === null || e === void 0 ? void 0 : e.content.usePlaceholder()) &&
          (!this.isClosing || !t.mainScroll.isShifted());
        if (!this._animateZoom) {
          this._animateRootOpacity = true;
          if (this.isOpening && e) {
            e.zoomAndPanToInitial();
            e.applyCurrentZoomPan();
          }
        } else {
          var n;
          this._animateRootOpacity = (n = i.showHideOpacity) !== null && n !== void 0 ? n : false;
        }
        this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > qt;
        this._opacityElement = this._animateRootOpacity ? t.element : t.bg;
        if (!this._useAnimation) {
          this._duration = 0;
          this._animateZoom = false;
          this._animateBgOpacity = false;
          this._animateRootOpacity = true;
          if (this.isOpening) {
            if (t.element) t.element.style.opacity = String(qt);
            t.applyBgOpacity(1);
          }
          return;
        }
        if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
          var s;
          this._croppedZoom = true;
          this._cropContainer1 = this.pswp.container;
          this._cropContainer2 = (s = this.pswp.currSlide) === null || s === void 0 ? void 0 : s.holderElement;
          if (t.container) {
            t.container.style.overflow = 'hidden';
            t.container.style.width = t.viewportSize.x + 'px';
          }
        } else this._croppedZoom = false;
        if (this.isOpening) {
          if (this._animateRootOpacity) {
            if (t.element) t.element.style.opacity = String(qt);
            t.applyBgOpacity(1);
          } else {
            if (this._animateBgOpacity && t.bg) t.bg.style.opacity = String(qt);
            if (t.element) t.element.style.opacity = '1';
          }
          if (this._animateZoom) {
            this._setClosedStateZoomPan();
            if (this._placeholder) {
              this._placeholder.style.willChange = 'transform';
              this._placeholder.style.opacity = String(qt);
            }
          }
        } else if (this.isClosing) {
          if (t.mainScroll.itemHolders[0]) t.mainScroll.itemHolders[0].el.style.display = 'none';
          if (t.mainScroll.itemHolders[2]) t.mainScroll.itemHolders[2].el.style.display = 'none';
          if (this._croppedZoom)
            if (t.mainScroll.x !== 0) {
              t.mainScroll.resetPosition();
              t.mainScroll.resize();
            }
        }
      }
      _start() {
        if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === 'IMG')
          new Promise((t) => {
            let e = false;
            let i = true;
            M(this._placeholder).finally(() => {
              e = true;
              if (!i) t(true);
            });
            setTimeout(() => {
              i = false;
              if (e) t(true);
            }, 50);
            setTimeout(t, 250);
          }).finally(() => this._initiate());
        else this._initiate();
      }
      _initiate() {
        var t, e;
        (t = this.pswp.element) === null ||
          t === void 0 ||
          t.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
        this.pswp.dispatch(this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart');
        this.pswp.dispatch('initialZoom' + (this.isOpening ? 'In' : 'Out'));
        (e = this.pswp.element) === null || e === void 0 || e.classList.toggle('pswp--ui-visible', this.isOpening);
        if (this.isOpening) {
          if (this._placeholder) this._placeholder.style.opacity = '1';
          this._animateToOpenState();
        } else if (this.isClosing) this._animateToClosedState();
        if (!this._useAnimation) this._onAnimationComplete();
      }
      _onAnimationComplete() {
        const { pswp: t } = this;
        this.isOpen = this.isOpening;
        this.isClosed = this.isClosing;
        this.isOpening = false;
        this.isClosing = false;
        t.dispatch(this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd');
        t.dispatch('initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'));
        if (this.isClosed) t.destroy();
        else if (this.isOpen) {
          var e;
          if (this._animateZoom && t.container) {
            t.container.style.overflow = 'visible';
            t.container.style.width = '100%';
          }
          (e = t.currSlide) === null || e === void 0 || e.applyCurrentZoomPan();
        }
      }
      _animateToOpenState() {
        const { pswp: t } = this;
        if (this._animateZoom) {
          if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
            this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
            this._animateTo(this._cropContainer2, 'transform', 'none');
          }
          if (t.currSlide) {
            t.currSlide.zoomAndPanToInitial();
            this._animateTo(t.currSlide.container, 'transform', t.currSlide.getCurrentTransform());
          }
        }
        if (this._animateBgOpacity && t.bg) this._animateTo(t.bg, 'opacity', String(t.options.bgOpacity));
        if (this._animateRootOpacity && t.element) this._animateTo(t.element, 'opacity', '1');
      }
      _animateToClosedState() {
        const { pswp: t } = this;
        if (this._animateZoom) this._setClosedStateZoomPan(true);
        if (this._animateBgOpacity && t.bgOpacity > 0.01 && t.bg) this._animateTo(t.bg, 'opacity', '0');
        if (this._animateRootOpacity && t.element) this._animateTo(t.element, 'opacity', '0');
      }
      _setClosedStateZoomPan(t) {
        if (!this._thumbBounds) return;
        const { pswp: e } = this;
        const { innerRect: i } = this._thumbBounds;
        const { currSlide: n, viewportSize: s } = e;
        if (this._croppedZoom && i && this._cropContainer1 && this._cropContainer2) {
          const e = -s.x + (this._thumbBounds.x - i.x) + i.w;
          const n = -s.y + (this._thumbBounds.y - i.y) + i.h;
          const r = s.x - i.w;
          const o = s.y - i.h;
          if (t) {
            this._animateTo(this._cropContainer1, 'transform', D(e, n));
            this._animateTo(this._cropContainer2, 'transform', D(r, o));
          } else {
            L(this._cropContainer1, e, n);
            L(this._cropContainer2, r, o);
          }
        }
        if (n) {
          S(n.pan, i || this._thumbBounds);
          n.currZoomLevel = this._thumbBounds.w / n.width;
          if (t) this._animateTo(n.container, 'transform', n.getCurrentTransform());
          else n.applyCurrentZoomPan();
        }
      }
      _animateTo(t, e, i) {
        if (!this._duration) {
          t.style[e] = i;
          return;
        }
        const { animations: n } = this.pswp;
        const s = {
          duration: this._duration,
          easing: this.pswp.options.easing,
          onComplete: () => {
            if (!n.activeAnimations.length) this._onAnimationComplete();
          },
          target: t,
        };
        s[e] = i;
        n.startTransition(s);
      }
    }
    const Gt = {
      allowPanToNext: true,
      spacing: 0.1,
      loop: true,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      hideAnimationDuration: 333,
      showAnimationDuration: 333,
      zoomAnimationDuration: 333,
      escKey: true,
      arrowKeys: true,
      trapFocus: true,
      returnFocus: true,
      maxWidthToAnimate: 4e3,
      clickToCloseNonZoomable: true,
      imageClickAction: 'zoom-or-close',
      bgClickAction: 'close',
      tapAction: 'toggle-controls',
      doubleTapAction: 'zoom',
      indexIndicatorSep: ' / ',
      preloaderDelay: 2e3,
      bgOpacity: 0.8,
      index: 0,
      errorMsg: 'The image cannot be loaded',
      preload: [1, 2],
      easing: 'cubic-bezier(.4,0,.22,1)',
    };
    class $t extends Ut {
      constructor(t) {
        super();
        this.options = this._prepareOptions(t || {});
        this.offset = { x: 0, y: 0 };
        this._prevViewportSize = { x: 0, y: 0 };
        this.viewportSize = { x: 0, y: 0 };
        this.bgOpacity = 1;
        this.currIndex = 0;
        this.potentialIndex = 0;
        this.isOpen = false;
        this.isDestroying = false;
        this.hasMouse = false;
        this._initialItemData = {};
        this._initialThumbBounds = void 0;
        this.topBar = void 0;
        this.element = void 0;
        this.template = void 0;
        this.container = void 0;
        this.scrollWrap = void 0;
        this.currSlide = void 0;
        this.events = new B();
        this.animations = new _t();
        this.mainScroll = new dt(this);
        this.gestures = new ht(this);
        this.opener = new Xt(this);
        this.keyboard = new ft(this);
        this.contentLoader = new Vt(this);
      }
      init() {
        if (this.isOpen || this.isDestroying) return false;
        this.isOpen = true;
        this.dispatch('init');
        this.dispatch('beforeOpen');
        this._createMainStructure();
        let t = 'pswp--open';
        if (this.gestures.supportsTouch) t += ' pswp--touch';
        if (this.options.mainClass) t += ' ' + this.options.mainClass;
        if (this.element) this.element.className += ' ' + t;
        this.currIndex = this.options.index || 0;
        this.potentialIndex = this.currIndex;
        this.dispatch('firstUpdate');
        this.scrollWheel = new xt(this);
        if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems())
          this.currIndex = 0;
        if (!this.gestures.supportsTouch) this.mouseDetected();
        this.updateSize();
        this.offset.y = window.pageYOffset;
        this._initialItemData = this.getItemData(this.currIndex);
        this.dispatch('gettingData', {
          index: this.currIndex,
          data: this._initialItemData,
          slide: void 0,
        });
        this._initialThumbBounds = this.getThumbBounds();
        this.dispatch('initialLayout');
        this.on('openingAnimationEnd', () => {
          const { itemHolders: t } = this.mainScroll;
          if (t[0]) {
            t[0].el.style.display = 'block';
            this.setContent(t[0], this.currIndex - 1);
          }
          if (t[2]) {
            t[2].el.style.display = 'block';
            this.setContent(t[2], this.currIndex + 1);
          }
          this.appendHeavy();
          this.contentLoader.updateLazy();
          this.events.add(window, 'resize', this._handlePageResize.bind(this));
          this.events.add(window, 'scroll', this._updatePageScrollOffset.bind(this));
          this.dispatch('bindEvents');
        });
        if (this.mainScroll.itemHolders[1]) this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
        this.dispatch('change');
        this.opener.open();
        this.dispatch('afterInit');
        return true;
      }
      getLoopedIndex(t) {
        const e = this.getNumItems();
        if (this.options.loop) {
          if (t > e - 1) t -= e;
          if (t < 0) t += e;
        }
        return A(t, 0, e - 1);
      }
      appendHeavy() {
        this.mainScroll.itemHolders.forEach((t) => {
          var e;
          (e = t.slide) === null || e === void 0 || e.appendHeavy();
        });
      }
      goTo(t) {
        this.mainScroll.moveIndexBy(this.getLoopedIndex(t) - this.potentialIndex);
      }
      next() {
        this.goTo(this.potentialIndex + 1);
      }
      prev() {
        this.goTo(this.potentialIndex - 1);
      }
      zoomTo(...t) {
        var e;
        (e = this.currSlide) === null || e === void 0 || e.zoomTo(...t);
      }
      toggleZoom() {
        var t;
        (t = this.currSlide) === null || t === void 0 || t.toggleZoom();
      }
      close() {
        if (!this.opener.isOpen || this.isDestroying) return;
        this.isDestroying = true;
        this.dispatch('close');
        this.events.removeAll();
        this.opener.close();
      }
      destroy() {
        var t;
        if (!this.isDestroying) {
          this.options.showHideAnimationType = 'none';
          this.close();
          return;
        }
        this.dispatch('destroy');
        this._listeners = {};
        if (this.scrollWrap) {
          this.scrollWrap.ontouchmove = null;
          this.scrollWrap.ontouchend = null;
        }
        (t = this.element) === null || t === void 0 || t.remove();
        this.mainScroll.itemHolders.forEach((t) => {
          var e;
          (e = t.slide) === null || e === void 0 || e.destroy();
        });
        this.contentLoader.destroy();
        this.events.removeAll();
      }
      refreshSlideContent(t) {
        this.contentLoader.removeByIndex(t);
        this.mainScroll.itemHolders.forEach((e, i) => {
          var n, s;
          let r =
            ((n = (s = this.currSlide) === null || s === void 0 ? void 0 : s.index) !== null && n !== void 0 ? n : 0) -
            1 +
            i;
          if (this.canLoop()) r = this.getLoopedIndex(r);
          if (r === t) {
            this.setContent(e, t, true);
            if (i === 1) {
              var o;
              this.currSlide = e.slide;
              (o = e.slide) === null || o === void 0 || o.setIsActive(true);
            }
          }
        });
        this.dispatch('change');
      }
      setContent(t, e, i) {
        if (this.canLoop()) e = this.getLoopedIndex(e);
        if (t.slide) {
          if (t.slide.index === e && !i) return;
          t.slide.destroy();
          t.slide = void 0;
        }
        if (!this.canLoop() && (e < 0 || e >= this.getNumItems())) return;
        const n = this.getItemData(e);
        t.slide = new X(n, e, this);
        if (e === this.currIndex) this.currSlide = t.slide;
        t.slide.append(t.el);
      }
      getViewportCenterPoint() {
        return { x: this.viewportSize.x / 2, y: this.viewportSize.y / 2 };
      }
      updateSize(t) {
        if (this.isDestroying) return;
        const e = W(this.options, this);
        if (!t && P(e, this._prevViewportSize)) return;
        S(this._prevViewportSize, e);
        this.dispatch('beforeResize');
        S(this.viewportSize, this._prevViewportSize);
        this._updatePageScrollOffset();
        this.dispatch('viewportSize');
        this.mainScroll.resize(this.opener.isOpen);
        if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) this.mouseDetected();
        this.dispatch('resize');
      }
      applyBgOpacity(t) {
        this.bgOpacity = Math.max(t, 0);
        if (this.bg) this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
      }
      mouseDetected() {
        if (!this.hasMouse) {
          var t;
          this.hasMouse = true;
          (t = this.element) === null || t === void 0 || t.classList.add('pswp--has_mouse');
        }
      }
      _handlePageResize() {
        this.updateSize();
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent))
          setTimeout(() => {
            this.updateSize();
          }, 500);
      }
      _updatePageScrollOffset() {
        this.setScrollOffset(0, window.pageYOffset);
      }
      setScrollOffset(t, e) {
        this.offset.x = t;
        this.offset.y = e;
        this.dispatch('updateScrollOffset');
      }
      _createMainStructure() {
        this.element = x('pswp', 'div');
        this.element.setAttribute('tabindex', '-1');
        this.element.setAttribute('role', 'dialog');
        this.template = this.element;
        this.bg = x('pswp__bg', 'div', this.element);
        this.scrollWrap = x('pswp__scroll-wrap', 'section', this.element);
        this.container = x('pswp__container', 'div', this.scrollWrap);
        this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
        this.container.setAttribute('aria-live', 'off');
        this.container.setAttribute('id', 'pswp__items');
        this.mainScroll.appendHolders();
        this.ui = new zt(this);
        this.ui.init();
        (this.options.appendToEl || document.body).appendChild(this.element);
      }
      getThumbBounds() {
        return Ft(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
      }
      canLoop() {
        return this.options.loop && this.getNumItems() > 2;
      }
      _prepareOptions(t) {
        if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
          t.showHideAnimationType = 'none';
          t.zoomAnimationDuration = 0;
        }
        return { ...Gt, ...t };
      }
    }
    function Yt(t, e, i) {
      const n = document.createElement(e);
      if (t) n.className = t;
      if (i) i.appendChild(n);
      return n;
    }
    function Kt(t, e, i) {
      let n = `translate3d(${t}px,${e || 0}px,0)`;
      if (i !== void 0) n += ` scale3d(${i},${i},1)`;
      return n;
    }
    function Qt(t, e, i) {
      t.style.width = typeof e === 'number' ? `${e}px` : e;
      t.style.height = typeof i === 'number' ? `${i}px` : i;
    }
    const Jt = {
      IDLE: 'idle',
      LOADING: 'loading',
      LOADED: 'loaded',
      ERROR: 'error',
    };
    function te(t) {
      return ('button' in t && t.button === 1) || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey;
    }
    function ee(t, e, i = document) {
      let n = [];
      if (t instanceof Element) n = [t];
      else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
      else {
        const s = typeof t === 'string' ? t : e;
        if (s) n = Array.from(i.querySelectorAll(s));
      }
      return n;
    }
    function ie(t) {
      return typeof t === 'function' && t.prototype && t.prototype.goTo;
    }
    function ne() {
      return !!(navigator.vendor && navigator.vendor.match(/apple/i));
    }
    class se {
      constructor(t, e) {
        this.type = t;
        this.defaultPrevented = false;
        if (e) Object.assign(this, e);
      }
      preventDefault() {
        this.defaultPrevented = true;
      }
    }
    class re {
      constructor() {
        this._listeners = {};
        this._filters = {};
        this.pswp = void 0;
        this.options = void 0;
      }
      addFilter(t, e, i = 100) {
        var n, s, r;
        if (!this._filters[t]) this._filters[t] = [];
        (n = this._filters[t]) === null || n === void 0 || n.push({ fn: e, priority: i });
        (s = this._filters[t]) === null || s === void 0 || s.sort((t, e) => t.priority - e.priority);
        (r = this.pswp) === null || r === void 0 || r.addFilter(t, e, i);
      }
      removeFilter(t, e) {
        if (this._filters[t]) this._filters[t] = this._filters[t].filter((t) => t.fn !== e);
        if (this.pswp) this.pswp.removeFilter(t, e);
      }
      applyFilters(t, ...e) {
        var i;
        (i = this._filters[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            e[0] = t.fn.apply(this, e);
          });
        return e[0];
      }
      on(t, e) {
        var i, n;
        if (!this._listeners[t]) this._listeners[t] = [];
        (i = this._listeners[t]) === null || i === void 0 || i.push(e);
        (n = this.pswp) === null || n === void 0 || n.on(t, e);
      }
      off(t, e) {
        var i;
        if (this._listeners[t]) this._listeners[t] = this._listeners[t].filter((t) => e !== t);
        (i = this.pswp) === null || i === void 0 || i.off(t, e);
      }
      dispatch(t, e) {
        var i;
        if (this.pswp) return this.pswp.dispatch(t, e);
        const n = new se(t, e);
        (i = this._listeners[t]) === null ||
          i === void 0 ||
          i.forEach((t) => {
            t.call(this, n);
          });
        return n;
      }
    }
    class oe {
      constructor(t, e) {
        this.element = Yt('pswp__img pswp__img--placeholder', t ? 'img' : 'div', e);
        if (t) {
          const e = this.element;
          e.decoding = 'async';
          e.alt = '';
          e.src = t;
          e.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.element.tagName === 'IMG') {
          Qt(this.element, 250, 'auto');
          this.element.style.transformOrigin = '0 0';
          this.element.style.transform = Kt(0, 0, t / 250);
        } else Qt(this.element, t, e);
      }
      destroy() {
        var t;
        if ((t = this.element) !== null && t !== void 0 && t.parentNode) this.element.remove();
        this.element = null;
      }
    }
    class ae {
      constructor(t, e, i) {
        this.instance = e;
        this.data = t;
        this.index = i;
        this.element = void 0;
        this.placeholder = void 0;
        this.slide = void 0;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        this.state = Jt.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', { content: this });
      }
      removePlaceholder() {
        if (this.placeholder && !this.keepPlaceholder())
          setTimeout(() => {
            if (this.placeholder) {
              this.placeholder.destroy();
              this.placeholder = void 0;
            }
          }, 1e3);
      }
      load(t, e) {
        if (this.slide && this.usePlaceholder())
          if (!this.placeholder) {
            const t = this.instance.applyFilters(
              'placeholderSrc',
              this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false,
              this
            );
            this.placeholder = new oe(t, this.slide.container);
          } else {
            const t = this.placeholder.element;
            if (t && !t.parentElement) this.slide.container.prepend(t);
          }
        if (this.element && !e) return;
        if (this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented) return;
        if (this.isImageContent()) {
          this.element = Yt('pswp__img', 'img');
          if (this.displayedImageWidth) this.loadImage(t);
        } else {
          this.element = Yt('pswp__content', 'div');
          this.element.innerHTML = this.data.html || '';
        }
        if (e && this.slide) this.slide.updateContentSize(true);
      }
      loadImage(t) {
        var e, i;
        if (
          !this.isImageContent() ||
          !this.element ||
          this.instance.dispatch('contentLoadImage', {
            content: this,
            isLazy: t,
          }).defaultPrevented
        )
          return;
        const n = this.element;
        this.updateSrcsetSizes();
        if (this.data.srcset) n.srcset = this.data.srcset;
        n.src = (e = this.data.src) !== null && e !== void 0 ? e : '';
        n.alt = (i = this.data.alt) !== null && i !== void 0 ? i : '';
        this.state = Jt.LOADING;
        if (n.complete) this.onLoaded();
        else {
          n.onload = () => {
            this.onLoaded();
          };
          n.onerror = () => {
            this.onError();
          };
        }
      }
      setSlide(t) {
        this.slide = t;
        this.hasSlide = true;
        this.instance = t.pswp;
      }
      onLoaded() {
        this.state = Jt.LOADED;
        if (this.slide && this.element) {
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            content: this,
          });
          if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
            this.append();
            this.slide.updateContentSize(true);
          }
          if (this.state === Jt.LOADED || this.state === Jt.ERROR) this.removePlaceholder();
        }
      }
      onError() {
        this.state = Jt.ERROR;
        if (this.slide) {
          this.displayError();
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: true,
            content: this,
          });
          this.instance.dispatch('loadError', {
            slide: this.slide,
            content: this,
          });
        }
      }
      isLoading() {
        return this.instance.applyFilters('isContentLoading', this.state === Jt.LOADING, this);
      }
      isError() {
        return this.state === Jt.ERROR;
      }
      isImageContent() {
        return this.type === 'image';
      }
      setDisplayedSize(t, e) {
        if (!this.element) return;
        if (this.placeholder) this.placeholder.setDisplayedSize(t, e);
        if (
          this.instance.dispatch('contentResize', {
            content: this,
            width: t,
            height: e,
          }).defaultPrevented
        )
          return;
        Qt(this.element, t, e);
        if (this.isImageContent() && !this.isError()) {
          const i = !this.displayedImageWidth && t;
          this.displayedImageWidth = t;
          this.displayedImageHeight = e;
          if (i) this.loadImage(false);
          else this.updateSrcsetSizes();
          if (this.slide)
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width: t,
              height: e,
              content: this,
            });
        }
      }
      isZoomable() {
        return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== Jt.ERROR, this);
      }
      updateSrcsetSizes() {
        if (!this.isImageContent() || !this.element || !this.data.srcset) return;
        const t = this.element;
        const e = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
        if (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) {
          t.sizes = e + 'px';
          t.dataset.largestUsedSize = String(e);
        }
      }
      usePlaceholder() {
        return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
      }
      lazyLoad() {
        if (this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented) return;
        this.load(true);
      }
      keepPlaceholder() {
        return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
      }
      destroy() {
        this.hasSlide = false;
        this.slide = void 0;
        if (this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented) return;
        this.remove();
        if (this.placeholder) {
          this.placeholder.destroy();
          this.placeholder = void 0;
        }
        if (this.isImageContent() && this.element) {
          this.element.onload = null;
          this.element.onerror = null;
          this.element = void 0;
        }
      }
      displayError() {
        if (this.slide) {
          var t, e;
          let i = Yt('pswp__error-msg', 'div');
          i.innerText =
            (t = (e = this.instance.options) === null || e === void 0 ? void 0 : e.errorMsg) !== null && t !== void 0
              ? t
              : '';
          i = this.instance.applyFilters('contentErrorElement', i, this);
          this.element = Yt('pswp__content pswp__error-msg-container', 'div');
          this.element.appendChild(i);
          this.slide.container.innerText = '';
          this.slide.container.appendChild(this.element);
          this.slide.updateContentSize(true);
          this.removePlaceholder();
        }
      }
      append() {
        if (this.isAttached || !this.element) return;
        this.isAttached = true;
        if (this.state === Jt.ERROR) {
          this.displayError();
          return;
        }
        if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
        const t = 'decode' in this.element;
        if (this.isImageContent())
          if (t && this.slide && (!this.slide.isActive || ne())) {
            this.isDecoding = true;
            this.element
              .decode()
              .catch(() => {})
              .finally(() => {
                this.isDecoding = false;
                this.appendImage();
              });
          } else this.appendImage();
        else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
      }
      activate() {
        if (this.instance.dispatch('contentActivate', { content: this }).defaultPrevented || !this.slide) return;
        if (this.isImageContent() && this.isDecoding && !ne()) this.appendImage();
        else if (this.isError()) this.load(false, true);
        if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
      }
      deactivate() {
        this.instance.dispatch('contentDeactivate', { content: this });
        if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'true');
      }
      remove() {
        this.isAttached = false;
        if (this.instance.dispatch('contentRemove', { content: this }).defaultPrevented) return;
        if (this.element && this.element.parentNode) this.element.remove();
        if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
      }
      appendImage() {
        if (!this.isAttached) return;
        if (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented) return;
        if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
        if (this.state === Jt.LOADED || this.state === Jt.ERROR) this.removePlaceholder();
      }
    }
    function le(t, e) {
      if (t.getViewportSizeFn) {
        const i = t.getViewportSizeFn(t, e);
        if (i) return i;
      }
      return { x: document.documentElement.clientWidth, y: window.innerHeight };
    }
    function he(t, e, i, n, s) {
      let r = 0;
      if (e.paddingFn) r = e.paddingFn(i, n, s)[t];
      else if (e.padding) r = e.padding[t];
      else {
        const i = 'padding' + t[0].toUpperCase() + t.slice(1);
        if (e[i]) r = e[i];
      }
      return Number(r) || 0;
    }
    function ce(t, e, i, n) {
      return {
        x: e.x - he('left', t, e, i, n) - he('right', t, e, i, n),
        y: e.y - he('top', t, e, i, n) - he('bottom', t, e, i, n),
      };
    }
    const de = 4e3;
    class ue {
      constructor(t, e, i, n) {
        this.pswp = n;
        this.options = t;
        this.itemData = e;
        this.index = i;
        this.panAreaSize = null;
        this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
      }
      update(t, e, i) {
        const n = { x: t, y: e };
        this.elementSize = n;
        this.panAreaSize = i;
        const s = i.x / n.x;
        const r = i.y / n.y;
        this.fit = Math.min(1, s < r ? s : r);
        this.fill = Math.min(1, s > r ? s : r);
        this.vFill = Math.min(1, r);
        this.initial = this._getInitial();
        this.secondary = this._getSecondary();
        this.max = Math.max(this.initial, this.secondary, this._getMax());
        this.min = Math.min(this.fit, this.initial, this.secondary);
        if (this.pswp)
          this.pswp.dispatch('zoomLevelsUpdate', {
            zoomLevels: this,
            slideData: this.itemData,
          });
      }
      _parseZoomLevelOption(t) {
        const e = t + 'ZoomLevel';
        const i = this.options[e];
        if (!i) return;
        if (typeof i === 'function') return i(this);
        if (i === 'fill') return this.fill;
        if (i === 'fit') return this.fit;
        return Number(i);
      }
      _getSecondary() {
        let t = this._parseZoomLevelOption('secondary');
        if (t) return t;
        t = Math.min(1, this.fit * 3);
        if (this.elementSize && t * this.elementSize.x > de) t = de / this.elementSize.x;
        return t;
      }
      _getInitial() {
        return this._parseZoomLevelOption('initial') || this.fit;
      }
      _getMax() {
        return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
      }
    }
    function pe(t, e, i) {
      const n = e.createContentFromData(t, i);
      let s;
      const { options: r } = e;
      if (r) {
        s = new ue(r, t, -1);
        let o;
        if (e.pswp) o = e.pswp.viewportSize;
        else o = le(r, e);
        const a = ce(r, o, t, i);
        s.update(n.width, n.height, a);
      }
      n.lazyLoad();
      if (s) n.setDisplayedSize(Math.ceil(n.width * s.initial), Math.ceil(n.height * s.initial));
      return n;
    }
    function fe(t, e) {
      const i = e.getItemData(t);
      if (e.dispatch('lazyLoadSlide', { index: t, itemData: i }).defaultPrevented) return;
      return pe(i, e, t);
    }
    class ve extends re {
      getNumItems() {
        var t;
        let e = 0;
        const i = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
        if (i && 'length' in i) e = i.length;
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          if (i.items) e = i.items.length;
        }
        const n = this.dispatch('numItems', { dataSource: i, numItems: e });
        return this.applyFilters('numItems', n.numItems, i);
      }
      createContentFromData(t, e) {
        return new ae(t, this, e);
      }
      getItemData(t) {
        var e;
        const i = (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
        let n = {};
        if (Array.isArray(i)) n = i[t];
        else if (i && 'gallery' in i) {
          if (!i.items) i.items = this._getGalleryDOMElements(i.gallery);
          n = i.items[t];
        }
        let s = n;
        if (s instanceof Element) s = this._domElementToItemData(s);
        const r = this.dispatch('itemData', { itemData: s || {}, index: t });
        return this.applyFilters('itemData', r.itemData, t);
      }
      _getGalleryDOMElements(t) {
        var e, i;
        if (
          ((e = this.options) !== null && e !== void 0 && e.children) ||
          ((i = this.options) !== null && i !== void 0 && i.childSelector)
        )
          return ee(this.options.children, this.options.childSelector, t) || [];
        return [t];
      }
      _domElementToItemData(t) {
        const e = { element: t };
        const i = t.tagName === 'A' ? t : t.querySelector('a');
        if (i) {
          e.src = i.dataset.pswpSrc || i.href;
          if (i.dataset.pswpSrcset) e.srcset = i.dataset.pswpSrcset;
          e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0;
          e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0;
          e.w = e.width;
          e.h = e.height;
          if (i.dataset.pswpType) e.type = i.dataset.pswpType;
          const s = t.querySelector('img');
          if (s) {
            var n;
            e.msrc = s.currentSrc || s.src;
            e.alt = (n = s.getAttribute('alt')) !== null && n !== void 0 ? n : '';
          }
          if (i.dataset.pswpCropped || i.dataset.cropped) e.thumbCropped = true;
        }
        return this.applyFilters('domItemData', e, t, i);
      }
      lazyLoadData(t, e) {
        return pe(t, this, e);
      }
    }
    class me extends ve {
      constructor(t) {
        super();
        this.options = t || {};
        this._uid = 0;
        this.shouldOpen = false;
        this._preloadedContent = void 0;
        this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
      }
      init() {
        ee(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.addEventListener('click', this.onThumbnailsClick, false);
        });
      }
      onThumbnailsClick(t) {
        if (te(t) || window.pswp) return;
        let e = { x: t.clientX, y: t.clientY };
        if (!e.x && !e.y) e = null;
        let i = this.getClickedIndex(t);
        i = this.applyFilters('clickedIndex', i, t, this);
        const n = { gallery: t.currentTarget };
        if (i >= 0) {
          t.preventDefault();
          this.loadAndOpen(i, n, e);
        }
      }
      getClickedIndex(t) {
        if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
        const e = t.target;
        const i = ee(this.options.children, this.options.childSelector, t.currentTarget);
        const n = i.findIndex((t) => t === e || t.contains(e));
        if (n !== -1) return n;
        else if (this.options.children || this.options.childSelector) return -1;
        return 0;
      }
      loadAndOpen(t, e, i) {
        if (window.pswp || !this.options) return false;
        if (!e && this.options.gallery && this.options.children) {
          const t = ee(this.options.gallery);
          if (t[0]) e = { gallery: t[0] };
        }
        this.options.index = t;
        this.options.initialPointerPos = i;
        this.shouldOpen = true;
        this.preload(t, e);
        return true;
      }
      preload(t, e) {
        const { options: i } = this;
        if (e) i.dataSource = e;
        const n = [];
        const s = typeof i.pswpModule;
        if (ie(i.pswpModule)) n.push(Promise.resolve(i.pswpModule));
        else if (s === 'string') throw new Error('pswpModule as string is no longer supported');
        else if (s === 'function') n.push(i.pswpModule());
        else throw new Error('pswpModule is not valid');
        if (typeof i.openPromise === 'function') n.push(i.openPromise());
        if (i.preloadFirstSlide !== false && t >= 0) this._preloadedContent = fe(t, this);
        const r = ++this._uid;
        Promise.all(n).then((t) => {
          if (this.shouldOpen) {
            const e = t[0];
            this._openPhotoswipe(e, r);
          }
        });
      }
      _openPhotoswipe(t, e) {
        if (e !== this._uid && this.shouldOpen) return;
        this.shouldOpen = false;
        if (window.pswp) return;
        const i = typeof t === 'object' ? new t.default(this.options) : new t(this.options);
        this.pswp = i;
        window.pswp = i;
        Object.keys(this._listeners).forEach((t) => {
          var e;
          (e = this._listeners[t]) === null ||
            e === void 0 ||
            e.forEach((e) => {
              i.on(t, e);
            });
        });
        Object.keys(this._filters).forEach((t) => {
          var e;
          (e = this._filters[t]) === null ||
            e === void 0 ||
            e.forEach((e) => {
              i.addFilter(t, e.fn, e.priority);
            });
        });
        if (this._preloadedContent) {
          i.contentLoader.addToCache(this._preloadedContent);
          this._preloadedContent = void 0;
        }
        i.on('destroy', () => {
          this.pswp = void 0;
          delete window.pswp;
        });
        i.init();
      }
      destroy() {
        var t;
        (t = this.pswp) === null || t === void 0 || t.destroy();
        this.shouldOpen = false;
        this._listeners = {};
        ee(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.removeEventListener('click', this.onThumbnailsClick, false);
        });
      }
    }
    function ge(t) {
      if (t == null) return window;
      if (t.toString() !== '[object Window]') {
        var e = t.ownerDocument;
        return e ? e.defaultView || window : window;
      }
      return t;
    }
    function ye(t) {
      var e = ge(t).Element;
      return t instanceof e || t instanceof Element;
    }
    function we(t) {
      var e = ge(t).HTMLElement;
      return t instanceof e || t instanceof HTMLElement;
    }
    function be(t) {
      if (typeof ShadowRoot === 'undefined') return false;
      var e = ge(t).ShadowRoot;
      return t instanceof e || t instanceof ShadowRoot;
    }
    var _e = Math.max;
    var xe = Math.min;
    var Se = Math.round;
    function Ce() {
      var t = navigator.userAgentData;
      if (t != null && t.brands && Array.isArray(t.brands))
        return t.brands
          .map(function (t) {
            return t.brand + '/' + t.version;
          })
          .join(' ');
      return navigator.userAgent;
    }
    function Ee() {
      return !/^((?!chrome|android).)*safari/i.test(Ce());
    }
    function Pe(t, e, i) {
      if (e === void 0) e = false;
      if (i === void 0) i = false;
      var n = t.getBoundingClientRect();
      var s = 1;
      var r = 1;
      if (e && we(t)) {
        s = t.offsetWidth > 0 ? Se(n.width) / t.offsetWidth || 1 : 1;
        r = t.offsetHeight > 0 ? Se(n.height) / t.offsetHeight || 1 : 1;
      }
      var o = ye(t) ? ge(t) : window,
        a = o.visualViewport;
      var l = !Ee() && i;
      var h = (n.left + (l && a ? a.offsetLeft : 0)) / s;
      var c = (n.top + (l && a ? a.offsetTop : 0)) / r;
      var d = n.width / s;
      var u = n.height / r;
      return {
        width: d,
        height: u,
        top: c,
        right: h + d,
        bottom: c + u,
        left: h,
        x: h,
        y: c,
      };
    }
    function Ae(t) {
      var e = ge(t);
      var i = e.pageXOffset;
      var n = e.pageYOffset;
      return { scrollLeft: i, scrollTop: n };
    }
    function De(t) {
      return { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop };
    }
    function Le(t) {
      if (t === ge(t) || !we(t)) return Ae(t);
      else return De(t);
    }
    function Oe(t) {
      return t ? (t.nodeName || '').toLowerCase() : null;
    }
    function Ie(t) {
      return ((ye(t) ? t.ownerDocument : t.document) || window.document).documentElement;
    }
    function Te(t) {
      return Pe(Ie(t)).left + Ae(t).scrollLeft;
    }
    function ze(t) {
      return ge(t).getComputedStyle(t);
    }
    function Me(t) {
      var e = ze(t),
        i = e.overflow,
        n = e.overflowX,
        s = e.overflowY;
      return /auto|scroll|overlay|hidden/.test(i + s + n);
    }
    function ke(t) {
      var e = t.getBoundingClientRect();
      var i = Se(e.width) / t.offsetWidth || 1;
      var n = Se(e.height) / t.offsetHeight || 1;
      return i !== 1 || n !== 1;
    }
    function Fe(t, e, i) {
      if (i === void 0) i = false;
      var n = we(e);
      var s = we(e) && ke(e);
      var r = Ie(e);
      var o = Pe(t, s, i);
      var a = { scrollLeft: 0, scrollTop: 0 };
      var l = { x: 0, y: 0 };
      if (n || (!n && !i)) {
        if (Oe(e) !== 'body' || Me(r)) a = Le(e);
        if (we(e)) {
          l = Pe(e, true);
          l.x += e.clientLeft;
          l.y += e.clientTop;
        } else if (r) l.x = Te(r);
      }
      return {
        x: o.left + a.scrollLeft - l.x,
        y: o.top + a.scrollTop - l.y,
        width: o.width,
        height: o.height,
      };
    }
    function Re(t) {
      var e = Pe(t);
      var i = t.offsetWidth;
      var n = t.offsetHeight;
      if (Math.abs(e.width - i) <= 1) i = e.width;
      if (Math.abs(e.height - n) <= 1) n = e.height;
      return { x: t.offsetLeft, y: t.offsetTop, width: i, height: n };
    }
    function Ne(t) {
      if (Oe(t) === 'html') return t;
      return t.assignedSlot || t.parentNode || (be(t) ? t.host : null) || Ie(t);
    }
    function Ze(t) {
      if (['html', 'body', '#document'].indexOf(Oe(t)) >= 0) return t.ownerDocument.body;
      if (we(t) && Me(t)) return t;
      return Ze(Ne(t));
    }
    function Be(t, e) {
      var i;
      if (e === void 0) e = [];
      var n = Ze(t);
      var s = n === ((i = t.ownerDocument) == null ? void 0 : i.body);
      var r = ge(n);
      var o = s ? [r].concat(r.visualViewport || [], Me(n) ? n : []) : n;
      var a = e.concat(o);
      return s ? a : a.concat(Be(Ne(o)));
    }
    function We(t) {
      return ['table', 'td', 'th'].indexOf(Oe(t)) >= 0;
    }
    function He(t) {
      if (!we(t) || ze(t).position === 'fixed') return null;
      return t.offsetParent;
    }
    function je(t) {
      var e = /firefox/i.test(Ce());
      var i = /Trident/i.test(Ce());
      if (i && we(t)) {
        var n = ze(t);
        if (n.position === 'fixed') return null;
      }
      var s = Ne(t);
      if (be(s)) s = s.host;
      while (we(s) && ['html', 'body'].indexOf(Oe(s)) < 0) {
        var r = ze(s);
        if (
          r.transform !== 'none' ||
          r.perspective !== 'none' ||
          r.contain === 'paint' ||
          ['transform', 'perspective'].indexOf(r.willChange) !== -1 ||
          (e && r.willChange === 'filter') ||
          (e && r.filter && r.filter !== 'none')
        )
          return s;
        else s = s.parentNode;
      }
      return null;
    }
    function Ve(t) {
      var e = ge(t);
      var i = He(t);
      while (i && We(i) && ze(i).position === 'static') i = He(i);
      if (i && (Oe(i) === 'html' || (Oe(i) === 'body' && ze(i).position === 'static'))) return e;
      return i || je(t) || e;
    }
    var Ue = 'top';
    var qe = 'bottom';
    var Xe = 'right';
    var Ge = 'left';
    var $e = 'auto';
    var Ye = [Ue, qe, Xe, Ge];
    var Ke = 'start';
    var Qe = 'end';
    var Je = 'clippingParents';
    var ti = 'viewport';
    var ei = 'popper';
    var ii = 'reference';
    var ni = Ye.reduce(function (t, e) {
      return t.concat([e + '-' + Ke, e + '-' + Qe]);
    }, []);
    var si = [].concat(Ye, [$e]).reduce(function (t, e) {
      return t.concat([e, e + '-' + Ke, e + '-' + Qe]);
    }, []);
    var ri = 'beforeRead';
    var oi = 'read';
    var ai = 'afterRead';
    var li = 'beforeMain';
    var hi = 'main';
    var ci = 'afterMain';
    var di = 'beforeWrite';
    var ui = 'write';
    var pi = 'afterWrite';
    var fi = [ri, oi, ai, li, hi, ci, di, ui, pi];
    function vi(t) {
      var e = new Map();
      var i = new Set();
      var n = [];
      t.forEach(function (t) {
        e.set(t.name, t);
      });
      function s(t) {
        i.add(t.name);
        var r = [].concat(t.requires || [], t.requiresIfExists || []);
        r.forEach(function (t) {
          if (!i.has(t)) {
            var n = e.get(t);
            if (n) s(n);
          }
        });
        n.push(t);
      }
      t.forEach(function (t) {
        if (!i.has(t.name)) s(t);
      });
      return n;
    }
    function mi(t) {
      var e = vi(t);
      return fi.reduce(function (t, i) {
        return t.concat(
          e.filter(function (t) {
            return t.phase === i;
          })
        );
      }, []);
    }
    function gi(t) {
      var e;
      return function () {
        if (!e)
          e = new Promise(function (i) {
            Promise.resolve().then(function () {
              e = void 0;
              i(t());
            });
          });
        return e;
      };
    }
    function yi(t) {
      var e = t.reduce(function (t, e) {
        var i = t[e.name];
        t[e.name] = i
          ? Object.assign({}, i, e, {
              options: Object.assign({}, i.options, e.options),
              data: Object.assign({}, i.data, e.data),
            })
          : e;
        return t;
      }, {});
      return Object.keys(e).map(function (t) {
        return e[t];
      });
    }
    var wi = { placement: 'bottom', modifiers: [], strategy: 'absolute' };
    function bi() {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
      return !e.some(function (t) {
        return !(t && typeof t.getBoundingClientRect === 'function');
      });
    }
    function _i(t) {
      if (t === void 0) t = {};
      var e = t,
        i = e.defaultModifiers,
        n = i === void 0 ? [] : i,
        s = e.defaultOptions,
        r = s === void 0 ? wi : s;
      return function t(e, i, s) {
        if (s === void 0) s = r;
        var o = {
          placement: 'bottom',
          orderedModifiers: [],
          options: Object.assign({}, wi, r),
          modifiersData: {},
          elements: { reference: e, popper: i },
          attributes: {},
          styles: {},
        };
        var a = [];
        var l = false;
        var h = {
          state: o,
          setOptions: function t(s) {
            var a = typeof s === 'function' ? s(o.options) : s;
            d();
            o.options = Object.assign({}, r, o.options, a);
            o.scrollParents = {
              reference: ye(e) ? Be(e) : e.contextElement ? Be(e.contextElement) : [],
              popper: Be(i),
            };
            var l = mi(yi([].concat(n, o.options.modifiers)));
            o.orderedModifiers = l.filter(function (t) {
              return t.enabled;
            });
            c();
            return h.update();
          },
          forceUpdate: function t() {
            if (l) return;
            var e = o.elements,
              i = e.reference,
              n = e.popper;
            if (!bi(i, n)) return;
            o.rects = {
              reference: Fe(i, Ve(n), o.options.strategy === 'fixed'),
              popper: Re(n),
            };
            o.reset = false;
            o.placement = o.options.placement;
            o.orderedModifiers.forEach(function (t) {
              return (o.modifiersData[t.name] = Object.assign({}, t.data));
            });
            for (var s = 0; s < o.orderedModifiers.length; s++) {
              if (o.reset === true) {
                o.reset = false;
                s = -1;
                continue;
              }
              var r = o.orderedModifiers[s],
                a = r.fn,
                c = r.options,
                d = c === void 0 ? {} : c,
                u = r.name;
              if (typeof a === 'function') o = a({ state: o, options: d, name: u, instance: h }) || o;
            }
          },
          update: gi(function () {
            return new Promise(function (t) {
              h.forceUpdate();
              t(o);
            });
          }),
          destroy: function t() {
            d();
            l = true;
          },
        };
        if (!bi(e, i)) return h;
        h.setOptions(s).then(function (t) {
          if (!l && s.onFirstUpdate) s.onFirstUpdate(t);
        });
        function c() {
          o.orderedModifiers.forEach(function (t) {
            var e = t.name,
              i = t.options,
              n = i === void 0 ? {} : i,
              s = t.effect;
            if (typeof s === 'function') {
              var r = s({ state: o, name: e, instance: h, options: n });
              var l = function t() {};
              a.push(r || l);
            }
          });
        }
        function d() {
          a.forEach(function (t) {
            return t();
          });
          a = [];
        }
        return h;
      };
    }
    var xi = null && _i();
    var Si = { passive: true };
    function Ci(t) {
      var e = t.state,
        i = t.instance,
        n = t.options;
      var s = n.scroll,
        r = s === void 0 ? true : s,
        o = n.resize,
        a = o === void 0 ? true : o;
      var l = ge(e.elements.popper);
      var h = [].concat(e.scrollParents.reference, e.scrollParents.popper);
      if (r)
        h.forEach(function (t) {
          t.addEventListener('scroll', i.update, Si);
        });
      if (a) l.addEventListener('resize', i.update, Si);
      return function () {
        if (r)
          h.forEach(function (t) {
            t.removeEventListener('scroll', i.update, Si);
          });
        if (a) l.removeEventListener('resize', i.update, Si);
      };
    }
    const Ei = {
      name: 'eventListeners',
      enabled: true,
      phase: 'write',
      fn: function t() {},
      effect: Ci,
      data: {},
    };
    function Pi(t) {
      return t.split('-')[0];
    }
    function Ai(t) {
      return t.split('-')[1];
    }
    function Di(t) {
      return ['top', 'bottom'].indexOf(t) >= 0 ? 'x' : 'y';
    }
    function Li(t) {
      var e = t.reference,
        i = t.element,
        n = t.placement;
      var s = n ? Pi(n) : null;
      var r = n ? Ai(n) : null;
      var o = e.x + e.width / 2 - i.width / 2;
      var a = e.y + e.height / 2 - i.height / 2;
      var l;
      switch (s) {
        case Ue:
          l = { x: o, y: e.y - i.height };
          break;
        case qe:
          l = { x: o, y: e.y + e.height };
          break;
        case Xe:
          l = { x: e.x + e.width, y: a };
          break;
        case Ge:
          l = { x: e.x - i.width, y: a };
          break;
        default:
          l = { x: e.x, y: e.y };
      }
      var h = s ? Di(s) : null;
      if (h != null) {
        var c = h === 'y' ? 'height' : 'width';
        switch (r) {
          case Ke:
            l[h] = l[h] - (e[c] / 2 - i[c] / 2);
            break;
          case Qe:
            l[h] = l[h] + (e[c] / 2 - i[c] / 2);
            break;
          default:
        }
      }
      return l;
    }
    function Oi(t) {
      var e = t.state,
        i = t.name;
      e.modifiersData[i] = Li({
        reference: e.rects.reference,
        element: e.rects.popper,
        strategy: 'absolute',
        placement: e.placement,
      });
    }
    const Ii = {
      name: 'popperOffsets',
      enabled: true,
      phase: 'read',
      fn: Oi,
      data: {},
    };
    var Ti = { top: 'auto', right: 'auto', bottom: 'auto', left: 'auto' };
    function zi(t, e) {
      var i = t.x,
        n = t.y;
      var s = e.devicePixelRatio || 1;
      return { x: Se(i * s) / s || 0, y: Se(n * s) / s || 0 };
    }
    function Mi(t) {
      var e;
      var i = t.popper,
        n = t.popperRect,
        s = t.placement,
        r = t.variation,
        o = t.offsets,
        a = t.position,
        l = t.gpuAcceleration,
        h = t.adaptive,
        c = t.roundOffsets,
        d = t.isFixed;
      var u = o.x,
        p = u === void 0 ? 0 : u,
        f = o.y,
        v = f === void 0 ? 0 : f;
      var m = typeof c === 'function' ? c({ x: p, y: v }) : { x: p, y: v };
      p = m.x;
      v = m.y;
      var g = o.hasOwnProperty('x');
      var y = o.hasOwnProperty('y');
      var w = Ge;
      var b = Ue;
      var _ = window;
      if (h) {
        var x = Ve(i);
        var S = 'clientHeight';
        var C = 'clientWidth';
        if (x === ge(i)) {
          x = Ie(i);
          if (ze(x).position !== 'static' && a === 'absolute') {
            S = 'scrollHeight';
            C = 'scrollWidth';
          }
        }
        x;
        if (s === Ue || ((s === Ge || s === Xe) && r === Qe)) {
          b = qe;
          var E = d && x === _ && _.visualViewport ? _.visualViewport.height : x[S];
          v -= E - n.height;
          v *= l ? 1 : -1;
        }
        if (s === Ge || ((s === Ue || s === qe) && r === Qe)) {
          w = Xe;
          var P = d && x === _ && _.visualViewport ? _.visualViewport.width : x[C];
          p -= P - n.width;
          p *= l ? 1 : -1;
        }
      }
      var A = Object.assign({ position: a }, h && Ti);
      var D = c === true ? zi({ x: p, y: v }, ge(i)) : { x: p, y: v };
      p = D.x;
      v = D.y;
      if (l) {
        var L;
        return Object.assign(
          {},
          A,
          ((L = {}),
          (L[b] = y ? '0' : ''),
          (L[w] = g ? '0' : ''),
          (L.transform =
            (_.devicePixelRatio || 1) <= 1
              ? 'translate(' + p + 'px, ' + v + 'px)'
              : 'translate3d(' + p + 'px, ' + v + 'px, 0)'),
          L)
        );
      }
      return Object.assign(
        {},
        A,
        ((e = {}), (e[b] = y ? v + 'px' : ''), (e[w] = g ? p + 'px' : ''), (e.transform = ''), e)
      );
    }
    function ki(t) {
      var e = t.state,
        i = t.options;
      var n = i.gpuAcceleration,
        s = n === void 0 ? true : n,
        r = i.adaptive,
        o = r === void 0 ? true : r,
        a = i.roundOffsets,
        l = a === void 0 ? true : a;
      var h = {
        placement: Pi(e.placement),
        variation: Ai(e.placement),
        popper: e.elements.popper,
        popperRect: e.rects.popper,
        gpuAcceleration: s,
        isFixed: e.options.strategy === 'fixed',
      };
      if (e.modifiersData.popperOffsets != null)
        e.styles.popper = Object.assign(
          {},
          e.styles.popper,
          Mi(
            Object.assign({}, h, {
              offsets: e.modifiersData.popperOffsets,
              position: e.options.strategy,
              adaptive: o,
              roundOffsets: l,
            })
          )
        );
      if (e.modifiersData.arrow != null)
        e.styles.arrow = Object.assign(
          {},
          e.styles.arrow,
          Mi(
            Object.assign({}, h, {
              offsets: e.modifiersData.arrow,
              position: 'absolute',
              adaptive: false,
              roundOffsets: l,
            })
          )
        );
      e.attributes.popper = Object.assign({}, e.attributes.popper, {
        'data-popper-placement': e.placement,
      });
    }
    const Fi = {
      name: 'computeStyles',
      enabled: true,
      phase: 'beforeWrite',
      fn: ki,
      data: {},
    };
    function Ri(t) {
      var e = t.state;
      Object.keys(e.elements).forEach(function (t) {
        var i = e.styles[t] || {};
        var n = e.attributes[t] || {};
        var s = e.elements[t];
        if (!we(s) || !Oe(s)) return;
        Object.assign(s.style, i);
        Object.keys(n).forEach(function (t) {
          var e = n[t];
          if (e === false) s.removeAttribute(t);
          else s.setAttribute(t, e === true ? '' : e);
        });
      });
    }
    function Ni(t) {
      var e = t.state;
      var i = {
        popper: {
          position: e.options.strategy,
          left: '0',
          top: '0',
          margin: '0',
        },
        arrow: { position: 'absolute' },
        reference: {},
      };
      Object.assign(e.elements.popper.style, i.popper);
      e.styles = i;
      if (e.elements.arrow) Object.assign(e.elements.arrow.style, i.arrow);
      return function () {
        Object.keys(e.elements).forEach(function (t) {
          var n = e.elements[t];
          var s = e.attributes[t] || {};
          var r = Object.keys(e.styles.hasOwnProperty(t) ? e.styles[t] : i[t]);
          var o = r.reduce(function (t, e) {
            t[e] = '';
            return t;
          }, {});
          if (!we(n) || !Oe(n)) return;
          Object.assign(n.style, o);
          Object.keys(s).forEach(function (t) {
            n.removeAttribute(t);
          });
        });
      };
    }
    const Zi = {
      name: 'applyStyles',
      enabled: true,
      phase: 'write',
      fn: Ri,
      effect: Ni,
      requires: ['computeStyles'],
    };
    function Bi(t, e, i) {
      var n = Pi(t);
      var s = [Ge, Ue].indexOf(n) >= 0 ? -1 : 1;
      var r = typeof i === 'function' ? i(Object.assign({}, e, { placement: t })) : i,
        o = r[0],
        a = r[1];
      o = o || 0;
      a = (a || 0) * s;
      return [Ge, Xe].indexOf(n) >= 0 ? { x: a, y: o } : { x: o, y: a };
    }
    function Wi(t) {
      var e = t.state,
        i = t.options,
        n = t.name;
      var s = i.offset,
        r = s === void 0 ? [0, 0] : s;
      var o = si.reduce(function (t, i) {
        t[i] = Bi(i, e.rects, r);
        return t;
      }, {});
      var a = o[e.placement],
        l = a.x,
        h = a.y;
      if (e.modifiersData.popperOffsets != null) {
        e.modifiersData.popperOffsets.x += l;
        e.modifiersData.popperOffsets.y += h;
      }
      e.modifiersData[n] = o;
    }
    const Hi = {
      name: 'offset',
      enabled: true,
      phase: 'main',
      requires: ['popperOffsets'],
      fn: Wi,
    };
    var ji = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
    function Vi(t) {
      return t.replace(/left|right|bottom|top/g, function (t) {
        return ji[t];
      });
    }
    var Ui = { start: 'end', end: 'start' };
    function qi(t) {
      return t.replace(/start|end/g, function (t) {
        return Ui[t];
      });
    }
    function Xi(t, e) {
      var i = ge(t);
      var n = Ie(t);
      var s = i.visualViewport;
      var r = n.clientWidth;
      var o = n.clientHeight;
      var a = 0;
      var l = 0;
      if (s) {
        r = s.width;
        o = s.height;
        var h = Ee();
        if (h || (!h && e === 'fixed')) {
          a = s.offsetLeft;
          l = s.offsetTop;
        }
      }
      return { width: r, height: o, x: a + Te(t), y: l };
    }
    function Gi(t) {
      var e;
      var i = Ie(t);
      var n = Ae(t);
      var s = (e = t.ownerDocument) == null ? void 0 : e.body;
      var r = _e(i.scrollWidth, i.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0);
      var o = _e(i.scrollHeight, i.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0);
      var a = -n.scrollLeft + Te(t);
      var l = -n.scrollTop;
      if (ze(s || i).direction === 'rtl') a += _e(i.clientWidth, s ? s.clientWidth : 0) - r;
      return { width: r, height: o, x: a, y: l };
    }
    function $i(t, e) {
      var i = e.getRootNode && e.getRootNode();
      if (t.contains(e)) return true;
      else if (i && be(i)) {
        var n = e;
        do {
          if (n && t.isSameNode(n)) return true;
          n = n.parentNode || n.host;
        } while (n);
      }
      return false;
    }
    function Yi(t) {
      return Object.assign({}, t, {
        left: t.x,
        top: t.y,
        right: t.x + t.width,
        bottom: t.y + t.height,
      });
    }
    function Ki(t, e) {
      var i = Pe(t, false, e === 'fixed');
      i.top = i.top + t.clientTop;
      i.left = i.left + t.clientLeft;
      i.bottom = i.top + t.clientHeight;
      i.right = i.left + t.clientWidth;
      i.width = t.clientWidth;
      i.height = t.clientHeight;
      i.x = i.left;
      i.y = i.top;
      return i;
    }
    function Qi(t, e, i) {
      return e === ti ? Yi(Xi(t, i)) : ye(e) ? Ki(e, i) : Yi(Gi(Ie(t)));
    }
    function Ji(t) {
      var e = Be(Ne(t));
      var i = ['absolute', 'fixed'].indexOf(ze(t).position) >= 0;
      var n = i && we(t) ? Ve(t) : t;
      if (!ye(n)) return [];
      return e.filter(function (t) {
        return ye(t) && $i(t, n) && Oe(t) !== 'body';
      });
    }
    function tn(t, e, i, n) {
      var s = e === 'clippingParents' ? Ji(t) : [].concat(e);
      var r = [].concat(s, [i]);
      var o = r[0];
      var a = r.reduce(function (e, i) {
        var s = Qi(t, i, n);
        e.top = _e(s.top, e.top);
        e.right = xe(s.right, e.right);
        e.bottom = xe(s.bottom, e.bottom);
        e.left = _e(s.left, e.left);
        return e;
      }, Qi(t, o, n));
      a.width = a.right - a.left;
      a.height = a.bottom - a.top;
      a.x = a.left;
      a.y = a.top;
      return a;
    }
    function en() {
      return { top: 0, right: 0, bottom: 0, left: 0 };
    }
    function nn(t) {
      return Object.assign({}, en(), t);
    }
    function sn(t, e) {
      return e.reduce(function (e, i) {
        e[i] = t;
        return e;
      }, {});
    }
    function rn(t, e) {
      if (e === void 0) e = {};
      var i = e,
        n = i.placement,
        s = n === void 0 ? t.placement : n,
        r = i.strategy,
        o = r === void 0 ? t.strategy : r,
        a = i.boundary,
        l = a === void 0 ? Je : a,
        h = i.rootBoundary,
        c = h === void 0 ? ti : h,
        d = i.elementContext,
        u = d === void 0 ? ei : d,
        p = i.altBoundary,
        f = p === void 0 ? false : p,
        v = i.padding,
        m = v === void 0 ? 0 : v;
      var g = nn(typeof m !== 'number' ? m : sn(m, Ye));
      var y = u === ei ? ii : ei;
      var w = t.rects.popper;
      var b = t.elements[f ? y : u];
      var _ = tn(ye(b) ? b : b.contextElement || Ie(t.elements.popper), l, c, o);
      var x = Pe(t.elements.reference);
      var S = Li({
        reference: x,
        element: w,
        strategy: 'absolute',
        placement: s,
      });
      var C = Yi(Object.assign({}, w, S));
      var E = u === ei ? C : x;
      var P = {
        top: _.top - E.top + g.top,
        bottom: E.bottom - _.bottom + g.bottom,
        left: _.left - E.left + g.left,
        right: E.right - _.right + g.right,
      };
      var A = t.modifiersData.offset;
      if (u === ei && A) {
        var D = A[s];
        Object.keys(P).forEach(function (t) {
          var e = [Xe, qe].indexOf(t) >= 0 ? 1 : -1;
          var i = [Ue, qe].indexOf(t) >= 0 ? 'y' : 'x';
          P[t] += D[i] * e;
        });
      }
      return P;
    }
    function on(t, e) {
      if (e === void 0) e = {};
      var i = e,
        n = i.placement,
        s = i.boundary,
        r = i.rootBoundary,
        o = i.padding,
        a = i.flipVariations,
        l = i.allowedAutoPlacements,
        h = l === void 0 ? si : l;
      var c = Ai(n);
      var d = c
        ? a
          ? ni
          : ni.filter(function (t) {
              return Ai(t) === c;
            })
        : Ye;
      var u = d.filter(function (t) {
        return h.indexOf(t) >= 0;
      });
      if (u.length === 0) u = d;
      var p = u.reduce(function (e, i) {
        e[i] = rn(t, {
          placement: i,
          boundary: s,
          rootBoundary: r,
          padding: o,
        })[Pi(i)];
        return e;
      }, {});
      return Object.keys(p).sort(function (t, e) {
        return p[t] - p[e];
      });
    }
    function an(t) {
      if (Pi(t) === $e) return [];
      var e = Vi(t);
      return [qi(t), e, qi(e)];
    }
    function ln(t) {
      var e = t.state,
        i = t.options,
        n = t.name;
      if (e.modifiersData[n]._skip) return;
      var s = i.mainAxis,
        r = s === void 0 ? true : s,
        o = i.altAxis,
        a = o === void 0 ? true : o,
        l = i.fallbackPlacements,
        h = i.padding,
        c = i.boundary,
        d = i.rootBoundary,
        u = i.altBoundary,
        p = i.flipVariations,
        f = p === void 0 ? true : p,
        v = i.allowedAutoPlacements;
      var m = e.options.placement;
      var g = Pi(m);
      var y = g === m;
      var w = l || (y || !f ? [Vi(m)] : an(m));
      var b = [m].concat(w).reduce(function (t, i) {
        return t.concat(
          Pi(i) === $e
            ? on(e, {
                placement: i,
                boundary: c,
                rootBoundary: d,
                padding: h,
                flipVariations: f,
                allowedAutoPlacements: v,
              })
            : i
        );
      }, []);
      var _ = e.rects.reference;
      var x = e.rects.popper;
      var S = new Map();
      var C = true;
      var E = b[0];
      for (var P = 0; P < b.length; P++) {
        var A = b[P];
        var D = Pi(A);
        var L = Ai(A) === Ke;
        var O = [Ue, qe].indexOf(D) >= 0;
        var I = O ? 'width' : 'height';
        var T = rn(e, {
          placement: A,
          boundary: c,
          rootBoundary: d,
          altBoundary: u,
          padding: h,
        });
        var z = O ? (L ? Xe : Ge) : L ? qe : Ue;
        if (_[I] > x[I]) z = Vi(z);
        var M = Vi(z);
        var k = [];
        if (r) k.push(T[D] <= 0);
        if (a) k.push(T[z] <= 0, T[M] <= 0);
        if (
          k.every(function (t) {
            return t;
          })
        ) {
          E = A;
          C = false;
          break;
        }
        S.set(A, k);
      }
      if (C) {
        var F = f ? 3 : 1;
        var R = function t(e) {
          var i = b.find(function (t) {
            var i = S.get(t);
            if (i)
              return i.slice(0, e).every(function (t) {
                return t;
              });
          });
          if (i) {
            E = i;
            return 'break';
          }
        };
        for (var N = F; N > 0; N--) {
          var Z = R(N);
          if (Z === 'break') break;
        }
      }
      if (e.placement !== E) {
        e.modifiersData[n]._skip = true;
        e.placement = E;
        e.reset = true;
      }
    }
    const hn = {
      name: 'flip',
      enabled: true,
      phase: 'main',
      fn: ln,
      requiresIfExists: ['offset'],
      data: { _skip: false },
    };
    function cn(t) {
      return t === 'x' ? 'y' : 'x';
    }
    function dn(t, e, i) {
      return _e(t, xe(e, i));
    }
    function un(t, e, i) {
      var n = dn(t, e, i);
      return n > i ? i : n;
    }
    function pn(t) {
      var e = t.state,
        i = t.options,
        n = t.name;
      var s = i.mainAxis,
        r = s === void 0 ? true : s,
        o = i.altAxis,
        a = o === void 0 ? false : o,
        l = i.boundary,
        h = i.rootBoundary,
        c = i.altBoundary,
        d = i.padding,
        u = i.tether,
        p = u === void 0 ? true : u,
        f = i.tetherOffset,
        v = f === void 0 ? 0 : f;
      var m = rn(e, {
        boundary: l,
        rootBoundary: h,
        padding: d,
        altBoundary: c,
      });
      var g = Pi(e.placement);
      var y = Ai(e.placement);
      var w = !y;
      var b = Di(g);
      var _ = cn(b);
      var x = e.modifiersData.popperOffsets;
      var S = e.rects.reference;
      var C = e.rects.popper;
      var E = typeof v === 'function' ? v(Object.assign({}, e.rects, { placement: e.placement })) : v;
      var P = typeof E === 'number' ? { mainAxis: E, altAxis: E } : Object.assign({ mainAxis: 0, altAxis: 0 }, E);
      var A = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null;
      var D = { x: 0, y: 0 };
      if (!x) return;
      if (r) {
        var L;
        var O = b === 'y' ? Ue : Ge;
        var I = b === 'y' ? qe : Xe;
        var T = b === 'y' ? 'height' : 'width';
        var z = x[b];
        var M = z + m[O];
        var k = z - m[I];
        var F = p ? -C[T] / 2 : 0;
        var R = y === Ke ? S[T] : C[T];
        var N = y === Ke ? -C[T] : -S[T];
        var Z = e.elements.arrow;
        var B = p && Z ? Re(Z) : { width: 0, height: 0 };
        var W = e.modifiersData['arrow#persistent'] ? e.modifiersData['arrow#persistent'].padding : en();
        var H = W[O];
        var j = W[I];
        var V = dn(0, S[T], B[T]);
        var U = w ? S[T] / 2 - F - V - H - P.mainAxis : R - V - H - P.mainAxis;
        var q = w ? -S[T] / 2 + F + V + j + P.mainAxis : N + V + j + P.mainAxis;
        var X = e.elements.arrow && Ve(e.elements.arrow);
        var G = X ? (b === 'y' ? X.clientTop || 0 : X.clientLeft || 0) : 0;
        var $ = (L = A == null ? void 0 : A[b]) != null ? L : 0;
        var Y = z + U - $ - G;
        var K = z + q - $;
        var Q = dn(p ? xe(M, Y) : M, z, p ? _e(k, K) : k);
        x[b] = Q;
        D[b] = Q - z;
      }
      if (a) {
        var J;
        var tt = b === 'x' ? Ue : Ge;
        var et = b === 'x' ? qe : Xe;
        var it = x[_];
        var nt = _ === 'y' ? 'height' : 'width';
        var st = it + m[tt];
        var rt = it - m[et];
        var ot = [Ue, Ge].indexOf(g) !== -1;
        var at = (J = A == null ? void 0 : A[_]) != null ? J : 0;
        var lt = ot ? st : it - S[nt] - C[nt] - at + P.altAxis;
        var ht = ot ? it + S[nt] + C[nt] - at - P.altAxis : rt;
        var ct = p && ot ? un(lt, it, ht) : dn(p ? lt : st, it, p ? ht : rt);
        x[_] = ct;
        D[_] = ct - it;
      }
      e.modifiersData[n] = D;
    }
    const fn = {
      name: 'preventOverflow',
      enabled: true,
      phase: 'main',
      fn: pn,
      requiresIfExists: ['offset'],
    };
    var vn = function t(e, i) {
      e = typeof e === 'function' ? e(Object.assign({}, i.rects, { placement: i.placement })) : e;
      return nn(typeof e !== 'number' ? e : sn(e, Ye));
    };
    function mn(t) {
      var e;
      var i = t.state,
        n = t.name,
        s = t.options;
      var r = i.elements.arrow;
      var o = i.modifiersData.popperOffsets;
      var a = Pi(i.placement);
      var l = Di(a);
      var h = [Ge, Xe].indexOf(a) >= 0;
      var c = h ? 'height' : 'width';
      if (!r || !o) return;
      var d = vn(s.padding, i);
      var u = Re(r);
      var p = l === 'y' ? Ue : Ge;
      var f = l === 'y' ? qe : Xe;
      var v = i.rects.reference[c] + i.rects.reference[l] - o[l] - i.rects.popper[c];
      var m = o[l] - i.rects.reference[l];
      var g = Ve(r);
      var y = g ? (l === 'y' ? g.clientHeight || 0 : g.clientWidth || 0) : 0;
      var w = v / 2 - m / 2;
      var b = d[p];
      var _ = y - u[c] - d[f];
      var x = y / 2 - u[c] / 2 + w;
      var S = dn(b, x, _);
      var C = l;
      i.modifiersData[n] = ((e = {}), (e[C] = S), (e.centerOffset = S - x), e);
    }
    function gn(t) {
      var e = t.state,
        i = t.options;
      var n = i.element,
        s = n === void 0 ? '[data-popper-arrow]' : n;
      if (s == null) return;
      if (typeof s === 'string') {
        s = e.elements.popper.querySelector(s);
        if (!s) return;
      }
      if (!$i(e.elements.popper, s)) return;
      e.elements.arrow = s;
    }
    const yn = {
      name: 'arrow',
      enabled: true,
      phase: 'main',
      fn: mn,
      effect: gn,
      requires: ['popperOffsets'],
      requiresIfExists: ['preventOverflow'],
    };
    function wn(t, e, i) {
      if (i === void 0) i = { x: 0, y: 0 };
      return {
        top: t.top - e.height - i.y,
        right: t.right - e.width + i.x,
        bottom: t.bottom - e.height + i.y,
        left: t.left - e.width - i.x,
      };
    }
    function bn(t) {
      return [Ue, Xe, qe, Ge].some(function (e) {
        return t[e] >= 0;
      });
    }
    function _n(t) {
      var e = t.state,
        i = t.name;
      var n = e.rects.reference;
      var s = e.rects.popper;
      var r = e.modifiersData.preventOverflow;
      var o = rn(e, { elementContext: 'reference' });
      var a = rn(e, { altBoundary: true });
      var l = wn(o, n);
      var h = wn(a, s, r);
      var c = bn(l);
      var d = bn(h);
      e.modifiersData[i] = {
        referenceClippingOffsets: l,
        popperEscapeOffsets: h,
        isReferenceHidden: c,
        hasPopperEscaped: d,
      };
      e.attributes.popper = Object.assign({}, e.attributes.popper, {
        'data-popper-reference-hidden': c,
        'data-popper-escaped': d,
      });
    }
    const xn = {
      name: 'hide',
      enabled: true,
      phase: 'main',
      requiresIfExists: ['preventOverflow'],
      fn: _n,
    };
    var Sn = [Ei, Ii, Fi, Zi, Hi, hn, fn, yn, xn];
    var Cn = _i({ defaultModifiers: Sn });
    var En =
      '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
    var Pn = 'tippy-box';
    var An = 'tippy-content';
    var Dn = 'tippy-backdrop';
    var Ln = 'tippy-arrow';
    var On = 'tippy-svg-arrow';
    var In = { passive: true, capture: true };
    var Tn = function t() {
      return document.body;
    };
    function zn(t, e) {
      return {}.hasOwnProperty.call(t, e);
    }
    function Mn(t, e, i) {
      if (Array.isArray(t)) {
        var n = t[e];
        return n == null ? (Array.isArray(i) ? i[e] : i) : n;
      }
      return t;
    }
    function kn(t, e) {
      var i = {}.toString.call(t);
      return i.indexOf('[object') === 0 && i.indexOf(e + ']') > -1;
    }
    function Fn(t, e) {
      return typeof t === 'function' ? t.apply(void 0, e) : t;
    }
    function Rn(t, e) {
      if (e === 0) return t;
      var i;
      return function (n) {
        clearTimeout(i);
        i = setTimeout(function () {
          t(n);
        }, e);
      };
    }
    function Nn(t, e) {
      var i = Object.assign({}, t);
      e.forEach(function (t) {
        delete i[t];
      });
      return i;
    }
    function Zn(t) {
      return t.split(/\s+/).filter(Boolean);
    }
    function Bn(t) {
      return [].concat(t);
    }
    function Wn(t, e) {
      if (t.indexOf(e) === -1) t.push(e);
    }
    function Hn(t) {
      return t.filter(function (e, i) {
        return t.indexOf(e) === i;
      });
    }
    function jn(t) {
      return t.split('-')[0];
    }
    function Vn(t) {
      return [].slice.call(t);
    }
    function Un(t) {
      return Object.keys(t).reduce(function (e, i) {
        if (t[i] !== void 0) e[i] = t[i];
        return e;
      }, {});
    }
    function qn() {
      return document.createElement('div');
    }
    function Xn(t) {
      return ['Element', 'Fragment'].some(function (e) {
        return kn(t, e);
      });
    }
    function Gn(t) {
      return kn(t, 'NodeList');
    }
    function $n(t) {
      return kn(t, 'MouseEvent');
    }
    function Yn(t) {
      return !!(t && t._tippy && t._tippy.reference === t);
    }
    function Kn(t) {
      if (Xn(t)) return [t];
      if (Gn(t)) return Vn(t);
      if (Array.isArray(t)) return t;
      return Vn(document.querySelectorAll(t));
    }
    function Qn(t, e) {
      t.forEach(function (t) {
        if (t) t.style.transitionDuration = e + 'ms';
      });
    }
    function Jn(t, e) {
      t.forEach(function (t) {
        if (t) t.setAttribute('data-state', e);
      });
    }
    function ts(t) {
      var e;
      var i = Bn(t),
        n = i[0];
      return n != null && (e = n.ownerDocument) != null && e.body ? n.ownerDocument : document;
    }
    function es(t, e) {
      var i = e.clientX,
        n = e.clientY;
      return t.every(function (t) {
        var e = t.popperRect,
          s = t.popperState,
          r = t.props;
        var o = r.interactiveBorder;
        var a = jn(s.placement);
        var l = s.modifiersData.offset;
        if (!l) return true;
        var h = a === 'bottom' ? l.top.y : 0;
        var c = a === 'top' ? l.bottom.y : 0;
        var d = a === 'right' ? l.left.x : 0;
        var u = a === 'left' ? l.right.x : 0;
        var p = e.top - n + h > o;
        var f = n - e.bottom - c > o;
        var v = e.left - i + d > o;
        var m = i - e.right - u > o;
        return p || f || v || m;
      });
    }
    function is(t, e, i) {
      var n = e + 'EventListener';
      ['transitionend', 'webkitTransitionEnd'].forEach(function (e) {
        t[n](e, i);
      });
    }
    function ns(t, e) {
      var i = e;
      while (i) {
        var n;
        if (t.contains(i)) return true;
        i = i.getRootNode == null ? void 0 : (n = i.getRootNode()) == null ? void 0 : n.host;
      }
      return false;
    }
    var ss = { isTouch: false };
    var rs = 0;
    function os() {
      if (ss.isTouch) return;
      ss.isTouch = true;
      if (window.performance) document.addEventListener('mousemove', as);
    }
    function as() {
      var t = performance.now();
      if (t - rs < 20) {
        ss.isTouch = false;
        document.removeEventListener('mousemove', as);
      }
      rs = t;
    }
    function ls() {
      var t = document.activeElement;
      if (Yn(t)) {
        var e = t._tippy;
        if (t.blur && !e.state.isVisible) t.blur();
      }
    }
    function hs() {
      document.addEventListener('touchstart', os, In);
      window.addEventListener('blur', ls);
    }
    var cs = typeof window !== 'undefined' && typeof document !== 'undefined';
    var ds = cs ? !!window.msCrypto : false;
    function us(t) {
      var e = t === 'destroy' ? 'n already-' : ' ';
      return [
        t + '() was called on a' + e + 'destroyed instance. This is a no-op but',
        'indicates a potential memory leak.',
      ].join(' ');
    }
    function ps(t) {
      var e = /[ \t]{2,}/g;
      var i = /^[ \t]*/gm;
      return t.replace(e, ' ').replace(i, '').trim();
    }
    function fs(t) {
      return ps(
        '\n  %ctippy.js\n\n  %c' +
          ps(t) +
          '\n\n  %c👷‍ This is a development-only message. It will be removed in production.\n  '
      );
    }
    function vs(t) {
      return [fs(t), 'color: #00C584; font-size: 1.3em; font-weight: bold;', 'line-height: 1.5', 'color: #a6a095;'];
    }
    var ms;
    if (false);
    function gs() {
      ms = new Set();
    }
    function ys(t, e) {
      if (t && !ms.has(e)) {
        var i;
        ms.add(e);
        (i = console).warn.apply(i, vs(e));
      }
    }
    function ws(t, e) {
      if (t && !ms.has(e)) {
        var i;
        ms.add(e);
        (i = console).error.apply(i, vs(e));
      }
    }
    function bs(t) {
      var e = !t;
      var i = Object.prototype.toString.call(t) === '[object Object]' && !t.addEventListener;
      ws(
        e,
        [
          'tippy() was passed',
          '`' + String(t) + '`',
          'as its targets (first) argument. Valid types are: String, Element,',
          'Element[], or NodeList.',
        ].join(' ')
      );
      ws(
        i,
        [
          'tippy() was passed a plain object which is not supported as an argument',
          'for virtual positioning. Use props.getReferenceClientRect instead.',
        ].join(' ')
      );
    }
    var _s = {
      animateFill: false,
      followCursor: false,
      inlinePositioning: false,
      sticky: false,
    };
    var xs = {
      allowHTML: false,
      animation: 'fade',
      arrow: true,
      content: '',
      inertia: false,
      maxWidth: 350,
      role: 'tooltip',
      theme: '',
      zIndex: 9999,
    };
    var Ss = Object.assign(
      {
        appendTo: Tn,
        aria: { content: 'auto', expanded: 'auto' },
        delay: 0,
        duration: [300, 250],
        getReferenceClientRect: null,
        hideOnClick: true,
        ignoreAttributes: false,
        interactive: false,
        interactiveBorder: 2,
        interactiveDebounce: 0,
        moveTransition: '',
        offset: [0, 10],
        onAfterUpdate: function t() {},
        onBeforeUpdate: function t() {},
        onCreate: function t() {},
        onDestroy: function t() {},
        onHidden: function t() {},
        onHide: function t() {},
        onMount: function t() {},
        onShow: function t() {},
        onShown: function t() {},
        onTrigger: function t() {},
        onUntrigger: function t() {},
        onClickOutside: function t() {},
        placement: 'top',
        plugins: [],
        popperOptions: {},
        render: null,
        showOnCreate: false,
        touch: true,
        trigger: 'mouseenter focus',
        triggerTarget: null,
      },
      _s,
      xs
    );
    var Cs = Object.keys(Ss);
    var Es = function t(e) {
      if (false);
      var i = Object.keys(e);
      i.forEach(function (t) {
        Ss[t] = e[t];
      });
    };
    function Ps(t) {
      var e = t.plugins || [];
      var i = e.reduce(function (e, i) {
        var n = i.name,
          s = i.defaultValue;
        if (n) {
          var r;
          e[n] = t[n] !== void 0 ? t[n] : (r = Ss[n]) != null ? r : s;
        }
        return e;
      }, {});
      return Object.assign({}, t, i);
    }
    function As(t, e) {
      var i = e ? Object.keys(Ps(Object.assign({}, Ss, { plugins: e }))) : Cs;
      var n = i.reduce(function (e, i) {
        var n = (t.getAttribute('data-tippy-' + i) || '').trim();
        if (!n) return e;
        if (i === 'content') e[i] = n;
        else
          try {
            e[i] = JSON.parse(n);
          } catch (t) {
            e[i] = n;
          }
        return e;
      }, {});
      return n;
    }
    function Ds(t, e) {
      var i = Object.assign({}, e, { content: Fn(e.content, [t]) }, e.ignoreAttributes ? {} : As(t, e.plugins));
      i.aria = Object.assign({}, Ss.aria, i.aria);
      i.aria = {
        expanded: i.aria.expanded === 'auto' ? e.interactive : i.aria.expanded,
        content: i.aria.content === 'auto' ? (e.interactive ? null : 'describedby') : i.aria.content,
      };
      return i;
    }
    function Ls(t, e) {
      if (t === void 0) t = {};
      if (e === void 0) e = [];
      var i = Object.keys(t);
      i.forEach(function (t) {
        var i = Nn(Ss, Object.keys(_s));
        var n = !zn(i, t);
        if (n)
          n =
            e.filter(function (e) {
              return e.name === t;
            }).length === 0;
        ys(
          n,
          [
            '`' + t + '`',
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/',
          ].join(' ')
        );
      });
    }
    var Os = function t() {
      return 'innerHTML';
    };
    function Is(t, e) {
      t[Os()] = e;
    }
    function Ts(t) {
      var e = qn();
      if (t === true) e.className = Ln;
      else {
        e.className = On;
        if (Xn(t)) e.appendChild(t);
        else Is(e, t);
      }
      return e;
    }
    function zs(t, e) {
      if (Xn(e.content)) {
        Is(t, '');
        t.appendChild(e.content);
      } else if (typeof e.content !== 'function')
        if (e.allowHTML) Is(t, e.content);
        else t.textContent = e.content;
    }
    function Ms(t) {
      var e = t.firstElementChild;
      var i = Vn(e.children);
      return {
        box: e,
        content: i.find(function (t) {
          return t.classList.contains(An);
        }),
        arrow: i.find(function (t) {
          return t.classList.contains(Ln) || t.classList.contains(On);
        }),
        backdrop: i.find(function (t) {
          return t.classList.contains(Dn);
        }),
      };
    }
    function ks(t) {
      var e = qn();
      var i = qn();
      i.className = Pn;
      i.setAttribute('data-state', 'hidden');
      i.setAttribute('tabindex', '-1');
      var n = qn();
      n.className = An;
      n.setAttribute('data-state', 'hidden');
      zs(n, t.props);
      e.appendChild(i);
      i.appendChild(n);
      s(t.props, t.props);
      function s(i, n) {
        var s = Ms(e),
          r = s.box,
          o = s.content,
          a = s.arrow;
        if (n.theme) r.setAttribute('data-theme', n.theme);
        else r.removeAttribute('data-theme');
        if (typeof n.animation === 'string') r.setAttribute('data-animation', n.animation);
        else r.removeAttribute('data-animation');
        if (n.inertia) r.setAttribute('data-inertia', '');
        else r.removeAttribute('data-inertia');
        r.style.maxWidth = typeof n.maxWidth === 'number' ? n.maxWidth + 'px' : n.maxWidth;
        if (n.role) r.setAttribute('role', n.role);
        else r.removeAttribute('role');
        if (i.content !== n.content || i.allowHTML !== n.allowHTML) zs(o, t.props);
        if (n.arrow) {
          if (!a) r.appendChild(Ts(n.arrow));
          else if (i.arrow !== n.arrow) {
            r.removeChild(a);
            r.appendChild(Ts(n.arrow));
          }
        } else if (a) r.removeChild(a);
      }
      return { popper: e, onUpdate: s };
    }
    ks.$$tippy = true;
    var Fs = 1;
    var Rs = [];
    var Ns = [];
    function Zs(t, e) {
      var i = Ds(t, Object.assign({}, Ss, Ps(Un(e))));
      var n;
      var s;
      var r;
      var o = false;
      var a = false;
      var l = false;
      var h = false;
      var c;
      var d;
      var u;
      var p = [];
      var f = Rn(Y, i.interactiveDebounce);
      var v;
      var m = Fs++;
      var g = null;
      var y = Hn(i.plugins);
      var w = {
        isEnabled: true,
        isVisible: false,
        isDestroyed: false,
        isMounted: false,
        isShown: false,
      };
      var b = {
        id: m,
        reference: t,
        popper: qn(),
        popperInstance: g,
        props: i,
        state: w,
        plugins: y,
        clearDelayTimeouts: lt,
        setProps: ht,
        setContent: ct,
        show: dt,
        hide: ut,
        hideWithInteractivity: pt,
        enable: ot,
        disable: at,
        unmount: ft,
        destroy: vt,
      };
      if (!i.render) {
        if (false);
        return b;
      }
      var _ = i.render(b),
        x = _.popper,
        S = _.onUpdate;
      x.setAttribute('data-tippy-root', '');
      x.id = 'tippy-' + b.id;
      b.popper = x;
      t._tippy = b;
      x._tippy = b;
      var C = y.map(function (t) {
        return t.fn(b);
      });
      var E = t.hasAttribute('aria-expanded');
      X();
      F();
      z();
      M('onCreate', [b]);
      if (i.showOnCreate) st();
      x.addEventListener('mouseenter', function () {
        if (b.props.interactive && b.state.isVisible) b.clearDelayTimeouts();
      });
      x.addEventListener('mouseleave', function () {
        if (b.props.interactive && b.props.trigger.indexOf('mouseenter') >= 0) O().addEventListener('mousemove', f);
      });
      return b;
      function P() {
        var t = b.props.touch;
        return Array.isArray(t) ? t : [t, 0];
      }
      function A() {
        return P()[0] === 'hold';
      }
      function D() {
        var t;
        return !!((t = b.props.render) != null && t.$$tippy);
      }
      function L() {
        return v || t;
      }
      function O() {
        var t = L().parentNode;
        return t ? ts(t) : document;
      }
      function I() {
        return Ms(x);
      }
      function T(t) {
        if ((b.state.isMounted && !b.state.isVisible) || ss.isTouch || (c && c.type === 'focus')) return 0;
        return Mn(b.props.delay, t ? 0 : 1, Ss.delay);
      }
      function z(t) {
        if (t === void 0) t = false;
        x.style.pointerEvents = b.props.interactive && !t ? '' : 'none';
        x.style.zIndex = '' + b.props.zIndex;
      }
      function M(t, e, i) {
        if (i === void 0) i = true;
        C.forEach(function (i) {
          if (i[t]) i[t].apply(i, e);
        });
        if (i) {
          var n;
          (n = b.props)[t].apply(n, e);
        }
      }
      function k() {
        var e = b.props.aria;
        if (!e.content) return;
        var i = 'aria-' + e.content;
        var n = x.id;
        var s = Bn(b.props.triggerTarget || t);
        s.forEach(function (t) {
          var e = t.getAttribute(i);
          if (b.state.isVisible) t.setAttribute(i, e ? e + ' ' + n : n);
          else {
            var s = e && e.replace(n, '').trim();
            if (s) t.setAttribute(i, s);
            else t.removeAttribute(i);
          }
        });
      }
      function F() {
        if (E || !b.props.aria.expanded) return;
        var e = Bn(b.props.triggerTarget || t);
        e.forEach(function (t) {
          if (b.props.interactive) t.setAttribute('aria-expanded', b.state.isVisible && t === L() ? 'true' : 'false');
          else t.removeAttribute('aria-expanded');
        });
      }
      function R() {
        O().removeEventListener('mousemove', f);
        Rs = Rs.filter(function (t) {
          return t !== f;
        });
      }
      function N(e) {
        if (ss.isTouch) if (l || e.type === 'mousedown') return;
        var i = (e.composedPath && e.composedPath()[0]) || e.target;
        if (b.props.interactive && ns(x, i)) return;
        if (
          Bn(b.props.triggerTarget || t).some(function (t) {
            return ns(t, i);
          })
        ) {
          if (ss.isTouch) return;
          if (b.state.isVisible && b.props.trigger.indexOf('click') >= 0) return;
        } else M('onClickOutside', [b, e]);
        if (b.props.hideOnClick === true) {
          b.clearDelayTimeouts();
          b.hide();
          a = true;
          setTimeout(function () {
            a = false;
          });
          if (!b.state.isMounted) H();
        }
      }
      function Z() {
        l = true;
      }
      function B() {
        l = false;
      }
      function W() {
        var t = O();
        t.addEventListener('mousedown', N, true);
        t.addEventListener('touchend', N, In);
        t.addEventListener('touchstart', B, In);
        t.addEventListener('touchmove', Z, In);
      }
      function H() {
        var t = O();
        t.removeEventListener('mousedown', N, true);
        t.removeEventListener('touchend', N, In);
        t.removeEventListener('touchstart', B, In);
        t.removeEventListener('touchmove', Z, In);
      }
      function j(t, e) {
        U(t, function () {
          if (!b.state.isVisible && x.parentNode && x.parentNode.contains(x)) e();
        });
      }
      function V(t, e) {
        U(t, e);
      }
      function U(t, e) {
        var i = I().box;
        function n(t) {
          if (t.target === i) {
            is(i, 'remove', n);
            e();
          }
        }
        if (t === 0) return e();
        is(i, 'remove', d);
        is(i, 'add', n);
        d = n;
      }
      function q(e, i, n) {
        if (n === void 0) n = false;
        var s = Bn(b.props.triggerTarget || t);
        s.forEach(function (t) {
          t.addEventListener(e, i, n);
          p.push({ node: t, eventType: e, handler: i, options: n });
        });
      }
      function X() {
        if (A()) {
          q('touchstart', $, { passive: true });
          q('touchend', K, { passive: true });
        }
        Zn(b.props.trigger).forEach(function (t) {
          if (t === 'manual') return;
          q(t, $);
          switch (t) {
            case 'mouseenter':
              q('mouseleave', K);
              break;
            case 'focus':
              q(ds ? 'focusout' : 'blur', Q);
              break;
            case 'focusin':
              q('focusout', Q);
              break;
          }
        });
      }
      function G() {
        p.forEach(function (t) {
          var e = t.node,
            i = t.eventType,
            n = t.handler,
            s = t.options;
          e.removeEventListener(i, n, s);
        });
        p = [];
      }
      function $(t) {
        var e;
        var i = false;
        if (!b.state.isEnabled || J(t) || a) return;
        var n = ((e = c) == null ? void 0 : e.type) === 'focus';
        c = t;
        v = t.currentTarget;
        F();
        if (!b.state.isVisible && $n(t))
          Rs.forEach(function (e) {
            return e(t);
          });
        if (
          t.type === 'click' &&
          (b.props.trigger.indexOf('mouseenter') < 0 || o) &&
          b.props.hideOnClick !== false &&
          b.state.isVisible
        )
          i = true;
        else st(t);
        if (t.type === 'click') o = !i;
        if (i && !n) rt(t);
      }
      function Y(t) {
        var e = t.target;
        var n = L().contains(e) || x.contains(e);
        if (t.type === 'mousemove' && n) return;
        var s = nt()
          .concat(x)
          .map(function (t) {
            var e;
            var n = t._tippy;
            var s = (e = n.popperInstance) == null ? void 0 : e.state;
            if (s)
              return {
                popperRect: t.getBoundingClientRect(),
                popperState: s,
                props: i,
              };
            return null;
          })
          .filter(Boolean);
        if (es(s, t)) {
          R();
          rt(t);
        }
      }
      function K(t) {
        var e = J(t) || (b.props.trigger.indexOf('click') >= 0 && o);
        if (e) return;
        if (b.props.interactive) {
          b.hideWithInteractivity(t);
          return;
        }
        rt(t);
      }
      function Q(t) {
        if (b.props.trigger.indexOf('focusin') < 0 && t.target !== L()) return;
        if (b.props.interactive && t.relatedTarget && x.contains(t.relatedTarget)) return;
        rt(t);
      }
      function J(t) {
        return ss.isTouch ? A() !== t.type.indexOf('touch') >= 0 : false;
      }
      function tt() {
        et();
        var e = b.props,
          i = e.popperOptions,
          n = e.placement,
          s = e.offset,
          r = e.getReferenceClientRect,
          o = e.moveTransition;
        var a = D() ? Ms(x).arrow : null;
        var l = r
          ? {
              getBoundingClientRect: r,
              contextElement: r.contextElement || L(),
            }
          : t;
        var h = {
          name: '$$tippy',
          enabled: true,
          phase: 'beforeWrite',
          requires: ['computeStyles'],
          fn: function t(e) {
            var i = e.state;
            if (D()) {
              var n = I(),
                s = n.box;
              ['placement', 'reference-hidden', 'escaped'].forEach(function (t) {
                if (t === 'placement') s.setAttribute('data-placement', i.placement);
                else if (i.attributes.popper['data-popper-' + t]) s.setAttribute('data-' + t, '');
                else s.removeAttribute('data-' + t);
              });
              i.attributes.popper = {};
            }
          },
        };
        var c = [
          { name: 'offset', options: { offset: s } },
          {
            name: 'preventOverflow',
            options: { padding: { top: 2, bottom: 2, left: 5, right: 5 } },
          },
          { name: 'flip', options: { padding: 5 } },
          { name: 'computeStyles', options: { adaptive: !o } },
          h,
        ];
        if (D() && a) c.push({ name: 'arrow', options: { element: a, padding: 3 } });
        c.push.apply(c, (i == null ? void 0 : i.modifiers) || []);
        b.popperInstance = Cn(l, x, Object.assign({}, i, { placement: n, onFirstUpdate: u, modifiers: c }));
      }
      function et() {
        if (b.popperInstance) {
          b.popperInstance.destroy();
          b.popperInstance = null;
        }
      }
      function it() {
        var t = b.props.appendTo;
        var e;
        var i = L();
        if ((b.props.interactive && t === Tn) || t === 'parent') e = i.parentNode;
        else e = Fn(t, [i]);
        if (!e.contains(x)) e.appendChild(x);
        b.state.isMounted = true;
        tt();
        if (false);
      }
      function nt() {
        return Vn(x.querySelectorAll('[data-tippy-root]'));
      }
      function st(t) {
        b.clearDelayTimeouts();
        if (t) M('onTrigger', [b, t]);
        W();
        var e = T(true);
        var i = P(),
          s = i[0],
          r = i[1];
        if (ss.isTouch && s === 'hold' && r) e = r;
        if (e)
          n = setTimeout(function () {
            b.show();
          }, e);
        else b.show();
      }
      function rt(t) {
        b.clearDelayTimeouts();
        M('onUntrigger', [b, t]);
        if (!b.state.isVisible) {
          H();
          return;
        }
        if (
          b.props.trigger.indexOf('mouseenter') >= 0 &&
          b.props.trigger.indexOf('click') >= 0 &&
          ['mouseleave', 'mousemove'].indexOf(t.type) >= 0 &&
          o
        )
          return;
        var e = T(false);
        if (e)
          s = setTimeout(function () {
            if (b.state.isVisible) b.hide();
          }, e);
        else
          r = requestAnimationFrame(function () {
            b.hide();
          });
      }
      function ot() {
        b.state.isEnabled = true;
      }
      function at() {
        b.hide();
        b.state.isEnabled = false;
      }
      function lt() {
        clearTimeout(n);
        clearTimeout(s);
        cancelAnimationFrame(r);
      }
      function ht(e) {
        if (false);
        if (b.state.isDestroyed) return;
        M('onBeforeUpdate', [b, e]);
        G();
        var i = b.props;
        var n = Ds(t, Object.assign({}, i, Un(e), { ignoreAttributes: true }));
        b.props = n;
        X();
        if (i.interactiveDebounce !== n.interactiveDebounce) {
          R();
          f = Rn(Y, n.interactiveDebounce);
        }
        if (i.triggerTarget && !n.triggerTarget)
          Bn(i.triggerTarget).forEach(function (t) {
            t.removeAttribute('aria-expanded');
          });
        else if (n.triggerTarget) t.removeAttribute('aria-expanded');
        F();
        z();
        if (S) S(i, n);
        if (b.popperInstance) {
          tt();
          nt().forEach(function (t) {
            requestAnimationFrame(t._tippy.popperInstance.forceUpdate);
          });
        }
        M('onAfterUpdate', [b, e]);
      }
      function ct(t) {
        b.setProps({ content: t });
      }
      function dt() {
        if (false);
        var t = b.state.isVisible;
        var e = b.state.isDestroyed;
        var i = !b.state.isEnabled;
        var n = ss.isTouch && !b.props.touch;
        var s = Mn(b.props.duration, 0, Ss.duration);
        if (t || e || i || n) return;
        if (L().hasAttribute('disabled')) return;
        M('onShow', [b], false);
        if (b.props.onShow(b) === false) return;
        b.state.isVisible = true;
        if (D()) x.style.visibility = 'visible';
        z();
        W();
        if (!b.state.isMounted) x.style.transition = 'none';
        if (D()) {
          var r = I(),
            o = r.box,
            a = r.content;
          Qn([o, a], 0);
        }
        u = function t() {
          var e;
          if (!b.state.isVisible || h) return;
          h = true;
          void x.offsetHeight;
          x.style.transition = b.props.moveTransition;
          if (D() && b.props.animation) {
            var i = I(),
              n = i.box,
              r = i.content;
            Qn([n, r], s);
            Jn([n, r], 'visible');
          }
          k();
          F();
          Wn(Ns, b);
          (e = b.popperInstance) == null ? void 0 : e.forceUpdate();
          M('onMount', [b]);
          if (b.props.animation && D())
            V(s, function () {
              b.state.isShown = true;
              M('onShown', [b]);
            });
        };
        it();
      }
      function ut() {
        if (false);
        var t = !b.state.isVisible;
        var e = b.state.isDestroyed;
        var i = !b.state.isEnabled;
        var n = Mn(b.props.duration, 1, Ss.duration);
        if (t || e || i) return;
        M('onHide', [b], false);
        if (b.props.onHide(b) === false) return;
        b.state.isVisible = false;
        b.state.isShown = false;
        h = false;
        o = false;
        if (D()) x.style.visibility = 'hidden';
        R();
        H();
        z(true);
        if (D()) {
          var s = I(),
            r = s.box,
            a = s.content;
          if (b.props.animation) {
            Qn([r, a], n);
            Jn([r, a], 'hidden');
          }
        }
        k();
        F();
        if (b.props.animation) {
          if (D()) j(n, b.unmount);
        } else b.unmount();
      }
      function pt(t) {
        if (false);
        O().addEventListener('mousemove', f);
        Wn(Rs, f);
        f(t);
      }
      function ft() {
        if (false);
        if (b.state.isVisible) b.hide();
        if (!b.state.isMounted) return;
        et();
        nt().forEach(function (t) {
          t._tippy.unmount();
        });
        if (x.parentNode) x.parentNode.removeChild(x);
        Ns = Ns.filter(function (t) {
          return t !== b;
        });
        b.state.isMounted = false;
        M('onHidden', [b]);
      }
      function vt() {
        if (false);
        if (b.state.isDestroyed) return;
        b.clearDelayTimeouts();
        b.unmount();
        G();
        delete t._tippy;
        b.state.isDestroyed = true;
        M('onDestroy', [b]);
      }
    }
    function Bs(t, e) {
      if (e === void 0) e = {};
      var i = Ss.plugins.concat(e.plugins || []);
      if (false);
      hs();
      var n = Object.assign({}, e, { plugins: i });
      var s = Kn(t);
      if (false) var r, o;
      var a = s.reduce(function (t, e) {
        var i = e && Zs(e, n);
        if (i) t.push(i);
        return t;
      }, []);
      return Xn(t) ? a[0] : a;
    }
    Bs.defaultProps = Ss;
    Bs.setDefaultProps = Es;
    Bs.currentInput = ss;
    var Ws = function t(e) {
      var i = e === void 0 ? {} : e,
        n = i.exclude,
        s = i.duration;
      Ns.forEach(function (t) {
        var e = false;
        if (n) e = Yn(n) ? t.reference === n : t.popper === n.popper;
        if (!e) {
          var i = t.props.duration;
          t.setProps({ duration: s });
          t.hide();
          if (!t.state.isDestroyed) t.setProps({ duration: i });
        }
      });
    };
    var Hs = Object.assign({}, Zi, {
      effect: function t(e) {
        var i = e.state;
        var n = {
          popper: {
            position: i.options.strategy,
            left: '0',
            top: '0',
            margin: '0',
          },
          arrow: { position: 'absolute' },
          reference: {},
        };
        Object.assign(i.elements.popper.style, n.popper);
        i.styles = n;
        if (i.elements.arrow) Object.assign(i.elements.arrow.style, n.arrow);
      },
    });
    var js = function t(e, i) {
      var n;
      if (i === void 0) i = {};
      if (false);
      var s = e;
      var r = [];
      var o = [];
      var a;
      var l = i.overrides;
      var h = [];
      var c = false;
      function d() {
        o = s
          .map(function (t) {
            return Bn(t.props.triggerTarget || t.reference);
          })
          .reduce(function (t, e) {
            return t.concat(e);
          }, []);
      }
      function u() {
        r = s.map(function (t) {
          return t.reference;
        });
      }
      function p(t) {
        s.forEach(function (e) {
          if (t) e.enable();
          else e.disable();
        });
      }
      function f(t) {
        return s.map(function (e) {
          var i = e.setProps;
          e.setProps = function (n) {
            i(n);
            if (e.reference === a) t.setProps(n);
          };
          return function () {
            e.setProps = i;
          };
        });
      }
      function v(t, e) {
        var i = o.indexOf(e);
        if (e === a) return;
        a = e;
        var n = (l || []).concat('content').reduce(function (t, e) {
          t[e] = s[i].props[e];
          return t;
        }, {});
        t.setProps(
          Object.assign({}, n, {
            getReferenceClientRect:
              typeof n.getReferenceClientRect === 'function'
                ? n.getReferenceClientRect
                : function () {
                    var t;
                    return (t = r[i]) == null ? void 0 : t.getBoundingClientRect();
                  },
          })
        );
      }
      p(false);
      u();
      d();
      var m = {
        fn: function t() {
          return {
            onDestroy: function t() {
              p(true);
            },
            onHidden: function t() {
              a = null;
            },
            onClickOutside: function t(e) {
              if (e.props.showOnCreate && !c) {
                c = true;
                a = null;
              }
            },
            onShow: function t(e) {
              if (e.props.showOnCreate && !c) {
                c = true;
                v(e, r[0]);
              }
            },
            onTrigger: function t(e, i) {
              v(e, i.currentTarget);
            },
          };
        },
      };
      var g = Bs(
        qn(),
        Object.assign({}, Nn(i, ['overrides']), {
          plugins: [m].concat(i.plugins || []),
          triggerTarget: o,
          popperOptions: Object.assign({}, i.popperOptions, {
            modifiers: [].concat(((n = i.popperOptions) == null ? void 0 : n.modifiers) || [], [Hs]),
          }),
        })
      );
      var y = g.show;
      g.show = function (t) {
        y();
        if (!a && t == null) return v(g, r[0]);
        if (a && t == null) return;
        if (typeof t === 'number') return r[t] && v(g, r[t]);
        if (s.indexOf(t) >= 0) {
          var e = t.reference;
          return v(g, e);
        }
        if (r.indexOf(t) >= 0) return v(g, t);
      };
      g.showNext = function () {
        var t = r[0];
        if (!a) return g.show(0);
        var e = r.indexOf(a);
        g.show(r[e + 1] || t);
      };
      g.showPrevious = function () {
        var t = r[r.length - 1];
        if (!a) return g.show(t);
        var e = r.indexOf(a);
        var i = r[e - 1] || t;
        g.show(i);
      };
      var w = g.setProps;
      g.setProps = function (t) {
        l = t.overrides || l;
        w(t);
      };
      g.setInstances = function (t) {
        p(true);
        h.forEach(function (t) {
          return t();
        });
        s = t;
        p(false);
        u();
        d();
        h = f(g);
        g.setProps({ triggerTarget: o });
      };
      h = f(g);
      return g;
    };
    var Vs = { mouseover: 'mouseenter', focusin: 'focus', click: 'click' };
    function Us(t, e) {
      if (false);
      var i = [];
      var n = [];
      var s = false;
      var r = e.target;
      var o = Nn(e, ['target']);
      var a = Object.assign({}, o, { trigger: 'manual', touch: false });
      var l = Object.assign({ touch: Ss.touch }, o, { showOnCreate: true });
      var h = Bs(t, a);
      var c = Bn(h);
      function d(t) {
        if (!t.target || s) return;
        var i = t.target.closest(r);
        if (!i) return;
        var o = i.getAttribute('data-tippy-trigger') || e.trigger || Ss.trigger;
        if (i._tippy) return;
        if (t.type === 'touchstart' && typeof l.touch === 'boolean') return;
        if (t.type !== 'touchstart' && o.indexOf(Vs[t.type]) < 0) return;
        var a = Bs(i, l);
        if (a) n = n.concat(a);
      }
      function u(t, e, n, s) {
        if (s === void 0) s = false;
        t.addEventListener(e, n, s);
        i.push({ node: t, eventType: e, handler: n, options: s });
      }
      function p(t) {
        var e = t.reference;
        u(e, 'touchstart', d, In);
        u(e, 'mouseover', d);
        u(e, 'focusin', d);
        u(e, 'click', d);
      }
      function f() {
        i.forEach(function (t) {
          var e = t.node,
            i = t.eventType,
            n = t.handler,
            s = t.options;
          e.removeEventListener(i, n, s);
        });
        i = [];
      }
      function v(t) {
        var e = t.destroy;
        var i = t.enable;
        var r = t.disable;
        t.destroy = function (t) {
          if (t === void 0) t = true;
          if (t)
            n.forEach(function (t) {
              t.destroy();
            });
          n = [];
          f();
          e();
        };
        t.enable = function () {
          i();
          n.forEach(function (t) {
            return t.enable();
          });
          s = false;
        };
        t.disable = function () {
          r();
          n.forEach(function (t) {
            return t.disable();
          });
          s = true;
        };
        p(t);
      }
      c.forEach(v);
      return h;
    }
    var qs = {
      name: 'animateFill',
      defaultValue: false,
      fn: function t(e) {
        var i;
        if (!((i = e.props.render) != null && i.$$tippy)) {
          if (false);
          return {};
        }
        var n = Ms(e.popper),
          s = n.box,
          r = n.content;
        var o = e.props.animateFill ? Xs() : null;
        return {
          onCreate: function t() {
            if (o) {
              s.insertBefore(o, s.firstElementChild);
              s.setAttribute('data-animatefill', '');
              s.style.overflow = 'hidden';
              e.setProps({ arrow: false, animation: 'shift-away' });
            }
          },
          onMount: function t() {
            if (o) {
              var e = s.style.transitionDuration;
              var i = Number(e.replace('ms', ''));
              r.style.transitionDelay = Math.round(i / 10) + 'ms';
              o.style.transitionDuration = e;
              Jn([o], 'visible');
            }
          },
          onShow: function t() {
            if (o) o.style.transitionDuration = '0ms';
          },
          onHide: function t() {
            if (o) Jn([o], 'hidden');
          },
        };
      },
    };
    function Xs() {
      var t = qn();
      t.className = Dn;
      Jn([t], 'hidden');
      return t;
    }
    var Gs = { clientX: 0, clientY: 0 };
    var $s = [];
    function Ys(t) {
      var e = t.clientX,
        i = t.clientY;
      Gs = { clientX: e, clientY: i };
    }
    function Ks(t) {
      t.addEventListener('mousemove', Ys);
    }
    function Qs(t) {
      t.removeEventListener('mousemove', Ys);
    }
    var Js = {
      name: 'followCursor',
      defaultValue: false,
      fn: function t(e) {
        var i = e.reference;
        var n = ts(e.props.triggerTarget || i);
        var s = false;
        var r = false;
        var o = true;
        var a = e.props;
        function l() {
          return e.props.followCursor === 'initial' && e.state.isVisible;
        }
        function h() {
          n.addEventListener('mousemove', u);
        }
        function c() {
          n.removeEventListener('mousemove', u);
        }
        function d() {
          s = true;
          e.setProps({ getReferenceClientRect: null });
          s = false;
        }
        function u(t) {
          var n = t.target ? i.contains(t.target) : true;
          var s = e.props.followCursor;
          var r = t.clientX,
            o = t.clientY;
          var a = i.getBoundingClientRect();
          var l = r - a.left;
          var h = o - a.top;
          if (n || !e.props.interactive)
            e.setProps({
              getReferenceClientRect: function t() {
                var e = i.getBoundingClientRect();
                var n = r;
                var a = o;
                if (s === 'initial') {
                  n = e.left + l;
                  a = e.top + h;
                }
                var c = s === 'horizontal' ? e.top : a;
                var d = s === 'vertical' ? e.right : n;
                var u = s === 'horizontal' ? e.bottom : a;
                var p = s === 'vertical' ? e.left : n;
                return {
                  width: d - p,
                  height: u - c,
                  top: c,
                  right: d,
                  bottom: u,
                  left: p,
                };
              },
            });
        }
        function p() {
          if (e.props.followCursor) {
            $s.push({ instance: e, doc: n });
            Ks(n);
          }
        }
        function f() {
          $s = $s.filter(function (t) {
            return t.instance !== e;
          });
          if (
            $s.filter(function (t) {
              return t.doc === n;
            }).length === 0
          )
            Qs(n);
        }
        return {
          onCreate: p,
          onDestroy: f,
          onBeforeUpdate: function t() {
            a = e.props;
          },
          onAfterUpdate: function t(i, n) {
            var o = n.followCursor;
            if (s) return;
            if (o !== void 0 && a.followCursor !== o) {
              f();
              if (o) {
                p();
                if (e.state.isMounted && !r && !l()) h();
              } else {
                c();
                d();
              }
            }
          },
          onMount: function t() {
            if (e.props.followCursor && !r) {
              if (o) {
                u(Gs);
                o = false;
              }
              if (!l()) h();
            }
          },
          onTrigger: function t(e, i) {
            if ($n(i)) Gs = { clientX: i.clientX, clientY: i.clientY };
            r = i.type === 'focus';
          },
          onHidden: function t() {
            if (e.props.followCursor) {
              d();
              c();
              o = true;
            }
          },
        };
      },
    };
    function tr(t, e) {
      var i;
      return {
        popperOptions: Object.assign({}, t.popperOptions, {
          modifiers: [].concat(
            (((i = t.popperOptions) == null ? void 0 : i.modifiers) || []).filter(function (t) {
              var i = t.name;
              return i !== e.name;
            }),
            [e]
          ),
        }),
      };
    }
    var er = {
      name: 'inlinePositioning',
      defaultValue: false,
      fn: function t(e) {
        var i = e.reference;
        function n() {
          return !!e.props.inlinePositioning;
        }
        var s;
        var r = -1;
        var o = false;
        var a = [];
        var l = {
          name: 'tippyInlinePositioning',
          enabled: true,
          phase: 'afterWrite',
          fn: function t(i) {
            var r = i.state;
            if (n()) {
              if (a.indexOf(r.placement) !== -1) a = [];
              if (s !== r.placement && a.indexOf(r.placement) === -1) {
                a.push(r.placement);
                e.setProps({
                  getReferenceClientRect: function t() {
                    return h(r.placement);
                  },
                });
              }
              s = r.placement;
            }
          },
        };
        function h(t) {
          return ir(jn(t), i.getBoundingClientRect(), Vn(i.getClientRects()), r);
        }
        function c(t) {
          o = true;
          e.setProps(t);
          o = false;
        }
        function d() {
          if (!o) c(tr(e.props, l));
        }
        return {
          onCreate: d,
          onAfterUpdate: d,
          onTrigger: function t(i, n) {
            if ($n(n)) {
              var s = Vn(e.reference.getClientRects());
              var o = s.find(function (t) {
                return (
                  t.left - 2 <= n.clientX &&
                  t.right + 2 >= n.clientX &&
                  t.top - 2 <= n.clientY &&
                  t.bottom + 2 >= n.clientY
                );
              });
              var a = s.indexOf(o);
              r = a > -1 ? a : r;
            }
          },
          onHidden: function t() {
            r = -1;
          },
        };
      },
    };
    function ir(t, e, i, n) {
      if (i.length < 2 || t === null) return e;
      if (i.length === 2 && n >= 0 && i[0].left > i[1].right) return i[n] || e;
      switch (t) {
        case 'top':
        case 'bottom':
          var s = i[0];
          var r = i[i.length - 1];
          var o = t === 'top';
          var a = s.top;
          var l = r.bottom;
          var h = o ? s.left : r.left;
          var c = o ? s.right : r.right;
          var d = c - h;
          var u = l - a;
          return { top: a, bottom: l, left: h, right: c, width: d, height: u };
        case 'left':
        case 'right':
          var p = Math.min.apply(
            Math,
            i.map(function (t) {
              return t.left;
            })
          );
          var f = Math.max.apply(
            Math,
            i.map(function (t) {
              return t.right;
            })
          );
          var v = i.filter(function (e) {
            return t === 'left' ? e.left === p : e.right === f;
          });
          var m = v[0].top;
          var g = v[v.length - 1].bottom;
          var y = p;
          var w = f;
          var b = w - y;
          var _ = g - m;
          return { top: m, bottom: g, left: y, right: w, width: b, height: _ };
        default:
          return e;
      }
    }
    var nr = {
      name: 'sticky',
      defaultValue: false,
      fn: function t(e) {
        var i = e.reference,
          n = e.popper;
        function s() {
          return e.popperInstance ? e.popperInstance.state.elements.reference : i;
        }
        function r(t) {
          return e.props.sticky === true || e.props.sticky === t;
        }
        var o = null;
        var a = null;
        function l() {
          var t = r('reference') ? s().getBoundingClientRect() : null;
          var i = r('popper') ? n.getBoundingClientRect() : null;
          if ((t && sr(o, t)) || (i && sr(a, i))) if (e.popperInstance) e.popperInstance.update();
          o = t;
          a = i;
          if (e.state.isMounted) requestAnimationFrame(l);
        }
        return {
          onMount: function t() {
            if (e.props.sticky) l();
          },
        };
      },
    };
    function sr(t, e) {
      if (t && e) return t.top !== e.top || t.right !== e.right || t.bottom !== e.bottom || t.left !== e.left;
      return true;
    }
    Bs.setDefaultProps({ render: ks });
    const rr = Bs;
    var or = i(691);
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme = {
      Flickity: s(),
      Slider: d,
      AnimateLoading: e(),
      Notification: new l(),
      ProductHelper: { getVariantFromOptionArray: v },
      Confetti: _,
      PhotoSwipe: $t,
      PhotoSwipeLightbox: me,
    };
    window.FoxThemeEvents = window.FoxThemeEvents || new h();
    window.FoxTheme.loadjs = __loadjs;
    window.FoxTheme.Tooltip = rr;
    window.addEventListener('load', function () {
      rr('[data-tippy-content]', {
        animation: 'shift-away',
        touch: false,
        onCreate(t) {
          const e = t.reference.dataset.tippyTheme || 'color-background-1';
          t.setProps({ theme: e });
        },
      });
    });
    (function t() {
      const { FoxThemeSettings: e } = window;
      try {
        e.colorSwatches = [];
        e.imageSwatches = [];
        e.custom_colors
          .split(',')
          .filter(Boolean)
          .forEach((t) => {
            const [i, n] = t.split(':');
            e.colorSwatches.push({
              key: i.trim().toLowerCase(),
              value: n?.trim?.() || '',
            });
          });
        Object.keys(e).forEach((t) => {
          if (t.includes('custom_image') && !t.includes('.png'))
            if (e[`${t}.png`])
              e.imageSwatches.push({
                key: e[t].toLowerCase(),
                value: e[`${t}.png`],
              });
        });
      } catch (t) {
        void 0;
      }
    })();
  })();
})();
